import { getAssetsUrl } from '.'
import { getIcon } from './icons'
import { MenuItemType } from './types'

export const mockArray = (mock: (index: number) => any, num: number) =>
  [...new Array(num).keys()].map((k) => mock(k + 1))
export const mockArrayGraphql = (mock: (index: number) => any, num: number) => ({
  edges: [...new Array(num).keys()].map((k) => ({ node: mock(k + 1) })),
})

export const imgUrl = (w, h = null) => `https://placehold.co/${w}x${h || w}/png`

export const descrizioneConCustomContent =
  '<p>Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. <a href="/">Lorem ipsum dolor</a> sit amet.</p>' +
  '<h3 class="heading3">Lorem ipsum dolor sit amet.</h3>' +
  '<p>Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet</p>' +
  '<p class="psmall">Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet</p>' +
  '<ul><li>elenco puntato default</li><li>elenco puntato default con righe che possono essere più di una per vedere cosa succede se si va a capo</li><li>elenco puntato default</li></ul>' +
  '<ul class="checks"><li>elenco puntato coi checks</li><li>elenco puntato coi checks</li><li>elenco puntato coi checks</li><li>elenco puntato coi checks</li></ul>' +
  '<p class="pcaption">caption finale per vedere come viene</p>'

export const menusMock: MenuItemType = {
  children: [
    {
      pk: 1,
      key: 'top',
      children: [
        {
          pk: 101,
          name: 'Magazine',
          url: '/',
        },
        {
          pk: 102,
          name: 'Download',
          url: '/',
        },
        {
          pk: 103,
          name: 'Contatti',
          url: '/',
        },
      ],
    },
    {
      pk: 2,
      key: 'main',
      children: [
        {
          pk: 201,
          name: 'Prodotti',
          ctaLabel: 'Trova il prodotto per te',
          url: '/prodotti/',
          key: 'prodotti',
          children: [
            {
              pk: 202,
              key: 'prodotti-main',
              children: [
                {
                  pk: 203,
                  name: 'Effetto',
                  children: [
                    { pk: 204, name: 'Legno', url: '/' },
                    { pk: 205, name: 'Marmo', url: '/' },
                    { pk: 206, name: 'Pietra', url: '/' },
                    { pk: 207, name: 'Tinta Unita', url: '/' },
                    { pk: 208, name: 'Terracotta', url: '/' },
                    { pk: 209, name: 'Metallo', url: '/' },
                    { pk: 210, name: 'Cemento', url: '/' },
                    { pk: 211, name: 'Majolica', url: '/' },
                    { pk: 212, name: 'Design', url: '/' },
                  ],
                },
                {
                  pk: 213,
                  name: 'Ambiente',
                  children: [
                    { pk: 214, name: 'Cucina', url: '/' },
                    { pk: 215, name: 'Esterni', url: '/' },
                    { pk: 216, name: 'Bagni', url: '/' },
                    { pk: 217, name: 'Pubblici', url: '/' },
                    { pk: 218, name: 'Living', url: '/' },
                    { pk: 219, name: 'Commerciale', url: '/' },
                    { pk: 220, name: 'Camera da letto', url: '/' },
                  ],
                },
                {
                  pk: 221,
                  name: 'Brand',
                  children: [
                    { pk: 222, name: 'Emilceramica', url: '/' },
                    { pk: 223, name: 'Ergon', url: '/' },
                    { pk: 224, name: 'Provenza', url: '/' },
                    { pk: 225, name: 'Viva', url: '/' },
                    { pk: 226, name: 'Level', url: '/' },
                  ],
                },
                {
                  pk: 227,
                  name: 'Formato',
                  children: [
                    { pk: 228, name: 'Piccolo (<= 30 cm)', url: '/' },
                    { pk: 229, name: 'Medio (30-90 cm)', url: '/' },
                    { pk: 230, name: 'Grande (90-120 cm)', url: '/' },
                    { pk: 231, name: 'Grande lastra (120x240 cm)', url: '/' },
                    { pk: 232, name: 'Countertop (160x320 cm)', url: '/' },
                  ],
                },
                {
                  pk: 233,
                  name: 'Colore',
                  style: 'colors',
                  children: [
                    { pk: 234, name: 'Nero', url: '/', style: '#000000' },
                    { pk: 235, name: 'Bianco', url: '/', style: '#FFFFFF' },
                    { pk: 236, name: 'Beige', url: '/', style: '#F5F5DC' },
                    { pk: 237, name: 'Taupe', url: '/', style: '#483C32' },
                    { pk: 238, name: 'Verde', url: '/', style: '#008000' },
                    { pk: 239, name: 'Marrone', url: '/', style: '#8B4513' },
                    { pk: 240, name: 'Giallo', url: '/', style: '#FFFF00' },
                    { pk: 241, name: 'Neutral', url: '/', style: '#D3D3D3' },
                    { pk: 242, name: 'Grigio', url: '/', style: '#808080' },
                    { pk: 243, name: 'Grigio chiaro', url: '/', style: '#D3D3D3' },
                    { pk: 244, name: 'Antracite', url: '/', style: '#2F2F2F' },
                    { pk: 245, name: 'Blu', url: '/', style: '#0000FF' },
                    { pk: 246, name: 'Rosa chiaro', url: '/', style: '#FFB6C1' },
                    { pk: 247, name: 'Azzurro chiaro', url: '/', style: '#ADD8E6' },
                    { pk: 248, name: 'Viola', url: '/', style: '#800080' },
                    { pk: 249, name: 'Rosso', url: '/', style: '#FF0000' },
                  ],
                },
              ],
            },
            {
              pk: 253,
              key: 'prodotti-evidenza',
              name: 'In evidenza',
              children: [
                {
                  pk: 254,
                  name: 'Nuove Collezioni',
                  image: 'https://placehold.co/85/png',
                  ctaLabel: 'Scopri',
                  url: '/',
                },
                {
                  pk: 255,
                  name: 'Antiscivolo soffice al tatto',
                  image: 'https://placehold.co/85/png',
                  ctaLabel: 'Scopri',
                  url: '/',
                },
              ],
            },
          ],
        },
        {
          pk: 256,
          name: 'Brand',
          children: [
            { pk: 257, name: 'Emilceramica', url: '/' },
            { pk: 258, name: 'Ergon', url: '/' },
            { pk: 259, name: 'Provenza', url: '/' },
            { pk: 260, name: 'Viva', url: '/' },
            { pk: 261, name: 'Level', url: '/' },
          ],
          ctaLabel: 'Tutti i brand',
          url: '/',
        },
        {
          pk: 262,
          name: 'Progetti',
        },
        {
          pk: 263,
          name: 'Soluzioni',
          ctaLabel: 'Tutte le soluzioni',
          url: '/',
          children: [
            { pk: 264, name: 'Pavimenti per interni', url: '/' },
            { pk: 265, name: 'Rivestimenti per interni', url: '/' },
            { pk: 266, name: 'Pavimenti per esterni', url: '/' },
            { pk: 267, name: 'Facciate ventilate', url: '/' },
            { pk: 268, name: 'Coutertop e Arredo', url: '/' },
            { pk: 269, name: 'Piastrelle per Paraschizzi', url: '/' },
          ],
        },
        {
          pk: 270,
          name: 'Azienda',
          children: [
            { pk: 271, name: 'Chi Siamo', url: '/' },
            { pk: 272, name: 'Responsabilità', url: '/' },
            { pk: 273, name: 'Sostenibilità', url: '/' },
            { pk: 274, name: 'Offerta chiave', url: '/' },
            { pk: 275, name: 'Tecnologie', url: '/' },
          ],
          ctaLabel: "Scopri l'azienda",
          url: '/',
        },
        {
          pk: 276,
          name: 'Sostenibilità',
          url: '/',
          ctaLabel: 'Sostenibilità',
          children: [
            { pk: 277, name: 'Certificazioni', url: '/' },
            { pk: 278, name: 'Sistema integrato', url: '/' },
            { pk: 279, name: 'Sostenibilità ambientale', url: '/' },
            { pk: 280, name: 'Sostenibilità sociale', url: '/' },
          ],
        },
      ],
    },
    {
      pk: 3,
      key: 'footer',
      children: [
        {
          pk: 30,
          children: [
            { pk: 301, name: 'Progetti', url: '/' },
            { pk: 302, name: 'Sostenibilità', url: '/' },
            { pk: 303, name: 'Azienda', url: '/' },
            { pk: 304, name: 'Trova Rivenditore', url: '/' },
            { pk: 305, name: 'Area Download', url: '/' },
            { pk: 306, name: 'Informazioni Societarie', url: '/' },
          ],
        },
        {
          pk: 31,
          children: [
            { pk: 311, name: 'Area Personale', url: '/' },
            { pk: 312, name: 'Contatti', url: '/' },
            { pk: 313, name: 'Privacy Policy', url: '/' },
            { pk: 314, name: 'Cookie Policy', url: '/' },
            { pk: 315, name: 'Centro Preferenze sulla privacy', url: '/' },
          ],
        },
      ],
    },
    {
      pk: 4,
      key: 'social',
      children: [
        { pk: 401, name: 'Pinterest', style: 'social_pinterest', url: '/' },
        { pk: 402, name: 'Instagram', style: 'social_instagram', url: '/' },
        { pk: 403, name: 'Facebook', style: 'social_facebook', url: '/' },
        { pk: 404, name: 'LinkedIn', style: 'social_linkedin', url: '/' },
        { pk: 405, name: 'YouTube', style: 'social_youtube', url: '/' },
        { pk: 406, name: 'TikTok', style: 'social_tik_tok', url: '/' },
      ],
    },
    {
      pk: 5,
      key: 'partecipazioni',
      name: 'Le nostre partecipazioni',
      children: [
        { pk: 501, name: 'Architronic', image: imgUrl(50, 80), url: '/' },
        { pk: 502, name: 'ArchiExpo', image: imgUrl(98, 50), url: '/' },
        { pk: 503, name: 'Archi Products', image: imgUrl(98, 80), url: '/' },
      ],
    },
    {
      pk: 6,
      key: 'prefooter',
      children: [
        {
          pk: 61,
          key: 'banners',
          children: [
            {
              pk: 611,
              image: imgUrl(800, 500),
              key: 'banner-contatti',
              name: 'Curiosità o domande?',
              description:
                '<p>Hai bisogno di delucidazioni sui prodotti Emilgroup? Scrivici per qualsiasi informazione, siamo a tua disposizione.</p>',
              ctaLabel: 'Contattaci',
              url: '/',
            },
            {
              pk: 612,
              image: imgUrl(800, 500),
              key: 'banner-rivenditore',
              name: 'Cerchi un rivenditore?',
              description:
                '<p>Cerca il rivenditore più vicino a te dove potrai acquistare i nostri prodotti e farti consigliare da esperti.</p>',
              ctaLabel: 'Trova lo store',
              url: '/',
            },
          ],
        },
        {
          pk: 62,
          key: 'banner-newsletter',
          name: 'Iscriviti alla Newsletter',
          description:
            '<p>Entra nel mondo Emilgroup e rimani sempre aggiornato sulle nuove collezioni, gli eventi e le più innovative soluzioni progettuali dell’abitare contemporaneo.</p>',
          ctaLabel: 'Iscriviti alla newsletter',
          image: imgUrl(1920, 980),
          url: '/',
        },
      ],
    },
    {
      pk: 7,
      key: 'ricerca',
      children: [
        {
          pk: 71,
          key: 'evidenza',
          name: 'In evidenza',
          children: [
            {
              pk: 711,
              name: 'Nuove collezioni',
              image: imgUrl(85),
              ctaLabel: 'Scopri',
              url: '/',
            },
            {
              pk: 712,
              name: 'Antiscivolo soffice al tatto',
              image: imgUrl(85),
              ctaLabel: 'Silktech',
              url: '/',
            },
          ],
        },
        {
          pk: 72,
          key: 'ricerca-collezioni',
          name: 'Le collezioni più viste',
          children: [
            { pk: 721, name: 'Tele di Marmo Lumia', url: '/' },
            { pk: 722, name: 'Unique Bourgogne', url: '/' },
            { pk: 723, name: 'Ever-Stone', url: '/' },
            { pk: 724, name: 'Matera Stone', url: '/' },
            { pk: 725, name: 'Varana Stone', url: '/' },
            { pk: 726, name: 'Playwood', url: '/' },
          ],
        },
      ],
    },
    // Elementi pagine
    {
      pk: 1000,
      key: 'pagina-homepage',
      children: [
        { pk: 10001, key: 'brands-slider', name: 'I brand del gruppo' },
        { pk: 10002, key: 'soluzioni-slider', name: 'Soluzioni' },
        {
          pk: 10002,
          key: 'collezioni-slider',
          name: 'Le nostre ultime collezioni',
          description:
            "<p>Un'ampia gamma di prodotti in gres porcellanato composta da oltre 70 collezioni combinabili in vari formati, colori e superfici per offrirti la massima libertà di progettazione in spazi residenziali e commerciali, garantendo innovazione e affidabilità senza pari.</p>",
          url: '/',
          ctaLabel: 'Vedi tutte le collezioni',
        },
        { pk: 10002, key: 'effetti-slider', name: 'Effetti per ogni ambiente e gusto estetico' },
        {
          pk: 10002,
          key: 'progetti-slider',
          name: 'Progetti',
          ctaLabel: 'Tutti i progetti',
          url: '/',
        },
        {
          pk: 10002,
          key: 'ispirazioni-slider',
          name: 'Ispirazioni',
          ctaLabel: 'Scopri tutte le ispirazioni',
          url: '/',
        },
        {
          pk: 10002,
          key: 'ergon-banner',
          logo: imgUrl(287, 76),
          image: imgUrl(820, 500),
          name: 'Designed in Italy,<br /><span>produced in US</span>',
          ctaLabel: 'Scopri le collezioni Ergon made in USA',
          url: '/',
        },
        {
          pk: 10002,
          key: 'quickship-banner',
          logo: imgUrl(76),
          image: imgUrl(820, 500),
          name: 'Quickship',
          description:
            '<p>Scopri tutte le nostre collezioni già presenti in territorio Americano e pronte per una spedizione veloce.</p>',
          url: '/',
          ctaLabel: 'Scopri le collezioni Quickship',
        },
      ],
    },
  ],
}

export const mockPagina = (index: number) => ({
  pk: index,
  titolo: 'Titolo pagina',
  nome: 'Nome pagina',
  previewImage: imgUrl(400), // TODO
  descrizione: '<p>Lorem ipsum dolor sit amet</p>',
  breadcrumbs: [{ label: 'Home', url: '/' }, { label: 'Titolo pagina' }],
  url: '/',
  imageAlt: 'Alt immagine',
})

export const mockGenericItem = (index: number) => ({
  pk: index,
  icon: getIcon('leaf'),
  intro: 'Overtitle',
  title: 'Lorem ipsum dolor',
  slug: 'lorem-ipsum-dolor',
  name: `Iscriviti alla newletter ${index.toString()}`,
  description:
    '<p>Entra nel mondo Emilgroup e rimani sempre aggiornato sulle nuove collezioni, gli eventi e le più innovative soluzioni progettuali dell’abitare contemporaneo.</p>',
  ctaLabel: 'Call to action',
  url: '/',
  style: 'arrow_right',
  image: imgUrl(800, 500),
  alt: 'Alt immagine',
  video: {
    url: getAssetsUrl('/video/example.mp4'),
    provider: 'youtube',
    videoId: 'MaMIZj90GHw',
    ratio: '16-9',
  },
  videoPreview: {
    url: getAssetsUrl('/video/example.mp4'),
    provider: 'youtube',
    videoId: 'MaMIZj90GHw',
    ratio: '16:9',
  },
})

export const mockHeroSlider = () => {
  const slider = {
    ...mockGenericItem(1),
    children: [11, 12, 13, 14, 15, 16].map((item) => mockGenericItem(item)),
  }
  return slider
}

export const mockGenericItemNoAnchor = (index: number) => ({
  pk: index,
  name: 'Name',
  description: '<p>Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet.</p>', // no anchor in description
  ctaLabel: 'Call to action',
  url: '/',
  image: imgUrl(767, 500),
  alt: 'Alt immagine',
  video: {
    url: '/video/example.mp4',
  },
})

export const langsMock = [
  { pk: 1, name: 'Italiano', url: '/it', locale: 'it', selected: true },
  { pk: 2, name: 'English', url: '/en', locale: 'en' },
  { pk: 3, name: 'Français', url: '/fr', locale: 'fr' },
  { pk: 4, name: 'Deutsch', url: '/de', locale: 'de' },
  { pk: 5, name: 'Español', url: '/es', locale: 'es' },
  { pk: 6, name: 'Русский', url: '/ru', locale: 'ru' },
]

export const mockCollezione = {
  pk: 1274,
  nome: 'Unique Travertine',
  title: 'Unique Travertine',
  sottotitolo:
    'Estetica e prestazioni si uniscono in un inno alla matericità calcarea del travertino.',
  description:
    'Unique Travertine è un progetto completo, realizzato attraverso lo studio delle diverse lavorazioni del travertino. La gamma si compone di numerose declinazioni, dalle più naturali come Vein Cut, con le tipiche venature longitudinali del taglio nel verso della vena, Minimal, che si ispira alla lavorazione del retro del travertino, fino alle versioni più insolite come Ruled, ricca di scanalature e solchi tridimensionali, e Ancient, con un sofisticato effetto anticato che ben si adatta a recuperi in stile e progetti dal sapore retrò. Unique Travertine è la sintesi ideale tra materia classica e progettualità contemporanea, un compendio completo e armonico di elementi capaci di interpretare, combinandosi tra loro, ambienti dal carattere definito e unico, dai più tradizionali ai più audaci e sperimentali.\n\n\nCon il nuovo formato 120x278 a spessore 6,5 mm, dall’elevato impatto scenico, Unique Travertine amplifica le proprie potenzialità espressive, dando massimo risalto al fascino senza tempo, e per questo sempre profondamente attuale, della materia di ispirazione.\nUnique Travertine si amplia e rende disponibile anche il formato 120x120 a spessore 9,5 mm, nelle superfici Naturale e Tecnica, caratterizzata da elevate prestazioni antiscivolo adatta per spazi esterni, pubblici e privati. La stessa superficie resta in dotazione anche per il formato 60x120, con l’aggiunta di nuovi colori e finiture che estendono le sue possibilità applicative e progettuali.\n',
  slug: 'unique-travertine',
  brand: {
    id: '3',
    nome: 'Provenza',
    title: 'Provenza',
    slug: 'provenza',
  },
  quickship: false,
  shield: false,
  silktech: false,
  novita: false,
  nsf: false,
  nsfMagazineSlug: null,
  isUsa: false,
  claim: 'Progettualità senza confini',
  payoff: 'Perfetta sintesi tra materia classica e progettualità contemporanea.',
  logo: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Provenza_Unique Travertine_Logo.jpg',
  gallery: [
    {
      id: 3344,
      url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/UniqueTravertine_img_gallery1.jpg',
      articoliGallery: [
        {
          pk: 22076,
          image:
            'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ8P_ UNIQUE TRAVERTINE MINIMAL WHITE_30x60_1.jpg',
          tonalitaNome: 'White',
          tonalitaUrl: '/provenza/unique-travertine/minimal-white',
          finituraNome: 'Minimal',
        },
        {
          pk: 22142,
          image:
            'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ97_ UNIQUE TRAVERTINE RULED SILVER_30x60 CON STRUTTURA_1.jpg',
          tonalitaNome: 'Silver',
          tonalitaUrl: '/provenza/unique-travertine/ruled-silver',
          finituraNome: 'Ruled',
        },
        {
          pk: 22072,
          image:
            'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ7K_ UNIQUE TRAVERTINE VEIN CUT SILVER_30x60_1.jpg',
          tonalitaNome: 'Silver',
          tonalitaUrl: '/provenza/unique-travertine/vein-cut-silver',
          finituraNome: 'Vein Cut',
        },
        {
          pk: 22072,
          image:
            'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ7K_ UNIQUE TRAVERTINE VEIN CUT SILVER_30x60_1.jpg',
          tonalitaNome: 'Silver',
          tonalitaUrl: '/provenza/unique-travertine/vein-cut-silver',
          finituraNome: 'Vein Cut',
        },
        {
          pk: 22072,
          image:
            'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ7K_ UNIQUE TRAVERTINE VEIN CUT SILVER_30x60_1.jpg',
          tonalitaNome: 'Silver',
          tonalitaUrl: '/provenza/unique-travertine/vein-cut-silver',
          finituraNome: 'Vein Cut',
        },
        {
          pk: 22072,
          image:
            'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ7K_ UNIQUE TRAVERTINE VEIN CUT SILVER_30x60_1.jpg',
          tonalitaNome: 'Silver',
          tonalitaUrl: '/provenza/unique-travertine/vein-cut-silver',
          finituraNome: 'Vein Cut',
        },
      ],
    },
    {
      id: 3345,
      url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/UniqueTravertine_img_gallery2.jpg',
      articoliGallery: [
        {
          pk: 22076,
          image:
            'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ8P_ UNIQUE TRAVERTINE MINIMAL WHITE_30x60_1.jpg',
          tonalitaNome: 'White',
          tonalitaUrl: '/provenza/unique-travertine/minimal-white',
          finituraNome: 'Minimal',
        },
        {
          pk: 22140,
          image:
            'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ95_UNIQUE TRAVERTINE RULED WHITE_30x60_CON STRUTTURA_1.jpg',
          tonalitaNome: 'White',
          tonalitaUrl: '/provenza/unique-travertine/ruled-white',
          finituraNome: 'Ruled',
        },
        {
          pk: 22070,
          image:
            'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ7H_ UNIQUE TRAVERTINE VEIN CUT WHITE_30x60_1.jpg',
          tonalitaNome: 'White',
          tonalitaUrl: '/provenza/unique-travertine/vein-cut-white',
          finituraNome: 'Vein Cut',
        },
      ],
    },
    {
      id: 3346,
      url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/UniqueTravertine_img_gallery3.jpg',
      articoliGallery: [
        {
          pk: 23215,
          image:
            'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJT4_ UNIQUE TRAVERTINE RULED CHOCOLATE_30x60_CON STRUTTURA_1.jpg',
          tonalitaNome: 'Chocolate',
          tonalitaUrl: '/provenza/unique-travertine/ruled-chocolate',
          finituraNome: 'Ruled',
        },
        {
          pk: 23208,
          image:
            'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJSL_ UNIQUE TRAVERTINE VEIN CUT CHOCOLATE_30x60_1.jpg',
          tonalitaNome: 'Chocolate',
          tonalitaUrl: '/provenza/unique-travertine/vein-cut-chocolate',
          finituraNome: 'Vein Cut',
        },
      ],
    },
    {
      id: 3347,
      url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/UniqueTravertine_img_gallery4.jpg',
      articoliGallery: [
        {
          pk: 22078,
          image:
            'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ8R_ UNIQUE TRAVERTINE MINIMAL SILVER_30x60_1.jpg',
          tonalitaNome: 'Silver',
          tonalitaUrl: '/provenza/unique-travertine/minimal-silver',
          finituraNome: 'Minimal',
        },
        {
          pk: 22142,
          image:
            'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ97_ UNIQUE TRAVERTINE RULED SILVER_30x60 CON STRUTTURA_1.jpg',
          tonalitaNome: 'Silver',
          tonalitaUrl: '/provenza/unique-travertine/ruled-silver',
          finituraNome: 'Ruled',
        },
      ],
    },
    {
      id: 3784,
      url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Unique Travertine Cream Vein Cut-Minimal Nat 120x278 Amb Bagno.jpg',
      articoliGallery: [
        {
          pk: 22077,
          image:
            'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ8Q_ UNIQUE TRAVERTINE MINIMAL CREAM_30x60_1.jpg',
          tonalitaNome: 'Cream',
          tonalitaUrl: '/provenza/unique-travertine/minimal-cream',
          finituraNome: 'Minimal',
        },
        {
          pk: 22071,
          image:
            'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ7J_ UNIQUE TRAVERTINE VEIN CUT CREAM_30x60_1.jpg',
          tonalitaNome: 'Cream',
          tonalitaUrl: '/provenza/unique-travertine/vein-cut-cream',
          finituraNome: 'Vein Cut',
        },
      ],
    },
    {
      id: 3785,
      url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Unique Travertine White Vein Cut Lapp-Minimal Nat 120x278 Amb Living.jpg',
      articoliGallery: [
        {
          pk: 22076,
          image:
            'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ8P_ UNIQUE TRAVERTINE MINIMAL WHITE_30x60_1.jpg',
          tonalitaNome: 'White',
          tonalitaUrl: '/provenza/unique-travertine/minimal-white',
          finituraNome: 'Minimal',
        },
        {
          pk: 22070,
          image:
            'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ7H_ UNIQUE TRAVERTINE VEIN CUT WHITE_30x60_1.jpg',
          tonalitaNome: 'White',
          tonalitaUrl: '/provenza/unique-travertine/vein-cut-white',
          finituraNome: 'Vein Cut',
        },
      ],
    },
  ],
  abaco: {
    id: 3505,
    url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Provenza Abaco UniqueTravertine 2021-04.jpg',
  },
  video: '6AOmjhrU_RU',
  linkVideo: 'https://youtu.be/6AOmjhrU_RU',
  immagineVideo: {
    id: 3338,
    url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Unique_Travertine_Img_Statica.jpg',
  },
  spessoriFormati: [
    {
      spessore: '9,5 mm',
      formati: [
        {
          nome: '7,5x60 cm',
          lato1Intero: null,
          lato2Intero: null,
          lato1Numeratore: null,
          lato2Numeratore: null,
          lato1Denominatore: null,
          lato2Denominatore: null,
        },
        {
          nome: '120x120 cm',
          lato1Intero: null,
          lato2Intero: null,
          lato1Numeratore: null,
          lato2Numeratore: null,
          lato1Denominatore: null,
          lato2Denominatore: null,
        },
        {
          nome: '30x60 cm',
          lato1Intero: null,
          lato2Intero: null,
          lato1Numeratore: null,
          lato2Numeratore: null,
          lato1Denominatore: null,
          lato2Denominatore: null,
        },
        {
          nome: '60x120 cm',
          lato1Intero: null,
          lato2Intero: null,
          lato1Numeratore: null,
          lato2Numeratore: null,
          lato1Denominatore: null,
          lato2Denominatore: null,
        },
        {
          nome: '60x60 cm',
          lato1Intero: null,
          lato2Intero: null,
          lato1Numeratore: null,
          lato2Numeratore: null,
          lato1Denominatore: null,
          lato2Denominatore: null,
        },
        {
          nome: '90x90 cm',
          lato1Intero: null,
          lato2Intero: null,
          lato1Numeratore: null,
          lato2Numeratore: null,
          lato1Denominatore: null,
          lato2Denominatore: null,
        },
      ],
    },
    {
      spessore: '10 mm',
      formati: [
        {
          nome: '90x180 cm',
          lato1Intero: null,
          lato2Intero: null,
          lato1Numeratore: null,
          lato2Numeratore: null,
          lato1Denominatore: null,
          lato2Denominatore: null,
        },
      ],
    },
    {
      spessore: '20 mm',
      formati: [
        {
          nome: '60x120 cm',
          lato1Intero: null,
          lato2Intero: null,
          lato1Numeratore: null,
          lato2Numeratore: null,
          lato1Denominatore: null,
          lato2Denominatore: null,
        },
      ],
    },
    {
      spessore: '6,5 mm',
      formati: [
        {
          nome: '120x278 cm',
          lato1Intero: null,
          lato2Intero: null,
          lato1Numeratore: null,
          lato2Numeratore: null,
          lato1Denominatore: null,
          lato2Denominatore: null,
        },
      ],
    },
  ],
  colori: [
    {
      id: 63,
      nome: 'Ancient',
      tonalita: [
        {
          nome: 'Chocolate',
          url: '/provenza/unique-travertine/ancient-chocolate',
          image: {
            title: null,
            alt: null,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJTA_ UNIQUE TRAVERTINE ANCIENT CHOCOLATE_30x60_1.jpg',
          },
        },
        {
          nome: 'Cream',
          url: '/provenza/unique-travertine/ancient-cream',
          image: {
            title: null,
            alt: null,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ9F_ UNIQUE TRAVERTINE ANCIENT CREAM_30x60_1.jpg',
          },
        },
        {
          nome: 'Silver',
          url: '/provenza/unique-travertine/ancient-silver',
          image: {
            title: null,
            alt: null,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ9G_ UNIQUE TRAVERTINE ANCIENT SILVER_30x60_1.jpg',
          },
        },
        {
          nome: 'White',
          url: '/provenza/unique-travertine/ancient-white',
          image: {
            title: null,
            alt: null,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ9E_ UNIQUE TRAVERTINE ANCIENT WHITE_30x60_1.jpg',
          },
        },
      ],
    },
    {
      id: 32,
      nome: 'Minimal',
      tonalita: [
        {
          nome: 'Chocolate',
          url: '/provenza/unique-travertine/minimal-chocolate',
          image: {
            title: null,
            alt: null,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJSY_ UNIQUE TRAVERTINE MINIMAL CHOCOLATE_30x60_1.jpg',
          },
        },
        {
          nome: 'Cream',
          url: '/provenza/unique-travertine/minimal-cream',
          image: {
            title: null,
            alt: null,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ8Q_ UNIQUE TRAVERTINE MINIMAL CREAM_30x60_1.jpg',
          },
        },
        {
          nome: 'Silver',
          url: '/provenza/unique-travertine/minimal-silver',
          image: {
            title: null,
            alt: null,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ8R_ UNIQUE TRAVERTINE MINIMAL SILVER_30x60_1.jpg',
          },
        },
        {
          nome: 'White',
          url: '/provenza/unique-travertine/minimal-white',
          image: {
            title: null,
            alt: null,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ8P_ UNIQUE TRAVERTINE MINIMAL WHITE_30x60_1.jpg',
          },
        },
      ],
    },
    {
      id: 64,
      nome: 'Ruled',
      tonalita: [
        {
          nome: 'Chocolate',
          url: '/provenza/unique-travertine/ruled-chocolate',
          image: {
            title: null,
            alt: null,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJT4_ UNIQUE TRAVERTINE RULED CHOCOLATE_30x60_CON STRUTTURA_1.jpg',
          },
        },
        {
          nome: 'Cream',
          url: '/provenza/unique-travertine/ruled-cream',
          image: {
            title: null,
            alt: null,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ96_ UNIQUE TRAVERTINE RULED CREAM_30x60_CON STRUTTURA_1.jpg',
          },
        },
        {
          nome: 'Silver',
          url: '/provenza/unique-travertine/ruled-silver',
          image: {
            title: null,
            alt: null,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ97_ UNIQUE TRAVERTINE RULED SILVER_30x60 CON STRUTTURA_1.jpg',
          },
        },
        {
          nome: 'White',
          url: '/provenza/unique-travertine/ruled-white',
          image: {
            title: null,
            alt: null,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ95_UNIQUE TRAVERTINE RULED WHITE_30x60_CON STRUTTURA_1.jpg',
          },
        },
      ],
    },
    {
      id: 62,
      nome: 'Vein Cut',
      tonalita: [
        {
          nome: 'Chocolate',
          url: '/provenza/unique-travertine/vein-cut-chocolate',
          image: {
            title: null,
            alt: null,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJSL_ UNIQUE TRAVERTINE VEIN CUT CHOCOLATE_30x60_1.jpg',
          },
        },
        {
          nome: 'Cream',
          url: '/provenza/unique-travertine/vein-cut-cream',
          image: {
            title: null,
            alt: null,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ7J_ UNIQUE TRAVERTINE VEIN CUT CREAM_30x60_1.jpg',
          },
        },
        {
          nome: 'Silver',
          url: '/provenza/unique-travertine/vein-cut-silver',
          image: {
            title: null,
            alt: null,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ7K_ UNIQUE TRAVERTINE VEIN CUT SILVER_30x60_1.jpg',
          },
        },
        {
          nome: 'White',
          url: '/provenza/unique-travertine/vein-cut-white',
          image: {
            title: null,
            alt: null,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ7H_ UNIQUE TRAVERTINE VEIN CUT WHITE_30x60_1.jpg',
          },
        },
      ],
    },
  ],
  superfici: [
    {
      id: 2109,
      nome: 'Full Lappato',
      dcof: null,
      bcra: null,
      pendoloAS4586: null,
      pendoloBS7976: null,
      pendoloUNE41901: null,
      scivolositaNome: null,
      scivolositaLabel: null,
      specificheAbcNome: null,
      specificheAbcLabel: null,
    },
    {
      id: 2,
      nome: 'Naturale',
      dcof: 'Wet ≥ 0.50',
      bcra: '> 0.40',
      pendoloAS4586: 'P3',
      pendoloBS7976: '> 36 Low Slip potential',
      pendoloUNE41901: null,
      scivolositaNome: 'R10',
      scivolositaLabel: 'DIN EN 16165 Annex B',
      specificheAbcNome: 'B (A+B)',
      specificheAbcLabel: 'DIN EN 16165 Annex A',
    },
    {
      id: 2116,
      nome: 'Naturale 20MM',
      dcof: 'Wet ≥ 0.65',
      bcra: '> 0.40',
      pendoloAS4586: 'P4',
      pendoloBS7976: '> 36 Low Slip potential',
      pendoloUNE41901: '3',
      scivolositaNome: 'R11',
      scivolositaLabel: 'DIN EN 16165 Annex B',
      specificheAbcNome: 'C (A+B+C)',
      specificheAbcLabel: 'DIN EN 16165 Annex A',
    },
    {
      id: 6,
      nome: 'Tecnica',
      dcof: 'Wet ≥ 0.65',
      bcra: '> 0.40',
      pendoloAS4586: 'P4',
      pendoloBS7976: '> 36 Low Slip potential',
      pendoloUNE41901: '3',
      scivolositaNome: 'R11',
      scivolositaLabel: 'DIN EN 16165 Annex B',
      specificheAbcNome: 'C (A+B+C)',
      specificheAbcLabel: 'DIN EN 16165 Annex A',
    },
  ],
  shadeVariations: [
    {
      codice: 'V3',
      nome: 'V3 High',
      imageUrl: 'https://www.emilgroup.it/emil/prodotti/certificazioni_emil/Shade V3.jpg',
      imageAlt: '',
    },
  ],
  destinazioni: [
    {
      nome: 'LIGHT COMMERCIAL FULL LAPPATO',
      titolo: null,
      imageUrl:
        'https://www.emilgroup.it/emil/prodotti/certificazioni_emil/Light_Commercial_Full_Lappato.png',
    },
    {
      nome: 'HEAVY COMMERCIAL',
      titolo: 'Alto traffico pedonale (es. stazioni ferroviarie, aereoporti, centri commerciali)',
      imageUrl: 'https://www.emilgroup.it/emil/prodotti/certificazioni_emil/Heavy_Commercial.png',
    },
  ],
  decori: [
    {
      categoria: 'MOSAICO 5X5 ANCIENT - 30X30',
      decori: [
        {
          image: {
            id: 1532,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJTR_UNIQUE TRAVERTINE_MOSAICO_30x30_5x5_ANCIENT CUT CHIOCOLATE.jpg',
          },
          id: 23228,
          categoriaDecoro: 'MOSAICO 5X5 ANCIENT - 30X30',
          nomeWeb: 'CHOCOLATE',
          styleWidth: 111,
          styleHeight: 111,
        },
        {
          image: {
            id: 1531,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJE1_UNIQUE TRAVERTINE_MOSAICO_30x30_5x5_ANCIENT CUT CREAM.jpg',
          },
          id: 22444,
          categoriaDecoro: 'MOSAICO 5X5 ANCIENT - 30X30',
          nomeWeb: 'CREAM',
          styleWidth: 111,
          styleHeight: 111,
        },
        {
          image: {
            id: 1530,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJE2_UNIQUE TRAVERTINE_MOSAICO_30x30_5x5_ANCIENT CUT SILVER.jpg',
          },
          id: 22445,
          categoriaDecoro: 'MOSAICO 5X5 ANCIENT - 30X30',
          nomeWeb: 'SILVER',
          styleWidth: 111,
          styleHeight: 111,
        },
        {
          image: {
            id: 1529,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJE0_UNIQUE TRAVERTINE_MOSAICO_30x30_5x5_ANCIENT CUT WHITE.jpg',
          },
          id: 22443,
          categoriaDecoro: 'MOSAICO 5X5 ANCIENT - 30X30',
          nomeWeb: 'WHITE',
          styleWidth: 111,
          styleHeight: 111,
        },
      ],
    },
    {
      categoria: 'MOSAICO 5X5 MINIMAL - 30X30',
      decori: [
        {
          image: {
            id: 1528,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJTP_UNIQUE TRAVERTINE_MOSAICO_30x30_5x5_MINIMAL CUT CHIOCOLATE.jpg',
          },
          id: 23227,
          categoriaDecoro: 'MOSAICO 5X5 MINIMAL - 30X30',
          nomeWeb: 'CHOCOLATE',
          styleWidth: 111,
          styleHeight: 111,
        },
        {
          image: {
            id: 1527,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJDX_UNIQUE TRAVERTINE_MOSAICO_30x30_5x5_MINIMAL CUT CREAM.jpg',
          },
          id: 22516,
          categoriaDecoro: 'MOSAICO 5X5 MINIMAL - 30X30',
          nomeWeb: 'CREAM',
          styleWidth: 111,
          styleHeight: 111,
        },
        {
          image: {
            id: 1526,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJDY_UNIQUE TRAVERTINE_MOSAICO_30x30_5x5_MINIMAL CUT SILVER.jpg',
          },
          id: 22517,
          categoriaDecoro: 'MOSAICO 5X5 MINIMAL - 30X30',
          nomeWeb: 'SILVER',
          styleWidth: 111,
          styleHeight: 111,
        },
        {
          image: {
            id: 1525,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJDW_UNIQUE TRAVERTINE_MOSAICO_30x30_5x5_MINIMAL CUT WHITE.jpg',
          },
          id: 22515,
          categoriaDecoro: 'MOSAICO 5X5 MINIMAL - 30X30',
          nomeWeb: 'WHITE',
          styleWidth: 111,
          styleHeight: 111,
        },
      ],
    },
    {
      categoria: 'MOSAICO 5X5 VEIN CUT - 30X30',
      decori: [
        {
          image: {
            id: 1521,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJTH_UNIQUE TRAVERTINE_MOSAICO_30x30_5x5_VIEN CUT CHIOCOLATE.jpg',
          },
          id: 23224,
          categoriaDecoro: 'MOSAICO 5X5 VEIN CUT - 30X30',
          nomeWeb: 'CHOCOLATE',
          styleWidth: 111,
          styleHeight: 111,
        },
        {
          image: {
            id: 1520,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJDK_UNIQUE TRAVERTINE_MOSAICO_30x30_5x5_VIEN CUT CREAM.jpg',
          },
          id: 22435,
          categoriaDecoro: 'MOSAICO 5X5 VEIN CUT - 30X30',
          nomeWeb: 'CREAM',
          styleWidth: 111,
          styleHeight: 111,
        },
        {
          image: {
            id: 1519,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJDL_UNIQUE TRAVERTINE_MOSAICO_30x30_5x5_VIEN CUT SILVER.jpg',
          },
          id: 22436,
          categoriaDecoro: 'MOSAICO 5X5 VEIN CUT - 30X30',
          nomeWeb: 'SILVER',
          styleWidth: 111,
          styleHeight: 111,
        },
        {
          image: {
            id: 1518,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJDJ_UNIQUE TRAVERTINE_MOSAICO_30x30_5x5_VIEN CUT WHITE.jpg',
          },
          id: 22434,
          categoriaDecoro: 'MOSAICO 5X5 VEIN CUT - 30X30',
          nomeWeb: 'WHITE',
          styleWidth: 111,
          styleHeight: 111,
        },
      ],
    },
    {
      categoria: 'MOSAICO MINI BLOCK ANCIENT - 30X30',
      decori: [
        {
          image: {
            id: 1544,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJTZ_UNIQUE TRAVERTINE_MOSAICO_30x30_MINI_BLOCK_ANCIENT CUT CHOCOLATE 1.jpg',
          },
          id: 23721,
          categoriaDecoro: 'MOSAICO MINI BLOCK ANCIENT - 30X30',
          nomeWeb: 'CHOCOLATE',
          styleWidth: 111,
          styleHeight: 111,
        },
        {
          image: {
            id: 1543,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJEJ_UNIQUE TRAVERTINE_MOSAICO_30x30_MINI_BLOCK_ANCIENT CUT CREAM 1.jpg',
          },
          id: 23718,
          categoriaDecoro: 'MOSAICO MINI BLOCK ANCIENT - 30X30',
          nomeWeb: 'CREAM',
          styleWidth: 111,
          styleHeight: 111,
        },
        {
          image: {
            id: 1542,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJEK_UNIQUE TRAVERTINE_MOSAICO_30x30_MINI_BLOCK_ANCIENT CUT SILVER 1.jpg',
          },
          id: 23719,
          categoriaDecoro: 'MOSAICO MINI BLOCK ANCIENT - 30X30',
          nomeWeb: 'SILVER',
          styleWidth: 111,
          styleHeight: 111,
        },
        {
          image: {
            id: 1541,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJEH_UNIQUE TRAVERTINE_MOSAICO_30x30_MINI_BLOCK_ANCIENT CUT WHITE 1.jpg',
          },
          id: 23717,
          categoriaDecoro: 'MOSAICO MINI BLOCK ANCIENT - 30X30',
          nomeWeb: 'WHITE',
          styleWidth: 111,
          styleHeight: 111,
        },
      ],
    },
    {
      categoria: 'MOSAICO MINI BLOCK MINIMAL - 30X30',
      decori: [
        {
          image: {
            id: 1540,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJTX_UNIQUE TRAVERTINE_MOSAICO_30x30_MINI_BLOCK_MINIMAL CUT CHOCOLATE 1.jpg',
          },
          id: 23720,
          categoriaDecoro: 'MOSAICO MINI BLOCK MINIMAL - 30X30',
          nomeWeb: 'CHOCOLATE',
          styleWidth: 111,
          styleHeight: 111,
        },
        {
          image: {
            id: 1539,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJEE_UNIQUE TRAVERTINE_MOSAICO_30x30_MINI_BLOCK_MINIMAL CUT CREAM 1.jpg',
          },
          id: 23715,
          categoriaDecoro: 'MOSAICO MINI BLOCK MINIMAL - 30X30',
          nomeWeb: 'CREAM',
          styleWidth: 111,
          styleHeight: 111,
        },
        {
          image: {
            id: 1538,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJEF_UNIQUE TRAVERTINE_MOSAICO_30x30_MINI_BLOCK_MINIMAL CUT SILVER 1.jpg',
          },
          id: 23716,
          categoriaDecoro: 'MOSAICO MINI BLOCK MINIMAL - 30X30',
          nomeWeb: 'SILVER',
          styleWidth: 111,
          styleHeight: 111,
        },
        {
          image: {
            id: 1537,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJED_UNIQUE TRAVERTINE_MOSAICO_30x30_MINI_BLOCK_MINIMAL CUT WHITE 1.jpg',
          },
          id: 23714,
          categoriaDecoro: 'MOSAICO MINI BLOCK MINIMAL - 30X30',
          nomeWeb: 'WHITE',
          styleWidth: 111,
          styleHeight: 111,
        },
      ],
    },
    {
      categoria: 'MOSAICO MINI BLOCK VEIN CUT - 30X30',
      decori: [
        {
          image: {
            id: 1536,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJTT_UNIQUE TRAVERTINE_MOSAICO_30x30_MINI_BLOCK_VIEN CUT CHOCOLATE 1.jpg',
          },
          id: 23692,
          categoriaDecoro: 'MOSAICO MINI BLOCK VEIN CUT - 30X30',
          nomeWeb: 'CHOCOLATE',
          styleWidth: 111,
          styleHeight: 111,
        },
        {
          image: {
            id: 1535,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJE5_UNIQUE TRAVERTINE_MOSAICO_30x30_MINI_BLOCK_VIEN CUT CREAM 1.jpg',
          },
          id: 23683,
          categoriaDecoro: 'MOSAICO MINI BLOCK VEIN CUT - 30X30',
          nomeWeb: 'CREAM',
          styleWidth: 111,
          styleHeight: 111,
        },
        {
          image: {
            id: 1534,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJE5_UNIQUE TRAVERTINE_MOSAICO_30x30_MINI_BLOCK_VIEN CUT CREAM 1.jpg',
          },
          id: 23684,
          categoriaDecoro: 'MOSAICO MINI BLOCK VEIN CUT - 30X30',
          nomeWeb: 'SILVER',
          styleWidth: 111,
          styleHeight: 111,
        },
        {
          image: {
            id: 1533,
            url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJE4_UNIQUE TRAVERTINE_MOSAICO_30x30_MINI_BLOCK_VIEN CUT WHITE 1.jpg',
          },
          id: 23682,
          categoriaDecoro: 'MOSAICO MINI BLOCK VEIN CUT - 30X30',
          nomeWeb: 'WHITE',
          styleWidth: 111,
          styleHeight: 111,
        },
      ],
    },
  ],
  opuses: [
    {
      nome: 'OPUS',
      descrizione: 'Opus Ancient Brecciato',
      imageUrl:
        'https://www.emilgroup.it/emil/prodotti/opus_emil/Articoli multiformato - Petit Opus.jpg',
      opusCodesPerFormati: [
        {
          codiceCatalogo: 'EJQ0',
          numPezzi: 1,
          formato: {
            id: 223,
            nome: '200x300',
            lato1Cm: '20.0',
            lato2Cm: '30.0',
            lato1Intero: '7',
            lato2Intero: '11',
            lato1Numeratore: '7',
            lato2Numeratore: '13',
            lato1Denominatore: '8',
            lato2Denominatore: '16',
            lato1PxWeb: '74',
            lato2PxWeb: '111',
          },
        },
        {
          codiceCatalogo: 'EJQ0',
          numPezzi: 1,
          formato: {
            id: 38,
            nome: '200x200',
            lato1Cm: '20.0',
            lato2Cm: '20.0',
            lato1Intero: '7',
            lato2Intero: '7',
            lato1Numeratore: '7',
            lato2Numeratore: '7',
            lato1Denominatore: '8',
            lato2Denominatore: '8',
            lato1PxWeb: '74',
            lato2PxWeb: '74',
          },
        },
      ],
      opusCodesPerArticoli: [
        {
          codiceCatalogo: 'EJPZ',
          numPezzi: 1,
          formato: {
            id: 38,
            nome: '200x200',
            lato1Cm: '20.0',
            lato2Cm: '20.0',
            lato1Intero: '7',
            lato2Intero: '7',
            lato1Numeratore: '7',
            lato2Numeratore: '7',
            lato1Denominatore: '8',
            lato2Denominatore: '8',
            lato1PxWeb: '74',
            lato2PxWeb: '74',
          },
        },
        {
          codiceCatalogo: 'EJQ1',
          numPezzi: 1,
          formato: {
            id: 38,
            nome: '200x200',
            lato1Cm: '20.0',
            lato2Cm: '20.0',
            lato1Intero: '7',
            lato2Intero: '7',
            lato1Numeratore: '7',
            lato2Numeratore: '7',
            lato1Denominatore: '8',
            lato2Denominatore: '8',
            lato1PxWeb: '74',
            lato2PxWeb: '74',
          },
        },
        {
          codiceCatalogo: 'EJTF',
          numPezzi: 1,
          formato: {
            id: 38,
            nome: '200x200',
            lato1Cm: '20.0',
            lato2Cm: '20.0',
            lato1Intero: '7',
            lato2Intero: '7',
            lato1Numeratore: '7',
            lato2Numeratore: '7',
            lato1Denominatore: '8',
            lato2Denominatore: '8',
            lato1PxWeb: '74',
            lato2PxWeb: '74',
          },
        },
        {
          codiceCatalogo: 'EJQ0',
          numPezzi: 1,
          formato: {
            id: 38,
            nome: '200x200',
            lato1Cm: '20.0',
            lato2Cm: '20.0',
            lato1Intero: '7',
            lato2Intero: '7',
            lato1Numeratore: '7',
            lato2Numeratore: '7',
            lato1Denominatore: '8',
            lato2Denominatore: '8',
            lato1PxWeb: '74',
            lato2PxWeb: '74',
          },
        },
      ],
    },
  ],
  lappato: true,
  lappatoUrl:
    'https://www.emilgroup.it/static/core/files/Manutenzione_Full_Lappato_Brochure_IT_2023.11_Web.pdf',
  catalogo: {
    nomeWeb: 'Unique Travertine Catalogo 2024.10',
    url: 'https://www.emilgroup.it/emil/prodotti/documenticollezioni_emil/Unique Travertine Catalogo 2024.10 Web.pdf',
  },
  cataloghiBrochure: [
    {
      nomeWeb: 'Tele di Marmo 90x180 2021.07',
      url: 'https://www.emilgroup.it/emil/prodotti/documenticollezioni_emil/TeleDiMarmo 90x180 Catalogo 2021.07 Web.pdf',
    },
    {
      nomeWeb: 'Tele di Marmo Collections 04.2023',
      url: 'https://www.emilgroup.it/emil/prodotti/documenticollezioni_emil/TdM Collections Catalogo 2023.03 Web.pdf',
    },
  ],
  certificazioni: [
    {
      title: 'Certificazione 1',
      nome: 'GREENGUARD GOLD',
      codice: 'GGG',
      imageUrl: 'https://www.emilgroup.it/emil/prodotti/certificazioni_emil/3.jpg',
      url: '/',
    },
  ],
  progetti: [
    {
      title: 'Attico con vista a Seoul ',
      destinazioneTitolo: 'Residenziale',
      slug: 'attico_con_vista_a_seoul',
      cittaId: null,
      subtitle: null,
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/Banner - UNIQUE TRAVERTINE_INTERIOR BIDI_SANGAHTILE _22_.jpg',
    },
    {
      title: 'Attico con vista a Seoul ',
      destinazioneTitolo: 'Residenziale',
      slug: 'attico_con_vista_a_seoul',
      cittaId: null,
      subtitle: null,
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/Banner - UNIQUE TRAVERTINE_INTERIOR BIDI_SANGAHTILE _22_.jpg',
    },
    {
      title: 'Attico con vista a Seoul ',
      destinazioneTitolo: 'Residenziale',
      slug: 'attico_con_vista_a_seoul',
      cittaId: null,
      subtitle: null,
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/Banner - UNIQUE TRAVERTINE_INTERIOR BIDI_SANGAHTILE _22_.jpg',
    },
    {
      title: 'Attico con vista a Seoul ',
      destinazioneTitolo: 'Residenziale',
      slug: 'attico_con_vista_a_seoul',
      cittaId: null,
      subtitle: null,
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/Banner - UNIQUE TRAVERTINE_INTERIOR BIDI_SANGAHTILE _22_.jpg',
    },
    {
      title: 'Attico con vista a Seoul ',
      destinazioneTitolo: 'Residenziale',
      slug: 'attico_con_vista_a_seoul',
      cittaId: null,
      subtitle: null,
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/Banner - UNIQUE TRAVERTINE_INTERIOR BIDI_SANGAHTILE _22_.jpg',
    },
  ],
  effetto: {
    title: 'Pietra',
    imageUrl:
      'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/UTrav Silver Vein Cut Ruled 60x120 White Minimal 90x180 Amb Caffetteria.jpg',
  },
  magazines: [
    {
      title: 'Interior Design e Benessere Mentale: come trasformare il tuo spazio e la tua mente',
      slug: 'interior-design-e-benessere-mentale-come-trasformare-il-tuo-spazio-e-la-tua-mente',
      categoriaTitle: 'Ispirazioni',
      description: null,
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/a6/25/a62547a5-a303-4ef9-b348-7cb0bd828333/banner_unique_travertine_white_vein_cut-minimal_nat_amb_cucina.jpg',
    },
    {
      title:
        "Il ritorno dei colori caldi nel design d'interni: una tendenza accogliente e vibrante",
      slug: 'il-ritorno-dei-colori-caldi-nel-design-dinterni-una-tendenza-accogliente-e-vibrante',
      categoriaTitle: 'Ispirazioni',
      description: null,
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/3e/10/3e104612-97ef-4801-b6e5-3d24fc4df80b/banner_forme_rosato-terracotta_20x20_amb_cucina.jpg',
    },
    {
      title: 'Scopri i rivestimenti da abbinare a elementi di recupero vintage',
      slug: 'scopri-i-rivestimenti-da-abbinare-a-elementi-di-recupero-vintage',
      categoriaTitle: null,
      description: null,
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/34/3f/343fe0c3-89d6-414c-bf56-3d03a1571229/banner_forme_majolica_ocra_lux_part_cucina.jpg',
    },
    {
      title: 'Il fascino elegante del travertino: intervista con l’architetto',
      slug: 'il-fascino-elegante-del-travertino-intervista-con-larchitetto',
      categoriaTitle: 'Interviste',
      description: null,
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/dc/b2/dcb2f06c-42d2-44d0-a84e-aadae7ea46f8/uzupis-webres-4.jpg',
    },
  ],
}

export const mockTonalitaDetail = {
  brand: {
    id: '3',
    nome: 'Provenza',
    title: 'Provenza',
    slug: 'provenza',
  },
  imageCollezione: {
    id: 3344,
    url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/UniqueTravertine_img_gallery1.jpg',
  },
  tonalita: {
    id: 160,
    pagina: null,
  },
  collezione: {
    title: 'Unique Travertine',
    sottotitolo: 'Estetica e prestazioni si uniscono in un <span>Unique Travertine</span>',
    slug: 'unique-travertine',
    shadeVariations: [
      {
        codice: 'V3',
        nome: 'V3 High',
        imageUrl: 'https://www.emilgroup.it/emil/prodotti/certificazioni_emil/Shade V3.jpg',
        imageAlt: '',
      },
    ],
    destinazioni: [
      {
        nome: 'HEAVY COMMERCIAL',
        titolo: 'Alto traffico pedonale (es. stazioni ferroviarie, aereoporti, centri commerciali)',
        imageUrl: 'https://www.emilgroup.it/emil/prodotti/certificazioni_emil/Heavy_Commercial.png',
      },
      {
        nome: 'LIGHT COMMERCIAL FULL LAPPATO',
        titolo: null,
        imageUrl:
          'https://www.emilgroup.it/emil/prodotti/certificazioni_emil/Light_Commercial_Full_Lappato.png',
      },
    ],
    shield: false,
  },
  tonalitaCollezione: {
    id: 10,
    tonalitaNome: 'Minimal - Cream',
    articolo: {
      image:
        'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ8Q_ UNIQUE TRAVERTINE MINIMAL CREAM_30x60_1.jpg',
    },
    breadcrumbs: [
      { label: 'Home', url: '/' },
      { label: 'Collezioni', url: '/collections' },
      { label: 'Level', url: '/collections/brand/level' },
      { label: 'Level Wood ', url: '/collections/brand/level/level-wood' },
      { label: 'Blonde Oak', url: '/collections/brand/level/level-wood/blonde_oak' },
    ],
    superficiSpessoriFormati: [
      {
        nome: 'Naturale',
        dcof: 'Wet ≥ 0.50',
        bcra: '> 0.40',
        pendoloAS4586: 'P2',
        pendoloBS7976: '< 36 Moderate Slip potential',
        pendoloUNE41901: null,
        scivolositaNome: 'R10',
        scivolositaLabel: 'DIN EN 16165 Annex B',
        specificheAbcNome: 'B (A+B)',
        specificheAbcLabel: 'DIN EN 16165 Annex A',
        spessori: [
          {
            spessore: '6,5 mm',
            codice: 'AR',
            formati: [
              {
                nome: '120x278 cm',
                lato1Intero: '47',
                lato2Intero: '109',
                lato1Numeratore: '1',
                lato2Numeratore: '7',
                lato1Denominatore: '4',
                lato2Denominatore: '16',
              },
            ],
          },
          {
            spessore: '9,5 mm',
            codice: 'BR',
            formati: [
              {
                nome: '120x120 cm',
                lato1Intero: '47',
                lato2Intero: '47',
                lato1Numeratore: '1',
                lato2Numeratore: '1',
                lato1Denominatore: '4',
                lato2Denominatore: '4',
              },
              {
                nome: '7,5x60 cm',
                lato1Intero: '2',
                lato2Intero: '23',
                lato1Numeratore: '1',
                lato2Numeratore: '5',
                lato1Denominatore: '1',
                lato2Denominatore: '8',
              },
              {
                nome: '60x120 cm',
                lato1Intero: '23',
                lato2Intero: '47',
                lato1Numeratore: '5',
                lato2Numeratore: '1',
                lato1Denominatore: '8',
                lato2Denominatore: '4',
              },
              {
                nome: '60x60 cm',
                lato1Intero: '23',
                lato2Intero: '23',
                lato1Numeratore: '5',
                lato2Numeratore: '5',
                lato1Denominatore: '8',
                lato2Denominatore: '8',
              },
            ],
          },
          {
            spessore: '10 mm',
            codice: 'BV',
            formati: [
              {
                nome: '90x180 cm',
                lato1Intero: '35',
                lato2Intero: '70',
                lato1Numeratore: '7',
                lato2Numeratore: '7',
                lato1Denominatore: '16',
                lato2Denominatore: '8',
              },
            ],
          },
        ],
      },
      {
        nome: 'Naturale 20MM',
        dcof: 'Wet ≥ 0.65',
        bcra: '> 0.40',
        pendoloAS4586: 'P4',
        pendoloBS7976: '> 36 Low Slip potential',
        pendoloUNE41901: '3',
        scivolositaNome: 'R11',
        scivolositaLabel: 'DIN EN 16165 Annex B',
        specificheAbcNome: 'C (A+B+C)',
        specificheAbcLabel: 'DIN EN 16165 Annex A',
        spessori: [
          {
            spessore: '20 mm',
            codice: 'CN',
            formati: [
              {
                nome: '60x120 cm',
                lato1Intero: '23',
                lato2Intero: '47',
                lato1Numeratore: '5',
                lato2Numeratore: '1',
                lato1Denominatore: '8',
                lato2Denominatore: '4',
              },
            ],
          },
        ],
      },
      {
        nome: 'Tecnica',
        dcof: 'Wet ≥ 0.65',
        bcra: '> 0.40',
        pendoloAS4586: 'P4',
        pendoloBS7976: '> 36 Low Slip potential',
        pendoloUNE41901: '3',
        scivolositaNome: 'R11',
        scivolositaLabel: 'DIN EN 16165 Annex B',
        specificheAbcNome: 'C (A+B+C)',
        specificheAbcLabel: 'DIN EN 16165 Annex A',
        spessori: [
          {
            spessore: '9,5 mm',
            codice: 'BR',
            formati: [
              {
                nome: '120x120 cm',
                lato1Intero: '47',
                lato2Intero: '47',
                lato1Numeratore: '1',
                lato2Numeratore: '1',
                lato1Denominatore: '4',
                lato2Denominatore: '4',
              },
              {
                nome: '7,5x60 cm',
                lato1Intero: '2',
                lato2Intero: '23',
                lato1Numeratore: '1',
                lato2Numeratore: '5',
                lato1Denominatore: '1',
                lato2Denominatore: '8',
              },
              {
                nome: '60x120 cm',
                lato1Intero: '23',
                lato2Intero: '47',
                lato1Numeratore: '5',
                lato2Numeratore: '1',
                lato1Denominatore: '8',
                lato2Denominatore: '4',
              },
              {
                nome: '60x60 cm',
                lato1Intero: '23',
                lato2Intero: '23',
                lato1Numeratore: '5',
                lato2Numeratore: '5',
                lato1Denominatore: '8',
                lato2Denominatore: '8',
              },
            ],
          },
        ],
      },
    ],
    certificazioni: [
      {
        nome: 'GREENGUARD GOLD',
        codice: 'GGG',
        imageUrl: 'https://www.emilgroup.it/emil/prodotti/certificazioni_emil/3.jpg',
      },
    ],
    gallery: [
      {
        id: 3338,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Unique_Travertine_Img_Statica.jpg',
      },
      {
        id: 3339,
        url: 'https://www.emilgroup.it/emil/prodotti/anteprimecollezioni_emil/Unique_Travertine_Anteprima.jpg',
      },
      {
        id: 3784,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Unique Travertine Cream Vein Cut-Minimal Nat 120x278 Amb Bagno.jpg',
      },
    ],
  },
}

export const mockListing = {
  title: 'Prodotti',
  subtitle: 'Piastrelle in gres porcellanato ideali per il bagno',
  description:
    'Testo descrittivo introduttivo per il listing premium “Bagno”. Le piastrelle in gres porcellanato firmate Emilgroup rispondono alle esigenze sempre nuove di una progettualità in continua evoluzione. Gli spazi cambiano in funzione dei tempi e delle mode, del nostro modo di vivere e abitare. L’immaginario in cui ci muoviamo quello è di un panorama sempre più vasto, fatto di pluralità e sperimentazioni.',
  suggestions: [
    {
      id: 10,
      modelName: 'collezioni',
      text: 'Metallica',
      url: '/collezioni/brand/emilceramica/metallica',
    },
  ],
  elementi: [
    {
      title: '20Twenty',
      slug: '20twenty',
      quickship: true,
      novita: true,
      listingImage: {
        id: 37,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_20Twenty_017.jpg',
      },
      brand: {
        nome: 'Emilceramica',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Emil_Bianco_Logo Brand Stiky Menu_365x122_Fondo Trasparente-1.png',
      },
    },
    {
      title: 'Be-Square',
      slug: 'be-square',
      quickship: true,
      novita: false,
      listingImage: {
        id: 4089,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Be-Square Sand 120x278 Amb. Hall.jpg',
      },
      brand: {
        nome: 'Emilceramica',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Emil_Bianco_Logo Brand Stiky Menu_365x122_Fondo Trasparente-1.png',
      },
    },
    {
      title: 'Externa',
      slug: 'externa',
      quickship: false,
      novita: true,
      listingImage: {
        id: 429,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_Externa_016.jpg',
      },
      brand: {
        nome: 'Emilceramica',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Emil_Bianco_Logo Brand Stiky Menu_365x122_Fondo Trasparente-1.png',
      },
    },
    {
      title: 'Millelegni',
      slug: 'millelegni',
      quickship: false,
      novita: false,
      listingImage: {
        id: 1554,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_Millelegni_009.jpg',
      },
      brand: {
        nome: 'Emilceramica',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Emil_Bianco_Logo Brand Stiky Menu_365x122_Fondo Trasparente-1.png',
      },
    },
    {
      title: 'Nordika',
      slug: 'nordika',
      quickship: false,
      novita: false,
      listingImage: {
        id: 784,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_Nordika_011.jpg',
      },
      brand: {
        nome: 'Emilceramica',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Emil_Bianco_Logo Brand Stiky Menu_365x122_Fondo Trasparente-1.png',
      },
    },
    {
      title: 'On Square',
      slug: 'on-square',
      quickship: false,
      novita: false,
      listingImage: {
        id: 2085,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_ON_SQUARE_004.jpg',
      },
      brand: {
        nome: 'Emilceramica',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Emil_Bianco_Logo Brand Stiky Menu_365x122_Fondo Trasparente-1.png',
      },
    },
    {
      title: 'Tele Di Marmo',
      slug: 'tele-di-marmo',
      quickship: false,
      novita: false,
      listingImage: {
        id: 4164,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Tdm Breccia 60x120 Amb Living.jpg',
      },
      brand: {
        nome: 'Emilceramica',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Emil_Bianco_Logo Brand Stiky Menu_365x122_Fondo Trasparente-1.png',
      },
    },
    {
      title: 'Tr3nd',
      slug: 'tr3nd',
      quickship: false,
      novita: false,
      listingImage: {
        id: 1327,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Ergon_Tr3nd_019.jpg',
      },
      brand: {
        nome: 'Ergon',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Ergon_Logo_RGB_web_bianco.png',
      },
    },
    {
      title: 'Cornerstone',
      slug: 'cornerstone',
      quickship: false,
      novita: false,
      listingImage: {
        id: 2406,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Ergon_Cornerstone White Slate_001.jpg',
      },
      brand: {
        nome: 'Ergon',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Ergon_Logo_RGB_web_bianco.png',
      },
    },
    {
      title: 'Groove',
      slug: 'groove',
      quickship: false,
      novita: false,
      listingImage: {
        id: 436,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Provenza_Groove_001.jpg',
      },
      brand: {
        nome: 'Provenza',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Provenza_Bianco_Logo Brand Stiky Menu_365x122_Fondo Trasparente-1.png',
      },
    },
    {
      title: 'Gesso',
      slug: 'gesso',
      quickship: false,
      novita: false,
      listingImage: {
        id: 474,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Provenza_Gesso_Provenza_Gesso_015.jpg',
      },
      brand: {
        nome: 'Provenza',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Provenza_Bianco_Logo Brand Stiky Menu_365x122_Fondo Trasparente-1.png',
      },
    },
    {
      title: 'Re-Use',
      slug: 're-use',
      quickship: false,
      novita: false,
      listingImage: {
        id: 496,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Provenza_Re-use_005.jpg',
      },
      brand: {
        nome: 'Provenza',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Provenza_Bianco_Logo Brand Stiky Menu_365x122_Fondo Trasparente-1.png',
      },
    },
    {
      title: 'Karman',
      slug: 'karman',
      quickship: false,
      novita: false,
      listingImage: {
        id: 3332,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Karman_Gallery02.jpg',
      },
      brand: {
        nome: 'Provenza',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Provenza_Bianco_Logo Brand Stiky Menu_365x122_Fondo Trasparente-1.png',
      },
    },
    {
      title: 'Playground',
      slug: 'playground',
      quickship: false,
      novita: false,
      listingImage: {
        id: 861,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Ergon_Playground_019.jpg',
      },
      brand: {
        nome: 'Ergon',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Ergon_Logo_RGB_web_bianco.png',
      },
    },
    {
      title: 'Provoak',
      slug: 'provoak',
      quickship: false,
      novita: false,
      listingImage: {
        id: 908,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Provenza_Provoak_028.jpg',
      },
      brand: {
        nome: 'Provenza',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Provenza_Bianco_Logo Brand Stiky Menu_365x122_Fondo Trasparente-1.png',
      },
    },
    {
      title: 'Stone Talk',
      slug: 'stone-talk',
      quickship: false,
      novita: false,
      listingImage: {
        id: 1012,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Ergon_Stonetalk_021.jpg',
      },
      brand: {
        nome: 'Ergon',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Ergon_Logo_RGB_web_bianco.png',
      },
    },
    {
      title: 'Stone Project',
      slug: 'stone-project',
      quickship: false,
      novita: false,
      listingImage: {
        id: 1173,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Ergon_StoneProject_009.jpg',
      },
      brand: {
        nome: 'Ergon',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Ergon_Logo_RGB_web_bianco.png',
      },
    },
    {
      title: 'Chateau',
      slug: 'chateau',
      quickship: false,
      novita: false,
      listingImage: {
        id: 1919,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emil_Chateau_012.jpg',
      },
      brand: {
        nome: 'Emilceramica',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Emil_Bianco_Logo Brand Stiky Menu_365x122_Fondo Trasparente-1.png',
      },
    },
    {
      title: 'Eureka',
      slug: 'eureka',
      quickship: false,
      novita: false,
      listingImage: {
        id: 355,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Provenza_Eureka_008.jpg',
      },
      brand: {
        nome: 'Provenza',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Provenza_Bianco_Logo Brand Stiky Menu_365x122_Fondo Trasparente-1.png',
      },
    },
    {
      title: 'Level Concrete',
      slug: 'level-concrete',
      quickship: false,
      novita: false,
      listingImage: null,
      brand: {
        nome: 'Level',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Level_Bianco_Logo Brand Stiky Menu_365x122_Fondo Trasparente-1.png',
      },
    },
    {
      title: 'Level Marmi',
      slug: 'level-marmi',
      quickship: false,
      novita: false,
      listingImage: {
        id: 2261,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/EMIL_Level_4.jpg',
      },
      brand: {
        nome: 'Level',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Level_Bianco_Logo Brand Stiky Menu_365x122_Fondo Trasparente-1.png',
      },
    },
    {
      title: 'Level Tinta Unita',
      slug: 'level-tinta-unita',
      quickship: false,
      novita: false,
      listingImage: {
        id: 2168,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Level_Tinta_Unita_041.jpg',
      },
      brand: {
        nome: 'Level',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Level_Bianco_Logo Brand Stiky Menu_365x122_Fondo Trasparente-1.png',
      },
    },
    {
      title: 'Grain Stone',
      slug: 'grain-stone',
      quickship: false,
      novita: false,
      listingImage: {
        id: 2078,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Ergon_Grainstone_004.jpg',
      },
      brand: {
        nome: 'Ergon',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Ergon_Logo_RGB_web_bianco.png',
      },
    },
    {
      title: 'Lombarda',
      slug: 'lombarda',
      quickship: false,
      novita: false,
      listingImage: {
        id: 3887,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Ergon_Lombarda_Living_60x120 Sabbia Mix _ 120x120 Sabbia.jpg',
      },
      brand: {
        nome: 'Ergon',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Ergon_Logo_RGB_web_bianco.png',
      },
    },
  ],
  attributi: [
    {
      label: 'Brand',
      chiave: 'brand',
      valori: [
        {
          id: 4,
          label: 'Viva',
          valori: null,
        },
        {
          id: 2,
          label: 'Ergon',
          valori: null,
        },
        {
          id: 7,
          label: 'Level',
          valori: null,
        },
        {
          id: 3,
          label: 'Provenza',
          valori: null,
        },
        {
          id: 1,
          label: 'Emilceramica',
          valori: null,
        },
      ],
    },
    {
      label: 'Novità',
      chiave: 'novita',
      valori: [
        {
          id: 1,
          label: 'Nuove collezioni',
          valori: null,
        },
      ],
    },
    {
      label: 'Colore',
      chiave: 'colore',
      valori: [
        {
          id: 7,
          label: '#9c9c9c',
          valori: null,
        },
        {
          id: 13,
          label: '#4d2942',
          valori: null,
        },
        {
          id: 1,
          label: '#f0901d',
          valori: null,
        },
        {
          id: 5,
          label: '#1f3e69',
          valori: null,
        },
        {
          id: 22,
          label: '#293133',
          valori: null,
        },
        {
          id: 4,
          label: '#FFFFFF',
          valori: null,
        },
        {
          id: 6,
          label: '#fbd953',
          valori: null,
        },
        {
          id: 28,
          label: '#ADD8E6',
          valori: null,
        },
        {
          id: 11,
          label: '#c1342d',
          valori: null,
        },
        {
          id: 3,
          label: '#f0e5c9',
          valori: null,
        },
        {
          id: 12,
          label: '#3c755b',
          valori: null,
        },
        {
          id: 2,
          label: '#55a1cd',
          valori: null,
        },
        {
          id: 8,
          label: '#654321',
          valori: null,
        },
        {
          id: 9,
          label: '#000000',
          valori: null,
        },
        {
          id: 23,
          label: '#E5D6CC',
          valori: null,
        },
        {
          id: 27,
          label: '#ffb6c1',
          valori: null,
        },
        {
          id: 25,
          label: '#d2d2d2',
          valori: null,
        },
      ],
    },
    {
      label: 'Effetto',
      chiave: 'effetto',
      valori: [
        {
          id: 2,
          label: 'Legno',
          valori: null,
        },
        {
          id: 1,
          label: 'Terracotta',
          valori: null,
        },
        {
          id: 4,
          label: 'Pietra',
          valori: null,
        },
        {
          id: 3,
          label: 'Cemento',
          valori: null,
        },
        {
          id: 19,
          label: 'Resina',
          valori: null,
        },
        {
          id: 5,
          label: 'Marmo',
          valori: null,
        },
        {
          id: 7,
          label: 'Metallo',
          valori: null,
        },
      ],
    },
    {
      label: 'Ambiente',
      chiave: 'ambiente',
      valori: [
        {
          id: 17,
          label: 'Piscina',
          valori: null,
        },
        {
          id: 18,
          label: 'Sala da Pranzo',
          valori: null,
        },
        {
          id: 3,
          label: 'Bagno',
          valori: null,
        },
        {
          id: 4,
          label: 'Soggiorno',
          valori: null,
        },
        {
          id: 8,
          label: 'Camera da Letto',
          valori: null,
        },
        {
          id: 10,
          label: 'Commerciale',
          valori: null,
        },
        {
          id: 9,
          label: 'Cucina',
          valori: null,
        },
        {
          id: 6,
          label: 'Dettaglio Immagine',
          valori: null,
        },
        {
          id: 7,
          label: 'Esterni',
          valori: null,
        },
        {
          id: 13,
          label: 'Interni',
          valori: null,
        },
        {
          id: 12,
          label: 'Negozio',
          valori: null,
        },
        {
          id: 16,
          label: 'Residenziale',
          valori: null,
        },
        {
          id: 15,
          label: 'Ristorante',
          valori: null,
        },
        {
          id: 2,
          label: 'Spazio Esterno',
          valori: null,
        },
        {
          id: 1,
          label: 'Spazio Pubblico',
          valori: null,
        },
        {
          id: 14,
          label: 'Still Life',
          valori: null,
        },
        {
          id: 11,
          label: 'Ufficio',
          valori: null,
        },
      ],
    },
    {
      label: 'Formato',
      chiave: 'formato',
      valori: [
        {
          id: 8,
          label: 'Countertop',
          valori: [
            {
              id: 1246,
              label: '160x320',
            },
            {
              id: 1322,
              label: '162x324',
            },
          ],
        },
        {
          id: 1,
          label: 'Grandi',
          valori: [
            {
              id: 434,
              label: '15x90',
            },
            {
              id: 681,
              label: '40x80',
            },
            {
              id: 61,
              label: '45x90',
            },
            {
              id: 1234,
              label: '60x120',
            },
            {
              id: 415,
              label: '80x80',
            },
            {
              id: 1265,
              label: '90x180',
            },
            {
              id: 252,
              label: '90x90',
            },
          ],
        },
        {
          id: 7,
          label: 'Grande Lastra',
          valori: [
            {
              id: 1211,
              label: '120x120',
            },
            {
              id: 1311,
              label: '120x278',
            },
          ],
        },
        {
          id: 2,
          label: 'Medi',
          valori: [
            {
              id: 268,
              label: '6,5x60',
            },
            {
              id: 6,
              label: '7,5x60',
            },
            {
              id: 686,
              label: '11x54',
            },
            {
              id: 284,
              label: '20x40',
            },
            {
              id: 51,
              label: '30x60',
            },
            {
              id: 71,
              label: '60x60',
            },
          ],
        },
        {
          id: 3,
          label: 'Piccoli',
          valori: [
            {
              id: 562,
              label: '5x15',
            },
            {
              id: 267,
              label: '6x25',
            },
            {
              id: 360,
              label: '7,5x15',
            },
            {
              id: 362,
              label: '7,5x20',
            },
            {
              id: 189,
              label: '7,5x30',
            },
            {
              id: 16,
              label: '10x30',
            },
            {
              id: 38,
              label: '20x20',
            },
            {
              id: 614,
              label: '21x18,2',
            },
            {
              id: 49,
              label: '30x30',
            },
          ],
        },
      ],
    },
    {
      label: 'Spessore',
      chiave: 'spessore',
      valori: [
        {
          id: 84,
          label: '6,5 mm',
          valori: null,
        },
        {
          id: 32,
          label: '8 mm',
          valori: null,
        },
        {
          id: 33,
          label: '8,5 mm',
          valori: null,
        },
        {
          id: 34,
          label: '9 mm',
          valori: null,
        },
        {
          id: 36,
          label: '9,5 mm',
          valori: null,
        },
        {
          id: 37,
          label: '10 mm',
          valori: null,
        },
        {
          id: 40,
          label: '11,5 mm',
          valori: null,
        },
        {
          id: 41,
          label: '12 mm',
          valori: null,
        },
        {
          id: 42,
          label: '20 mm',
          valori: null,
        },
      ],
    },
    {
      label: 'Indice R',
      chiave: 'scivolosita',
      valori: [
        {
          id: 1,
          label: 'R9',
          valori: null,
        },
        {
          id: 2,
          label: 'R10',
          valori: null,
        },
        {
          id: 3,
          label: 'R11',
          valori: null,
        },
      ],
    },
    {
      label: 'Superfici',
      chiave: 'macrosuperficie',
      valori: [
        {
          id: 1,
          label: 'Naturale',
          valori: null,
        },
        {
          id: 2,
          label: 'Lappato/Lucido',
          valori: null,
        },
        {
          id: 3,
          label: 'Matt',
          valori: null,
        },
        {
          id: 4,
          label: 'Antislip/Tecnica',
          valori: null,
        },
        {
          id: 5,
          label: 'Strutturato',
          valori: null,
        },
        {
          id: 6,
          label: 'Silktech',
          valori: null,
        },
      ],
    },
  ],
  params: {
    search: 'Unique',
    filtri: [
      {
        label: null,
        chiave: 'effetto',
        valori: [
          {
            id: 7,
            label: null,
            valori: null,
          },
        ],
      },
    ],
    ordinamento: null,
    page: 1,
    perPage: null,
    firstPagePerPage: null,
    categoriaSlug: null,
  },
  ordinamenti: [
    {
      label: 'Dal più recente',
      value: 'creation_date',
    },
    {
      label: 'Dalla A alla Z',
      value: 'alphabetic',
    },
    {
      label: 'Dalla Z alla A',
      value: 'reverse_alphabetic',
    },
  ],
  page: 1,
  perPage: 24,
  numPages: 24,
  count: 60,
  effetti: [
    {
      title: 'Cemento',
      slug: 'cemento',
      imageUrl:
        'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_Be-Square_001.jpg',
    },
    {
      title: 'Marmo',
      slug: 'marmo',
      imageUrl:
        'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_Tele_Di_Marmo_001.jpg',
    },
    {
      title: 'Metallo',
      slug: 'metallo',
      imageUrl:
        'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Viva_Metallica_Logo.jpg',
    },
    {
      title: 'Pietra',
      slug: 'pietra',
      imageUrl:
        'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_Chateaux_002.jpg',
    },
    {
      title: 'Cemento',
      slug: 'cemento',
      imageUrl:
        'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_Be-Square_001.jpg',
    },
    {
      title: 'Marmo',
      slug: 'marmo',
      imageUrl:
        'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_Tele_Di_Marmo_001.jpg',
    },
    {
      title: 'Metallo',
      slug: 'metallo',
      imageUrl:
        'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Viva_Metallica_Logo.jpg',
    },
    {
      title: 'Pietra',
      slug: 'pietra',
      imageUrl:
        'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_Chateaux_002.jpg',
    },
    {
      title: 'Pietra',
      slug: 'pietra',
      imageUrl:
        'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_Chateaux_002.jpg',
    },
    {
      title: 'Pietra',
      slug: 'pietra',
      imageUrl:
        'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_Chateaux_002.jpg',
    },
  ],
  ispirazioni: [
    {
      title:
        'Emilgroup ottiene il riconoscimento Top Employer Italia 2025: un successo che si rinnova per il settimo anno consecutivo',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/98/51/9851a906-282a-42f7-bd00-27544b29f65e/banner.jpg',
      slug: 'emilgroup-ottiene-il-riconoscimento-top-employer-italia-2025-un-successo-che-si-rinnova-per-il-settimo-anno-consecutivo',
    },
    {
      title: 'Emilgroup Premia il Talento dei Figli dei Dipendenti con le Borse di Studio 2024',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/a3/f3/a3f3c1c8-77f8-4497-818f-027fdec06d07/banner_emilgroup_borse_di_studio_2024-18.jpg',
      slug: 'emilgroup-premia-il-talento-dei-figli-dei-dipendenti-con-le-borse-di-studio-2024',
    },
    {
      title: "Rivivi la magia dell'evento Made in Emil 2024!",
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/86/fb/86fb11a0-8de6-44dc-9299-1a34b5c5ea66/banner-1920x1080-1.png',
      slug: 'rivivi-la-magia-dellevento-made-in-emil-2024',
    },
    {
      title: 'Emilgroup @ Arkeda 2024',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/8f/5d/8f5d39ed-8a4d-40b1-a24a-68b8d7810338/materastone_beige_120x278_60x120_white_120x278_amb_cucina.jpg',
      slug: 'emilgroup-arkeda-2024',
    },
    {
      title: 'Il decoro Elements di I-WOOD vince gli Archiproducts Design Awards 2024',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/45/49/45498b8c-d922-4aea-b22b-3d38cf6d6387/banner_emil_legno_roveredorato_miniset_part_copia.jpg',
      slug: 'il-decoro-elements-di-i-wood-vince-gli-archiproducts-design-awards-2024',
    },
    {
      title: "Emilgroup Project Awards 2024: I vincitori premiati durante l'evento Made in Emil",
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/84/93/8493b8f4-b6cb-48a6-8064-4eed55b2b426/banner_emilgroup_cersaie_23_settembre_2024-260.jpg',
      slug: 'emilgroup-project-awards-2024-i-vincitori-premiati-durante-levento-made-in-emil',
    },
    {
      title: 'Medley by Ergon trionfa al Ceramics of Italy Tile Competition',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/62/85/62851ccd-be5b-4163-802b-46da265e05d0/banner_1722431851_66aa396b6f57b_0.jpg',
      slug: 'medley-by-ergon-trionfa-al-ceramics-of-italy-tile-competition',
    },
    {
      title: 'Safety First Worker',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/fc/29/fc29856f-dc53-4f30-956d-f4e512eba182/banner_n8a2303.jpg',
      slug: 'safety-first-worker',
    },
    {
      title: 'Made in Emil: Open Days 23-27 Settembre 2024',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/7b/9e/7b9e9dcf-e9c4-47e7-9be1-2c3264d333d1/banner-1920x1080-1.png',
      slug: 'made-in-emil-open-days-23-27-settembre-2024',
    },
    {
      title: 'Bologna Business School: la visita aziendale in Emilgroup',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/8a/db/8adba38b-3605-476f-a4c8-3c27222eaed4/bbs-2024-05-07-98.jpg',
      slug: 'bologna-business-school-la-visita-aziendale-in-emilgroup',
    },
    {
      title: 'Emilgroup Project Awards 2024',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/4c/a5/4ca5f5db-6711-4cd4-80bf-3411fbaa73d0/1920x1080.jpg',
      slug: 'emilgroup-project-awards-2024',
    },
    {
      title: 'Emilgroup @ Coverings 2024',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/f0/cc/f0cc23f5-6aae-45e6-a367-4c0073e80b34/coverings_emil_sito.jpg',
      slug: 'emilgroup-coverings-2024',
    },
    {
      title: 'Emilgroup @ Milano Design Week 2024',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/48/c0/48c0cd90-a0f7-491a-a4e7-6c587009c34e/mdw_24_emil_sito.jpg',
      slug: 'emilgroup-milano-design-week-2024',
    },
    {
      title: 'Emilgroup si conferma azienda Top Employer Italia 2024',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/f5/aa/f5aa5311-3574-4e3f-9cb3-f43647cf7b9e/social_sito.png',
      slug: 'emilgroup-si-conferma-azienda-top-employer-italia-2024',
    },
    {
      title: 'Emilgroup @ Maison&Objet 2024',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/1e/d6/1ed6c425-296b-4969-96da-73664ae75134/maisonobject_nl.jpg',
      slug: 'emilgroup-maisonobjet-2024',
    },
    {
      title: 'Borse di studio 2022-2023: Emilgroup premia i figli dei dipendenti',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/59/87/598764c3-6fae-4a57-857c-c088cd3ba03d/banner_emilgroup_borsedistudio_2023-5.jpg',
      slug: 'borse-di-studio-2022-2023-emilgroup-premia-i-figli-dei-dipendenti',
    },
    {
      title: 'Emilgroup @ Arkeda 2023',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/95/fe/95fe5a17-f4b3-4dd9-b4cf-a34d031e287d/arkeda_sito.png',
      slug: 'emilgroup-arkeda-2023',
    },
    {
      title: 'Emilgroup @ BDNY 2023',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/b6/68/b668417a-7b11-4ab6-a864-1f58e2dbabbc/bd-ny_sito.png',
      slug: 'emilgroup-bdny-2023',
    },
    {
      title: 'Emilgroup Project Awards 2023: I vincitori',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/e0/49/e0497087-c3fd-4e32-9ae3-7bb3042a1208/emilgroup_cersaie_2023-435.jpg',
      slug: 'emilgroup-project-awards-2023-i-vincitori',
    },
    {
      title: 'EMILPEOPLE: GRAZIE DI ESSERE STATI CON NOI!',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/09/41/09411a26-e720-4c75-9bb3-98e3b17d42f3/banner___emilgroup_cersaie_2023-669.jpg',
      slug: 'emilpeople-grazie-di-essere-stati-con-noi',
    },
    {
      title: 'EmilPeople | Open Days 2023: Video',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/6f/1a/6f1ab7a6-6e95-4704-8674-33feb9e5cd01/bannerpeople_versione_3.png',
      slug: 'emilpeople-open-days-2023-video',
    },
    {
      title: 'EmilPeople: Open Days 25-29 Settembre 2023',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/0c/bc/0cbc895c-af70-41f6-a763-825bbb5d2ce0/bannerpeople_versione_1.png',
      slug: 'emilpeople-open-days-25-29-settembre-2023',
    },
    {
      title: 'Tele di Marmo Precious by Emilceramica - Video',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/bc/8c/bc8c6bad-00d8-419e-99c8-d5b0d756799c/tdmprecious_agate-crystal_128x278_apertura_generale.jpg',
      slug: 'tele-di-marmo-precious-by-emilceramica-video',
    },
    {
      title: 'Emil Lab Paris: Nuovo showroom',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/47/d6/47d686ba-872d-4340-ac99-dfb1dfd871f0/emil_design_lab_1920x1080.png',
      slug: 'emil-lab-paris-nuovo-showroom',
    },
    {
      title: 'Emilgroup sbarca su Tik Tok',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/19/a3/19a304e3-79df-4ebd-94cd-410564698542/tiktok_1920x1080.png',
      slug: 'emilgroup-sbarca-su-tik-tok',
    },
    {
      title: 'Emilgroup Project Awards 2023',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/21/13/2113f961-1cdc-42d2-a229-ac20336e96f4/home_page_1920x1080.png',
      slug: 'emilgroup-project-awards-2023',
    },
    {
      title: 'Ergon North Coast Challenger',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/ef/6d/ef6d69b3-c781-4a33-bae6-4f835f70e769/banner_-_northcoast_day1-173.jpg',
      slug: 'ergon-north-coast-challenger',
    },
    {
      title: 'Emilgroup @ Milano Design Week 2023',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/f9/b0/f9b0cb7c-f746-4b9b-9e4e-4b7be6140e12/milanodesignweek2023_1920x1080.png',
      slug: 'emilgroup-milano-design-week-2023',
    },
    {
      title: 'Revival: Connect with Nature',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/87/aa/87aa6c16-0005-41e1-ac17-d6ff8ecd84af/revival_1920x1080.jpg',
      slug: 'revival-connect-with-nature',
    },
    {
      title: 'Pigmento by Ergon: Video',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/6b/29/6b29237a-109d-48e0-b91f-5b42b0d8324d/emilceramica_cover_resine_1.jpg',
      slug: 'pigmento-by-ergon-video',
    },
    {
      title: 'Emilgroup @ Coverings 2023',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/bd/33/bd332ae5-83fe-4182-bbb5-e866e87f0ce9/coverings2023_sito.png',
      slug: 'emilgroup-coverings-2023',
    },
    {
      title: 'Virtual tour Ergon Showroom',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/50/db/50db8fd6-5333-4fc7-81bc-7d77cafe50df/banner_-_2_ergon_gen_img_9901.jpg',
      slug: 'virtual-tour-ergon-showroom',
    },
    {
      title: 'Emilgroup @ Euroshop 2023',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/f1/2e/f12ecb9d-0265-4744-be93-c97e0046cf44/home1920x1080.jpg',
      slug: 'emilgroup-euroshop-2023',
    },
    {
      title: 'Emilgroup è il per il 5° anno consecutivo Top Employer Italia',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/17/4a/174a1fad-ea8a-4025-8fe7-562fe8d1cab9/home1920x1080.png',
      slug: 'emilgroup-e-il-per-il-5-anno-consecutivo-top-employer-italia',
    },
    {
      title: 'Emilgroup @ Maison&Objet 2023',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/50/10/501063ed-3492-4c91-a3d9-0640a7ffebbe/maisonobjet2023_1920x1080.png',
      slug: 'emilgroup-maisonobjet-2023',
    },
    {
      title: 'EMILGROUP PROJECT AWARDS 2022 - LE INTERVISTE CON I VINCITORI',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/1e/e8/1ee869a7-2a58-41c1-956e-eefda59251a6/logo_epa_sito-01.png',
      slug: 'emilgroup-project-awards-2022-le-interviste-con-i-vincitori',
    },
    {
      title: 'Borse di studio 2021-2022: Emilgroup premia il talento',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/72/56/7256bf42-a9d3-496e-bf85-9ea9f8d072b6/emilgroup_borse_di_studio_20_dicembre_2022-24.jpg',
      slug: 'borse-di-studio-2021-2022-emilgroup-premia-il-talento',
    },
    {
      title: 'L’Italia che Comunica assegna il premio B2B alla campagna digital di Pave and Go',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/a1/c2/a1c20615-2e77-42cf-9bac-ba89d11b17ff/banner_-_emilgroup_premio_italia_che_comunica-1.jpg',
      slug: 'litalia-che-comunica-assegna-il-premio-b2b-alla-campagna-digital-di-pave-and-go',
    },
    {
      title:
        'Tele di Marmo Precious Agate Azure è la vincitrice degli Archiproducts Design Awards 2022',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/b3/4f/b34f5b51-68ae-4c42-b66c-3a7bd8aa1d6f/homepage-archiproduct.png',
      slug: 'tele-di-marmo-precious-agate-azure-e-la-vincitrice-degli-archiproducts-design-awards-2022',
    },
    {
      title: 'Emilgroup Project Awards 2022: i vincitori',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/5f/61/5f61ee1c-9ad4-4f6d-a0d2-c87639476aac/emilgroup_cersaie_26_settembre_2022-337.jpg',
      slug: 'emilgroup-project-awards-2022-i-vincitori',
    },
    {
      title: 'Emilgroup @ EquipHotel',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/49/d6/49d6171f-c4ab-4692-8eae-fb6160068da8/tdmprecious_agate_brown-crystal_ambra_128x278_amb_cucina.jpg',
      slug: 'emilgroup-equiphotel',
    },
    {
      title: 'Abacus by Ergon: Video',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/c1/82/c182136c-32c2-4308-91d6-94af3a9e5557/abacus_ricette_a_colori_barattoli.jpg',
      slug: 'abacus-by-ergon-video',
    },
    {
      title: 'TIME 60+1: L’EVENTO DI EMILGROUP',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/80/ac/80ac96b3-fb11-4e57-ad73-3a94108b57b9/banner_-_emilgroup_cersaie_26_settembre_2022-7.jpg',
      slug: 'time-601-levento-di-emilgroup',
    },
    {
      title: 'TIME 60+1: Open Days 26-30 Settembre',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/16/83/1683a555-0474-4c4c-8b71-114956e35b0b/opendays-homepage.png',
      slug: 'evento-time-601',
    },
    {
      title: 'TIME 60+1 | Open Days 2022 Coming soon',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/a8/dd/a8ddb92f-36b2-4cba-8295-1b6467cc870c/opendays-homepage.png',
      slug: 'time-601-open-days-2022-coming-soon',
    },
    {
      title: 'Emil Lab Opéra – Un relooking monumental',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/1c/ba/1cba5987-4628-4c04-a2af-23dfdbf9211a/paris_declinazioni_homepage_sito.png',
      slug: 'emil-lab-opera-un-relooking-monumental',
    },
    {
      title: 'Pave and Go 2022: Video',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/12/49/1249cf52-da4d-4cb1-bac3-50ad9e910b32/paveok.jpg',
      slug: 'pave-and-go-2022-video',
    },
    {
      title: 'Level NSF: Video',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/1a/b1/1ab1413e-7c7a-4484-aa6a-c9cac522aa55/statuario_bianco-1741.jpg',
      slug: 'level-nsf-video',
    },
    {
      title: 'Emilgroup @ Milano Design Week 2022',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/03/cb/03cbb350-9815-4fe6-939b-f0674d4d8cbc/fuorisalone_homepage.png',
      slug: 'emilgroup-milano-design-week',
    },
    {
      title: 'Level by Emilgroup ottiene la certificazione NSF per il contatto con gli alimenti',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/6a/09/6a09ad1d-9401-4fc4-9b5a-bac005837b59/banner_-_laguna_blanca-1617.jpg',
      slug: 'level-emilgroup-ottiene-la-certificazione-nsf-il-contatto-con-gli-alimenti',
    },
    {
      title: 'Emilgroup Booth @ Coverings 2022',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/9d/7d/9d7d91d9-5839-4f86-8141-f0bd912d9755/_mg_8150.jpg',
      slug: 'emilgroup-booth-coverings-2022',
    },
    {
      title: 'Emilgroup Project Awards 2022',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/bc/f1/bcf1a071-5b01-41d2-9793-a0649109b9ee/logo_epa_sito-01.png',
      slug: 'emilgroup-project-awards-2022',
    },
    {
      title: 'Emilgroup @ Coverings 2022',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/f8/1e/f81e2a2a-3801-4012-bae8-17e4d4c8d5b5/coverings2022_2_sito.png',
      slug: 'emilgroup-coverings-2022',
    },
    {
      title: 'Emilgroup @ Maison&Objet 2022',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/02/39/02397fe9-c751-4fa3-ba45-9ec662f7006d/maisonobjet2022_1920x1080.png',
      slug: 'emilgroup-maisonobject-2022',
    },
    {
      title: 'Emilceramica showroom: video',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/f7/5d/f75d7fb4-b6c4-4c93-9f24-09b639a058e6/4_mimesis_img_9700.jpg',
      slug: 'emilceramica-showroom-video',
    },
    {
      title: 'Sixty by Emilceramica: video',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/29/b3/29b3b474-248f-4faf-be72-e3296be5b231/banner_sixty_cielo_60x60_30x60_-_minibrick_lux_talco_amb_bagno.jpg',
      slug: 'sixty-emilceramica-video',
    },
    {
      title: 'EMILGROUP si conferma Top Employer Italia 2022',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/97/7f/977f1ddb-06ab-4ee7-b3e0-66ff0eb862ff/1-home1920x1080.png',
      slug: 'emilgroup-si-conferma-top-employer-italia-2022',
    },
    {
      title: 'Viva showroom: video',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/76/c1/76c1afbe-7d1b-4ad1-a417-6205496fc1c1/3-viva-showroom.png',
      slug: 'viva-showroom-video',
    },
    {
      title: 'Level showroom: video',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/0a/5b/0a5b5292-1f52-47f6-a186-4b745462c0aa/4-level-showroom.png',
      slug: 'level-showroom-video',
    },
    {
      title: 'Provenza showroom: video',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/37/0b/370b3475-69af-4964-8db5-a5888c1176be/2-provenza-showroom.jpeg',
      slug: 'provenza-showroom-video',
    },
    {
      title: 'Ergon showroom: video',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/7e/80/7e802f4f-7976-484a-b2d6-6b93fc188b1c/1-ergon-showroom.png',
      slug: 'ergon-showroom-video',
    },
    {
      title: 'Emilgroup premia il talento con le Borse di studio ai figli dei dipendenti',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/63/0f/630f371b-e66a-44f9-82cc-1ddf92df84a7/banner_studio.jpg',
      slug: 'emilgroup-premia-il-talento-con-le-borse-di-studio-ai-figli-dei-dipendenti',
    },
    {
      title: 'Sixty by Emilceramica è la vincitrice degli Archiproducts Design Awards 2021!',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/3e/a1/3ea18f4a-0d34-4bc4-a170-b682fdb74c4f/bannerlogo-1.png',
      slug: 'sixty-emilceramica-e-la-vincitrice-degli-archiproducts-design-awards-2021',
    },
    {
      title: 'Emilgroup @ICFF NYC',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/f8/30/f830826e-d51d-4698-aea6-aa04e6c14b10/banner-1920x1080-icff-rett.png',
      slug: 'emilgroup-icff-nyc',
    },
    {
      title: 'Unique Marble: Giancarlo Macchioni presents',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/69/cd/69cde5cc-601d-43be-8efa-2942fd838869/unique_marble_calacatta_regale_120x278_ambra-resin_amb_bar.jpg',
      slug: 'unique-marble-giancarlo-macchioni-presents',
    },
    {
      title: 'Landscape selezionata per ADI Design Index 2021',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/0b/09/0b09c47a-76d5-4748-af29-7aa5ead32dfb/banner_adidesignindex21.jpg',
      slug: 'landscape-selezionata-adi-design-index-2021',
    },
    {
      title: 'Menzione Speciale ADI Design per Unique Marble by Provenza',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/e1/e8/e1e82c51-31c0-4191-9fd9-1e905641045a/articolo_testata_dsc_6432.jpg',
      slug: 'menzione-speciale-adi-design-unique-marble-provenza',
    },
    {
      title: 'Tele di Marmo Onyx: Giancarlo Macchioni presents',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/92/17/921751c9-e6ba-4b78-8ade-f9658f5fc5e8/tdm_onyx_ivory_90x180_blue_120x278_mosaico_intrecci_ivory_amb_bagno.jpg',
      slug: 'tele-di-marmo-onyx-giancarlo-macchioni-presents',
    },
    {
      title: 'Mimesis: Giancarlo Macchioni presents',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/b4/05/b4059a14-1007-4bfe-b30a-dff9a593e1b6/mimesis_avorio_265x160_amb_cucina.jpg',
      slug: 'mimesis-giancarlo-macchioni-presents',
    },
    {
      title: 'Sixty: Giancarlo Macchioni presents',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/b3/82/b382baa8-9257-4be5-85bd-1b1594120676/sixty_cenere_120x120_-_esagona_cielo_amb_bar.jpg',
      slug: 'sixty-giancarlo-macchioni-presents',
    },
    {
      title: 'Oros Stone: Giancarlo Macchioni presents',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/25/b8/25b8ba5d-383e-4b7b-803f-2c4204d1c347/oros_stone_sand_60x120-splitstone_amb_living.jpg',
      slug: 'oros-stone-giancarlo-macchioni-presents',
    },
    {
      title: 'Cersaie 2021',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/aa/41/aa41d667-611d-40e1-bcb7-0750d000e7b1/banner_open_weekcersaie.jpg',
      slug: 'cersaie-2021',
    },
    {
      title: 'Emilgroup @ Milano Design Week 2021',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/2d/94/2d94e7a7-86ef-4ea2-9ed4-c09aa2287c53/dsc_0055.jpg',
      slug: 'emilgroup-milano-design-week-2021',
    },
    {
      title: 'Celebration is coming soon...',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/05/e7/05e7fc36-e4fd-4f52-92e4-78d3b52936c8/video_teaser_space.jpg',
      slug: 'celebration-coming-soon',
    },
    {
      title: 'Stone Project by Ergon premiata al CERAMICS OF ITALY TILE COMPETITION 2021',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/c9/c2/c9c2d1fc-c1e0-4f48-86de-6b2074bc48ca/banner_niagara_college.jpg',
      slug: 'stone-project-ergon-premiata-al-ceramics-italy-tile-competition-2021',
    },
    {
      title: 'Re-Play Concrete by Provenza: video',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/c8/d7/c8d7fa5c-0ffb-4670-86dc-d203d7198da3/replay_banner_art_video.jpg',
      slug: 're-play-concrete-provenza-video',
    },
    {
      title: 'Re-Play Concrete by Provenza',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/11/f7/11f7539b-afd3-44b8-810d-0d2d3c2127dc/replay_banner.jpg',
      slug: 're-play-concrete-provenza',
    },
    {
      title: 'Virtual tour TechnicaLab Emilgroup',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/b1/e8/b1e8b2e3-be0a-4b15-bf87-41bd6911f8e1/areatecnica_banner.jpg',
      slug: 'virtual-tour-technicalab-emilgroup',
    },
    {
      title: 'Level nuovi colori 2021',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/74/79/7479d516-1aee-4a83-8fad-a28c3624404d/nuovicolorilevel_banner.jpg',
      slug: 'level-nuovi-colori-2021',
    },
    {
      title: 'Level nuovo spessore 20MM',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/a3/5e/a35e13c9-de40-4750-ac28-1c14788647f3/banner_20mm_level.jpg',
      slug: 'level-nuovo-spessore-20mm',
    },
    {
      title: 'Elegance Pro by Ergon: video',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/28/5c/285c4056-05ea-4fb6-8494-8011a3f5cc70/banner_video_elegancepro.png',
      slug: 'elegance-pro-ergon-video',
    },
    {
      title: 'Nuova Area Qualità Emilgroup',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/63/85/63855987-e116-43c3-a1d4-7f7d4f08ba23/areaqualita_banner_testata.jpg',
      slug: 'nuova-area-qualita-emilgroup',
    },
    {
      title: 'Elegance Pro by Ergon: social video',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/43/0b/430b9aa6-b739-48fc-9101-fc1cd78a3dc4/elegancepro_banner.jpg',
      slug: 'elegance-pro-ergon-social-video',
    },
    {
      title: 'Shield: il video',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/7c/ee/7cee00bd-1f7e-42eb-91f6-330d7e676485/shield_video_articolo.png',
      slug: 'shield-il-video',
    },
    {
      title: 'Unique Travertine by Provenza: video',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/be/d4/bed48e0a-d5d4-4cc9-bc14-88491b6ea60d/articolo_video_uniquetravertine.jpg',
      slug: 'unique-travertine-provenza-video',
    },
    {
      title: 'Tele di Marmo Selection by Emilceramica: video',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/20/39/203999d4-119f-4a5e-9bea-fba5aaa7ec1f/tdm_selection_testata_articolo.jpg',
      slug: 'tele-di-marmo-selection-emilceramica-video',
    },
    {
      title: 'Shield: il processo antibatterico per la ceramica',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/0c/46/0c46adec-0f04-4941-98d4-9730c1cc36d1/shield_banner.jpg',
      slug: 'shield-il-processo-antibatterico-la-ceramica',
    },
    {
      title: 'Emilgroup è certificata Top Employers 2021',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/b7/cf/b7cf3b46-4e86-49bc-a622-061db8a8067c/banner-sito-1920x1080-new.png',
      slug: 'emilgroup-e-certificata-top-employers-2021',
    },
    {
      title: 'Unique Travertine by Provenza: social video',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/13/63/1363bd93-a6f5-436f-bfa9-b09768f6347d/unique_travertine_video_social_banner-1920x1080.png',
      slug: 'unique-travertine-provenza-social-video',
    },
    {
      title: 'Shield: il processo antibatterico per la ceramica',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/76/58/7658ab23-964e-4a20-88a1-e0e66c0b8363/shieldtestata_copia.jpg',
      slug: 'shield-il-processo-antibatterico-per-la-ceramica',
    },
    {
      title: 'Landscape by Emilceramica: video',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/42/88/428827fe-b7c2-4bc6-948c-12e6fc891150/landscape_sabbia_80x80_40x80_-_rigato_amb_bagno.jpg',
      slug: 'landscape-emilceramica-video',
    },
    {
      title: 'Emil Design Lab si rinnova e apre le sue porte virtuali',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/31/bf/31bff573-8f5d-4197-a3f8-c3e1cb0f5c26/thumbnail_02_emil_lab.jpg',
      slug: 'emil-design-lab-si-rinnova-e-apre-le-sue-porte-virtuali',
    },
    {
      title: 'Ergon Showroom: coming soon',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/0c/25/0c25d568-f056-4104-a2fb-4dd7a7f3d705/ergonshowroom.jpg',
      slug: 'ergon-showroom-coming-soon',
    },
    {
      title: "Medley by Ergon vincitrice dell'ADA 2020",
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/ad/9a/ad9a35a2-ef55-46a9-9969-2f60e49d4a0b/news_ergon_1b.jpg',
      slug: 'medley-vince-archiproducts-design-awards-2020',
    },
    {
      title: 'Metallica by Viva: video',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/63/99/6399d536-06c5-4f50-ba3c-de19591d80ab/2_metallica_immagine-testata.jpg',
      slug: 'metallica-viva-video',
    },
    {
      title: 'Emilgroup Technicalab',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/bc/6d/bc6d5bfb-65cc-4c05-8c53-7eab51272b28/pavego_ampia_02_00185.jpg',
      slug: 'emilgroup-technicalab',
    },
    {
      title: 'Emilgroup @ Digital Forum 2020',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/f4/56/f45649f5-aeba-478e-a05c-db64d04a5ff1/1badge_07.jpg',
      slug: 'emilgroup-digital-forum-2020',
    },
    {
      title: 'Emil Design Lab',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/b0/c8/b0c81784-bfc6-4941-b28e-63b76f27eb09/2_emil_labmilano.jpg',
      slug: 'emil-design-lab-teaser',
    },
    {
      title: 'Medley by Ergon: video',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/fa/0f/fa0f647d-5192-4a5e-bf4e-51a9e6bcb59e/medley_blue_60x120_minimal-pop_white_minimal-pop_amb_bagno.jpg',
      slug: 'medley-ergon-video',
    },
    {
      title: 'Tele di Marmo Revolution by Emilceramica: video',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/34/cb/34cbb983-2f4b-490d-bcce-78fb3a6159fc/immagine-testata_tele-di-marmo-video.jpg',
      slug: 'tele-di-marmo-revolution-emilceramica-video',
    },
    {
      title: 'Totalook by Emilceramica: video',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/05/8b/058b94cf-9c5e-4396-967e-8498d57d9f34/11immagine-testata_totalook-video.jpg',
      slug: 'totalook-emilceramica-video',
    },
    {
      title: 'Unique Bleu by Provenza: video',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/d0/10/d010d1aa-0afb-4d97-b722-fe32e60df5a2/immagine-testata_unique-bleu-by-provenza.jpg',
      slug: 'unique-bleu-provenza-video',
    },
    {
      title: 'Provenza premiata al Ceramics of Italy Tile Competition 2020',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/7e/b3/7eb36275-c9ec-411c-857c-8de9172ea2fa/immagine-testata_provenza-premiata-citc.jpg',
      slug: 'provenza-premiata-al-ceramics-italy-tile-competition-2020',
    },
    {
      title: 'Emilgroup @ Euroshop 2020',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/31/13/311353c4-a320-4133-90e7-e602ef9c7c7d/immagine-testata_euroshop-2020-video.png',
      slug: 'emilgroup-euroshop-2020',
    },
    {
      title: 'Madrid Casa Decor 2020',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/e3/d9/e3d9d5ef-c2f3-4013-ab3b-07921eae9110/immagine-testata_madrid-casa-decor-2020.png',
      slug: 'madrid-casa-decor-2020',
    },
    {
      title: 'Showroom @ Paris',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/2a/96/2a96babd-472d-4d43-94ae-8b81b6514c0d/immagine-testata_showreel-nel-cuore-parigi.jpg',
      slug: 'showroom-paris',
    },
    {
      title: 'Emilgroup @ Euroshop - Dusseldorf',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/5a/31/5a314c01-1fd0-4918-b19a-9909a8cf4ad0/euroshopeuroshop-1920x1280-desktop.png',
      slug: 'emilgroup-euroshop-dusseldorf',
    },
    {
      title: 'Emilgroup è certificata Top Employers 2020',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/f0/ca/f0cad9e1-a2b1-4f54-aff4-fe9b0a0fbce5/immagine-testata_top-employers-ita.png',
      slug: 'emilgroup-e-certificata-top-employers-2020',
    },
    {
      title: 'Provenza @ Cersaie 2019',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/a7/78/a77896d9-d93e-4f01-ad0d-7bbc79db7510/immagine-testata_video-provenza-cersaie-2019.jpg',
      slug: 'provenzacersaie-2019',
    },
    {
      title: 'Ergon @ Cersaie 2019',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/cd/55/cd551e60-9d71-43b4-8832-0327beb82682/immagine-testata_video-ergon-cersaie-2019.jpg',
      slug: 'ergoncersaie-2019',
    },
    {
      title: 'Emilceramica @ Cersaie 2019',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/30/79/3079ea8d-dc90-43b4-aece-3e0d36a34b3f/immagine-testata_emilceramica-cersaie-2019.jpg',
      slug: 'emilceramicacersaie-2019',
    },
    {
      title: 'Level @ Bdny',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/0e/f5/0ef5509b-72a5-48ea-9db5-21e00f4879a5/immagine-testata_level-bdny.png',
      slug: 'levelbdny',
    },
    {
      title: 'Emilgroup @ Klimahouse 2020',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/f6/3d/f63d777c-2e5d-420a-8a5e-d5ef9bd54673/immagine-testata_klimahouse.png',
      slug: 'emilgroupklimahouse-2020',
    },
    {
      title: 'Level @ Kbis - Las Vegas',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/c2/85/c2852acb-e8df-4afd-a2d4-67c1d9040557/immagine-testata_kbis.png',
      slug: 'level-kbis-las-vegas',
    },
    {
      title: 'Viva @ Cersaie 2019',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/99/b4/99b4c0af-063d-4aff-ab2e-80878507c140/immagine-testata_video-viva-cersaie-2019.jpg',
      slug: 'vivacersaie-2019',
    },
    {
      title: 'Emilgroup @ Cersaie 2019',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/da/ce/dace2ef2-cad9-42b6-9be3-494476463422/immagina-testata_emilgroup-cersaie-2019.jpg',
      slug: 'emilgroup-cersaie-2019',
    },
    {
      title: 'Emilgroup @ Made Expo 2019',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/d0/98/d098957c-498e-4cf4-b98d-024d064aa783/immagine-testata_emilgroup-made-expo-2019.png',
      slug: 'emilgroup-made-expo-2019',
    },
    {
      title: 'Showroom a Parigi',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/fb/2e/fb2ed52c-fe89-4b21-ae10-8313ebeeba91/immagine-testata_showroom-parigi.jpg',
      slug: 'showroom-parigi',
    },
    {
      title: 'Emilgroup @ Coverings 2019',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/9d/39/9d393523-a0ad-436f-b3b8-f2c43301fe89/immagine-testata_coverings-2019.png',
      slug: 'emilgroup-coverings-2019',
    },
    {
      title: 'Milano Design Week 2019',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/e5/87/e587a99b-cee4-4d01-a06d-b609a71c420a/immagine-testata_milano-design-week.jpg',
      slug: 'milano-design-week-2019',
    },
    {
      title: 'Emilgroup è Top Employers Italia 2019',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/bd/77/bd770b56-a3a8-4b5f-bb94-aba2a218f31b/emilgroup_-22_e_23_novembre_2017-256.jpg',
      slug: 'emilgroup-e-top-employers-italia-2019',
    },
  ],
}

export const mockHomepage = {
  brands: [
    {
      id: '3',
      slug: 'provenza',
      nome: 'Provenza',
      immagineHome:
        'https://www.emilgroup.it/media/filer_public/e7/2e/e72e92aa-d50f-4996-86a6-c07271d51512/brand_-_provenza.jpg',
      logoTransparent:
        'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Provenza_Bianco_Logo Brand Stiky Menu_365x122_Fondo Trasparente-1.png',
    },
    {
      id: '2',
      slug: 'ergon',
      nome: 'Ergon',
      immagineHome:
        'https://www.emilgroup.it/media/filer_public/fe/54/fe54ab2a-5f24-4b2c-8345-15b6cc7c6f2c/brand_-_ergon.jpg',
      logoTransparent:
        'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Ergon_Logo_RGB_web_bianco.png',
    },
    {
      id: '4',
      slug: 'viva',
      nome: 'Viva',
      immagineHome:
        'https://www.emilgroup.it/media/filer_public/29/11/29113089-5404-42d9-89d9-6a65938a3a68/brand_viva.jpg',
      logoTransparent:
        'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Viva_Bianco_Logo Brand Stiky Menu_365x122_Fondo Trasparente-1.png',
    },
    {
      id: '7',
      slug: 'level',
      nome: 'Level',
      immagineHome:
        'https://www.emilgroup.it/media/filer_public/8f/0a/8f0a4a7d-535a-4193-ba3d-3d54c4a3c14c/level_lagunablanca_cavalletto_living.jpg',
      logoTransparent:
        'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Level_Bianco_Logo Brand Stiky Menu_365x122_Fondo Trasparente-1.png',
    },
    {
      id: '1',
      slug: 'emilceramica',
      nome: 'Emilceramica',
      immagineHome:
        'https://www.emilgroup.it/media/filer_public/95/38/9538a08e-791b-4c0f-b38f-af0e23a128a2/tdm_lumia_ivory_gioiello_labradorite_120x278_amb_bagno.jpg',
      logoTransparent:
        'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Emil_Bianco_Logo Brand Stiky Menu_365x122_Fondo Trasparente-1.png',
    },
  ],
  soluzioni: [
    {
      id: '7',
      slug: 'soluzioni-in-gres-porcellanato-per-interni',
      title: 'Soluzioni in gres porcellanato Emilgroup',
      image:
        'https://www.emilgroup.it/media/filer_public/3b/e2/3be25dae-b202-407c-a17a-94b1a9a67743/soluzione_per_interni_1.png',
    },
    {
      id: '4',
      slug: 'piastrelle-in-gres-per-esterni',
      title: 'Soluzioni in gres porcellanato per gli esterni',
      image:
        'https://www.emilgroup.it/media/filer_public/cb/4d/cb4dceb9-af20-4cbf-a123-eb20dfda0e1e/mapierre_beige_ancienne_20x20-20x40-60x120_amb_terrazza.jpg',
    },
    {
      id: '2',
      slug: 'piastrelle-in-gres-facciate-ventilate',
      title: 'Facciate ventilate',
      image:
        'https://www.emilgroup.it/media/filer_public/b1/36/b1366976-f267-4c33-ae2d-285049da2351/pagina_soluzioni_testata_soluzioni_facciate_ventilate_20180511_093317.jpg',
    },
    {
      id: '3',
      slug: 'piastrelle-in-gres-grandi-lastre-level',
      title: 'Piastrelle grandi lastre Level',
      image:
        'https://www.emilgroup.it/media/filer_public/da/f9/daf933c3-d9b3-401a-bd41-d9683bc3caac/pagina_soluzioni_testata_soluzioni_countertop_quarzo_nat-lapp_luc_162x324_amb_bagno.jpg',
    },
    {
      id: '5',
      slug: 'piastrelle-in-gres-grandi-lastre-level',
      title: 'Piastrelle grandi lastre Level',
      image:
        'https://www.emilgroup.it/media/filer_public/da/f9/daf933c3-d9b3-401a-bd41-d9683bc3caac/pagina_soluzioni_testata_soluzioni_countertop_quarzo_nat-lapp_luc_162x324_amb_bagno.jpg',
    },
  ],
  collezioni: [
    {
      pk: 100001,
      url: '/collezioni/brand/emilceramica/stonehenge/',
      title: 'Stonehenge ',
      nome: 'Stonehenge ',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Stonehenge_001.jpg',
      },
    },
    {
      pk: 100000,
      url: '/collezioni/brand/emilceramica/slabs-usa/',
      title: 'SLABS USA',
      nome: 'SLABS USA',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Ergon_Slabs_001.jpg',
      },
    },
    {
      pk: 100002,
      url: '/collezioni/brand/emilceramica/aurelia-stone/',
      title: 'Aurelia Stone ',
      nome: 'Aurelia Stone ',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/AureliaStone_DarkGrey_Amb_Bar_gallery.jpg',
      },
    },
    {
      pk: 100003,
      url: '/collezioni/brand/emilceramica/essential-brick/',
      title: 'Essential Brick',
      nome: 'Essential Brick',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/001_Ergon_EssentialBrick_Cucina_generale_HR_gallery.jpg',
      },
    },
    {
      pk: 897,
      url: '/collezioni/brand/emilceramica/be-square/',
      title: 'Be-Square',
      nome: 'Be-Square',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Be-Square Sand 120x278 Amb. Hall.jpg',
      },
    },
    {
      pk: 904,
      url: '/collezioni/brand/emilceramica/eterna/',
      title: 'Eterna',
      nome: 'Eterna',
      listingImage: null,
    },
    {
      pk: 1141,
      url: '/collezioni/brand/emilceramica/concept3/',
      title: 'CONCEPT3',
      nome: 'CONCEPT3',
      listingImage: null,
    },
    {
      pk: 923,
      url: '/collezioni/brand/emilceramica/millelegni/',
      title: 'Millelegni',
      nome: 'Millelegni',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_Millelegni_009.jpg',
      },
    },
    {
      pk: 896,
      url: '/collezioni/brand/emilceramica/brick-design/',
      title: 'Brick Design',
      nome: 'Brick Design',
      listingImage: null,
    },
    {
      pk: 917,
      url: '/collezioni/brand/emilceramica/kotto/',
      title: 'Kotto',
      nome: 'Kotto',
      listingImage: null,
    },
  ],
  effetti: [
    {
      id: 3,
      title: 'Cemento',
      slug: 'cemento',
      imageUrl:
        'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_Be-Square_001.jpg',
    },
    {
      id: 5,
      title: 'Marmo',
      slug: 'marmo',
      imageUrl:
        'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_Tele_Di_Marmo_001.jpg',
    },
    {
      id: 7,
      title: 'Metallo',
      slug: 'metallo',
      imageUrl:
        'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Viva_Metallica_Logo.jpg',
    },
    {
      id: 4,
      title: 'Pietra',
      slug: 'pietra',
      imageUrl:
        'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_Chateaux_002.jpg',
    },
  ],
  progetti: [
    {
      id: 22,
      slug: 'restyling_aquapark_tatralandia',
      title: 'Restyling Aquapark Tatralandia ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/aquapark-tatralandia_gallery-1.jpg',
      destinazione: 'Cultura e tempo libero',
    },
    {
      id: 21,
      slug: 'restyling_ristorante_visconti',
      title: 'Restyling Ristorante Visconti ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/ristorante-visconti_gallery-1.jpg',
      destinazione: 'Ristorazione',
    },
    {
      id: 12,
      slug: 'restyling_cormorano_hotel',
      title: 'Restyling Cormorano Hotel ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/cormorano-hotel_gallery-2.jpg',
      destinazione: 'Hotel',
    },
    {
      id: 31,
      slug: 'restyling_aziendale_sede_promens',
      title: 'Restyling aziendale sede Promens ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/sede-promens_gallery-1.jpg',
      destinazione: 'Uffici e industrie',
    },
    {
      id: 14,
      slug: 'holy_name_of_jesus_cathedral',
      title: 'Holy Name of Jesus Cathedral',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/holychurch_gallery-1.jpg',
      destinazione: 'Edifici pubblici e di culto',
    },
    {
      id: 29,
      slug: 'restyling_piscina_residenziale_zlin',
      title: 'Restyling piscina residenziale Zlin ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/piscina-res-zin_immagine-testata.jpg',
      destinazione: 'Residenziale',
    },
    {
      id: 28,
      slug: 'ampliamento_centro_commerciale_iso_omena',
      title: 'Ampliamento centro commerciale Iso Omena ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/iso-omena_gallery-1.jpg',
      destinazione: null,
    },
    {
      id: 27,
      slug: 'restyling_aziendale_sede_pluricart',
      title: 'Restyling aziendale sede Pluricart',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/pluricart_immagine gallery-1.jpg',
      destinazione: 'Uffici e industrie',
    },
    {
      id: 24,
      slug: 'nuovo_design_della_residenza_isla_de_fuego',
      title: 'Nuovo Design della residenza Isla de Fuego ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/isla-de-fuego_immagine-testata.jpg',
      destinazione: 'Residenziale',
    },
    {
      id: 4,
      slug: 'residenza_moscoso',
      title: 'Residenza Moscoso ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/moscoso_gallery-1.jpg',
      destinazione: 'Residenziale',
    },
    {
      id: 17,
      slug: 'restyling_ristorante_drassana_medbar_el_campello',
      title: 'Restyling ristorante Drassana Medbar El Campello',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/dressana-med-bar_gallery-2.jpg',
      destinazione: 'Ristorazione',
    },
    {
      id: 18,
      slug: 'restyling_sport_club',
      title: 'Restyling Sport Club ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/sport-club-impuls_gallery-1.jpg',
      destinazione: 'Salute, benessere e fitness',
    },
    {
      id: 30,
      slug: 'restyling_tsing_yi_southwest_leisure_building',
      title: 'Restyling Tsing Yi Southwest Leisure Building',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/tsing-yi-southwest_gallery-1.jpg',
      destinazione: 'Uffici e industrie',
    },
    {
      id: 23,
      slug: 'restyling_resort_the_ridge_a_lake_geneva',
      title: 'Restyling resort The Ridge a Lake Geneva ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/lake-geneva_gallery-3.jpg',
      destinazione: 'Hotel',
    },
    {
      id: 16,
      slug: 'riqualificazione_vivienda',
      title: 'Riqualificazione Vivienda',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/vivienda_gallery-1.jpg',
      destinazione: 'Residenziale',
    },
    {
      id: 11,
      slug: 'restyling_astoria_hotel_bologna',
      title: 'Restyling Astoria Hotel, Bologna ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/astoria-boutique-hotel_gallery-3.jpg',
      destinazione: 'Hotel',
    },
    {
      id: 13,
      slug: 'il_restyling_di_villaverde_hotel-resort',
      title: 'Il restyling di Villaverde Hotel&Resort',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/golfclubudine_gallery-1.jpg',
      destinazione: 'Hotel',
    },
    {
      id: 10,
      slug: 'ristorante_nishiki',
      title: 'Ristorante Nishiki ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/ristorante-nishiki_gallery-1.jpg',
      destinazione: 'Ristorazione',
    },
    {
      id: 9,
      slug: 'ristorante_aimo_e_nadia_milano',
      title: 'Ristorante Aimo e Nadia, Milano ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/il-luogo-di-aimo-e-nadia_gallery-1.jpg',
      destinazione: 'Ristorazione',
    },
    {
      id: 8,
      slug: 'restyling_ristorante_niwa',
      title: 'Restyling ristorante Niwa',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/ristorante-niwa_immagine testata.jpg',
      destinazione: 'Ristorazione',
    },
    {
      id: 6,
      slug: 'riqualificazione_jameson_distillery_bow_st_',
      title: 'Riqualificazione Jameson Distillery Bow St. ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/jameson-distillery_gallery-1.jpg',
      destinazione: 'Ristorazione',
    },
    {
      id: 20,
      slug: 'riqualificazione_immobile_residenziale',
      title: 'Riqualificazione immobile Residenziale',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/via-genone_immagine-testata.jpg',
      destinazione: 'Residenziale',
    },
    {
      id: 19,
      slug: 'design_sede_emilgroup',
      title: 'Design sede Emilgroup ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/facciate-ventilate_gallery-1.jpg',
      destinazione: 'Uffici e industrie',
    },
    {
      id: 26,
      slug: 'restyling_villa_a_modena',
      title: 'Restyling Villa a Modena ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/villa-modena_gallery-3.jpg',
      destinazione: 'Residenziale',
    },
    {
      id: 25,
      slug: 'restyling_alessi_store',
      title: 'Restyling Alessi Store ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/alessi-store_gallery-1.jpg',
      destinazione: 'Commerciale',
    },
    {
      id: 5,
      slug: 'mizuno_store_torino',
      title: 'Mizuno Store Torino ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/mizuno-store_immagine-testata.jpg',
      destinazione: 'Commerciale',
    },
    {
      id: 15,
      slug: 'restyling_club_herradura',
      title: 'Restyling Club Herradura ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/herradura_gallery-1.jpg',
      destinazione: 'Residenziale',
    },
    {
      id: 32,
      slug: 'restyling_salotto_regina',
      title: 'Restyling Salotto Regina',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/SalottoRegina_imgTESTATA.JPG',
      destinazione: 'Ristorazione',
    },
    {
      id: 33,
      slug: 'ristrutturazione_di_una_villa_a_valencia',
      title: 'Ristrutturazione di una villa a Valencia',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/progetto_testata.jpg',
      destinazione: 'Residenziale',
    },
    {
      id: 34,
      slug: 'turbo_milano',
      title: 'Turbo Milano',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/Turbo_Testata_1920x1080.jpg',
      destinazione: 'Ristorazione',
    },
    {
      id: 35,
      slug: 'nuova_residenza_a_pinerolo',
      title: 'Nuova Residenza a Pinerolo',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/1Pinerolo_img_testata.jpg',
      destinazione: 'Residenziale',
    },
    {
      id: 36,
      slug: 'delices_ditalie',
      title: 'Délices d’Italie',
      imageUrl: 'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/delice_testata.jpg',
      destinazione: 'Commerciale',
    },
    {
      id: 37,
      slug: 'nuovi_appartamenti_residenziali_a_cipro',
      title: 'Nuovi appartamenti residenziali a Cipro',
      imageUrl: 'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/Banner_Kileton.jpg',
      destinazione: 'Residenziale',
    },
    {
      id: 38,
      slug: 'hotel_a_londra',
      title: 'Hotel a Londra',
      imageUrl: 'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/banner_nyx.jpg',
      destinazione: 'Hotel',
    },
    {
      id: 39,
      slug: 'vibrazioni_trendy_per_un_bagno_privato',
      title: 'Vibrazioni trendy per un bagno privato',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/banner_proposta2.jpg',
      destinazione: 'Residenziale',
    },
    {
      id: 40,
      slug: 'ristorante_giapponese_kekomo',
      title: 'Ristorante giapponese Kekomo',
      imageUrl: 'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/KEKOMO_1.jpg',
      destinazione: 'Ristorazione',
    },
    {
      id: 41,
      slug: 'ristrutturazione_di_unabitazione_ad_alicante',
      title: 'Ristrutturazione di un’abitazione ad Alicante',
      imageUrl: 'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/banner_alicante.jpg',
      destinazione: 'Residenziale',
    },
    {
      id: 42,
      slug: 'legno_e_ceramica_insieme_per_un_ristorante_di_charme',
      title: 'Legno e ceramica insieme per un ristorante di charme',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/Banner_NickysCatwalk.jpg',
      destinazione: 'Ristorazione',
    },
    {
      id: 43,
      slug: 'soluzioni_innovative_e_raffinate_per_loutdoor',
      title: 'Soluzioni innovative e raffinate per l’outdoor',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/Banner_villaKarman.jpg',
      destinazione: 'Residenziale',
    },
    {
      id: 44,
      slug: 'riserva_naturale_privata_kapama_river_lodge',
      title: 'Riserva naturale privata Kapama River Lodge',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/banner_Kapama progetto.jpg',
      destinazione: 'Hotel',
    },
    {
      id: 45,
      slug: 'un_complesso_studentesco_innovativo_e_funzionale',
      title: 'Un complesso studentesco innovativo e funzionale',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/banner_Niagara College.jpg',
      destinazione: 'Edifici pubblici e di culto',
    },
    {
      id: 46,
      slug: 'circondati_da_briciole_di_waffles',
      title: 'Circondati da briciole di waffles',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/banner_gelateria Katzefet.jpg',
      destinazione: 'Commerciale',
    },
    {
      id: 47,
      slug: 'eleganza_sontuosa_per_una_villa_privata',
      title: 'Eleganza sontuosa per una villa privata',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/banner_casa sudafrica.jpg',
      destinazione: 'Residenziale',
    },
    {
      id: 48,
      slug: 'un_armonioso_dialogo_tra_natura_e_pietra_calcarea',
      title: 'Un armonioso dialogo tra natura e pietra calcarea ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/_DSC1855Thomahof Pool21 - Banner.jpg',
      destinazione: 'Hotel',
    },
    {
      id: 49,
      slug: 'attico_con_vista_a_seoul',
      title: 'Attico con vista a Seoul ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/Banner - UNIQUE TRAVERTINE_INTERIOR BIDI_SANGAHTILE _22_.jpg',
      destinazione: 'Residenziale',
    },
    {
      id: 50,
      slug: 'un_terrazzo_in_centro_moderno_ed_elegante',
      title: 'Un terrazzo in centro moderno ed elegante ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/Banner - Pinelli_Gariselli-Botti_8090b_X.jpg',
      destinazione: 'Residenziale',
    },
    {
      id: 51,
      slug: 'la_funzionalita_incontra_il_design',
      title: 'La funzionalità incontra il design ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/Banner - _79A0645-HDR.jpg',
      destinazione: 'Residenziale',
    },
    {
      id: 52,
      slug: 'lo_stile_rustrial_per_linterior_design',
      title: 'Lo stile Rustrial per l’interior design ',
      imageUrl: 'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/IMG_3873.JPEG',
      destinazione: 'Residenziale',
    },
    {
      id: 53,
      slug: 'i_colori_e_le_forme_della_dolcezza',
      title: 'I colori e le forme della dolcezza',
      imageUrl: 'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/Barra.jpg',
      destinazione: 'Commerciale',
    },
    {
      id: 54,
      slug: 'bere_un_drink_non_e_mai_stato_cosi_chic',
      title: 'Bere un drink non è mai stato così chic ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/87b81f27-98f9-45ca-bd64-5a621939c1ea.jpg',
      destinazione: 'Commerciale',
    },
    {
      id: 55,
      slug: 'un_incontro_di_stili_per_una_pausa_caffe_originale',
      title: 'Un incontro di stili per una pausa caffè originale',
      imageUrl: 'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/1-7_.jpg',
      destinazione: 'Commerciale',
    },
    {
      id: 56,
      slug: 'modernita_e_accoglienza_per_un_business_ad_alta_quota',
      title: 'Modernità e accoglienza per un business ad alta quota',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/Banner Ufficio Istanbul.jpg',
      destinazione: 'Uffici e industrie',
    },
    {
      id: 57,
      slug: 'il_marmo_incanta_barcellona',
      title: 'Il marmo incanta Barcellona ',
      imageUrl: 'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/_MG_0354_banner.jpg',
      destinazione: 'Interni ed Esterni',
    },
    {
      id: 58,
      slug: 'unesperienza_di_shopping_unica',
      title: 'Un’esperienza di shopping unica',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/Banner - IMG_8128.jpg',
      destinazione: 'Interni ed Esterni',
    },
    {
      id: 60,
      slug: 'lospitalita_italiana_tra_passato_e_presente',
      title: 'L’ospitalità italiana tra passato e presente',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/Banner - DJI_0356.jpg',
      destinazione: 'Interni ed Esterni',
    },
    {
      id: 61,
      slug: 'laffascinante_eleganza_del_marmo',
      title: 'L’affascinante eleganza del marmo ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/Banner - orom-utca-interior-1.jpg',
      destinazione: 'Residenziale',
    },
    {
      id: 7,
      slug: 'residenze_di_design',
      title: 'Residenze di design ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/via-vico_gallery-1.jpg',
      destinazione: 'Residenziale',
    },
    {
      id: 62,
      slug: 'babenberger_passage_disco_pop_e_rock_tra_musica_e_design',
      title: 'Babenberger Passage Disco: Pop e Rock tra musica e design',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/BANNER - Babenberger_Passage_2021__c_ SRS_Architekten_NikolausMautnerMarkhof-101.jpg',
      destinazione: null,
    },
    {
      id: 63,
      slug: 'tribes_store_un_negozio_oltre_ogni_dimensione',
      title: 'Tribes Store: un negozio oltre ogni dimensione ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/Banner - 6 Tribes.jpg',
      destinazione: 'Commerciale',
    },
    {
      id: 64,
      slug: 'il_gusto_messicano_in_polonia',
      title: 'Il gusto messicano in Polonia ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/BANNER - kultura projektowania_restaurant 2.jpg',
      destinazione: 'Commerciale',
    },
    {
      id: 65,
      slug: 'linsuperabile_raffinatezza_delleffetto_legno',
      title: 'L’insuperabile raffinatezza dell’effetto legno ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/Banner Casa Germania 20Twenty.jpg',
      destinazione: 'Residenziale',
    },
    {
      id: 66,
      slug: 'una_clinica_con_un_grande_carisma',
      title: 'Una clinica con un grande carisma ',
      imageUrl: 'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/_W5A0014small.jpg',
      destinazione: null,
    },
    {
      id: 67,
      slug: 'una_nuova_esperienza_di_shopping',
      title: 'Una nuova esperienza di shopping',
      imageUrl: 'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/IMG_1408.JPEG',
      destinazione: 'Commerciale',
    },
    {
      id: 68,
      slug: 'una_casa_vacanze_alternativa',
      title: 'Una casa vacanze alternativa ',
      imageUrl: 'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/banner.jpg',
      destinazione: 'Residenziale',
    },
    {
      id: 69,
      slug: 'laos_in_town_la_cucina_laotiana_conquista_washington_dc',
      title: 'Laos in Town: la cucina laotiana conquista Washington DC',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/Banner Laos in Town.jpg',
      destinazione: 'Ristorazione',
    },
    {
      id: 70,
      slug: 'benessere_ed_eleganza_il_connubio_perfetto_per_una_clinica_medica_in_polonia',
      title: 'Benessere ed eleganza: il connubio perfetto per una clinica medica in Polonia ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/Banner - image00001 copy.jpg',
      destinazione: 'Salute, benessere e fitness',
    },
    {
      id: 71,
      slug: 'il_piacere_di_vivere_in_piccoli_spazi',
      title: 'Il piacere di vivere in piccoli spazi',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/BANNER - Casa Gialla 4.jpg',
      destinazione: 'Interni ed Esterni',
    },
    {
      id: 72,
      slug: 'un_design_dal_gusto_eccellente',
      title: 'Un design dal gusto eccellente',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/Lahpet West End_Interiors_Credit_ Kathrin Werner_6_.jpg',
      destinazione: 'Ristorazione',
    },
    {
      id: 73,
      slug: 'un_sontuoso_mix_tra_performance_e_design',
      title: 'Un sontuoso mix tra performance e design',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/BANNER SAND FALDA RETT_1_.jpg',
      destinazione: 'Hotel',
    },
    {
      id: 74,
      slug: 'un_viaggio_senza_tempo_tra_cocktail_internazionali_e_design',
      title: 'Un viaggio senza tempo tra cocktail internazionali e design',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/BANNER - 2022_VILLASASSI_LAGEARD_LOWDEF_04.jpg',
      destinazione: 'Commerciale',
    },
    {
      id: 75,
      slug: 'un_design_da_scalare',
      title: 'Un design da scalare',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/BANNER - BAAV_Mood_Dodatkowe_01.jpg',
      destinazione: 'Cultura e tempo libero',
    },
    {
      id: 76,
      slug: 'lo_shopping_si_trasforma_in_unesperienza_esclusiva',
      title: 'Lo shopping si trasforma in un’esperienza esclusiva ',
      imageUrl: 'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/BANNER_IMG_6084.jpg',
      destinazione: 'Commerciale',
    },
    {
      id: 77,
      slug: 'address_beach_resort_il_lusso_della_ceramica_conquista_dubai',
      title: 'Address Beach Resort: il lusso della ceramica conquista Dubai',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/BANNER - PENTHOUSE 1 ADDRESS.jpg',
      destinazione: 'Hotel',
    },
    {
      id: 78,
      slug: 'complesso_residenziale_a_como',
      title: 'Complesso Residenziale a Como',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/BANNER  1691138840_64ccbb18cd297_0.jpg',
      destinazione: 'Esterni',
    },
    {
      id: 79,
      slug: 'wine_resort_conti_thun',
      title: 'Wine Resort Conti Thun',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/1689322920_64b105a84d151_0.jpg',
      destinazione: 'Hotel',
    },
    {
      id: 80,
      slug: 'progetto_looks_house_of_beauty',
      title: 'Progetto Looks House of Beauty',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/BANNER 1690380973_64c12aadb0de9_0.jpg',
      destinazione: 'Commerciale',
    },
    {
      id: 81,
      slug: 'shopping_mall_lippulaiva',
      title: 'Shopping Mall Lippulaiva',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/BANNER 1685613585_64786c115969d_9.jpg',
      destinazione: 'Commerciale',
    },
    {
      id: 82,
      slug: 'bathroom_in_a_private_home',
      title: 'Bathroom in a Private Home',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/1692087821_64db360d083da_4.jpg',
      destinazione: 'Salute, benessere e fitness',
    },
    {
      id: 83,
      slug: 'restyling_contemporaneo_per_uno_studio_dentistico',
      title: 'Restyling contemporaneo per uno studio dentistico',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/1690408195_64c19503f175f_0.jpg',
      destinazione: 'Salute, benessere e fitness',
    },
    {
      id: 84,
      slug: 'una_residenza_accogliente_e_funzionale',
      title: 'Una residenza accogliente e funzionale',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/BANNER 1685010785_646f3961ee950_1.jpg',
      destinazione: 'Residenziale',
    },
    {
      id: 85,
      slug: 'un_loft_dal_tocco_italian_style',
      title: 'Un loft dal tocco italian style',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/1689243099_64afcddbf39c4_0.jpg',
      destinazione: 'Interni ed Esterni',
    },
    {
      id: 86,
      slug: 'il_fascino_elegante_del_travertino',
      title: 'Il fascino elegante del travertino',
      imageUrl: 'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/Uzupis-webres-4.jpg',
      destinazione: 'Residenziale',
    },
    {
      id: 87,
      slug: 'esplorando_le_atmosfere_mediterranee_della_residenza_la_corte_con_le_collezioni_mapierre_landscape_e_level',
      title:
        'Esplorando le atmosfere mediterranee della residenza La Corte con le collezioni Mapierre, Landscape e Level',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/BANNER eal_estate_pictures_DSC00494_extra.jpg',
      destinazione: 'Residenziale',
    },
    {
      id: 88,
      slug: 'armonia_e_design_nel_cuore_della_murcia',
      title: 'Armonia e Design nel cuore della Murcia',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/BANNER 1685007127_646f2b17e2b17_0.jpg',
      destinazione: 'Residenziale',
    },
    {
      id: 89,
      slug: 'arte_e_funzionalita_un_bagno_da_sogno_nel_sottotetto',
      title: 'Arte e Funzionalità: Un Bagno da Sogno nel Sottotetto',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/BANNER 1682622310_644ac76626374_Pink Terrazzo FORMAlinia2.jpg',
      destinazione: 'Residenziale',
    },
    {
      id: 90,
      slug: 'eleganza_e_raffinatezza_per_un_salone_di_bellezza_moderno',
      title: 'Eleganza e Raffinatezza per un salone di bellezza moderno ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/banner 1688736219_64a811dbd3dc6_0.jpg',
      destinazione: 'Commerciale',
    },
    {
      id: 91,
      slug: 'lusso_e_design_il_binomio_perfetto_per_un_hotel_di_prestigio',
      title: 'Lusso e design: il binomio perfetto per un hotel di prestigio',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/BANNER 1688650945_64a6c4c167b1b_1.jpg',
      destinazione: 'Hotel',
    },
    {
      id: 92,
      slug: 'afacial_skinbar_tele_di_marmo_onyx_guida_la_rivoluzione_degli_spazi_dedicati_ai_trattamenti_beauty',
      title:
        'AFACIAL Skinbar: Tele di Marmo Onyx guida la rivoluzione degli spazi dedicati ai trattamenti beauty',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/AFACIAL Skinbar by Carina Haberl Kolozs HIGH RESOLUTION 06.jpg',
      destinazione: 'Commerciale',
    },
    {
      id: 93,
      slug: 'la_bellezza_del_gres_effetto_marmo_sbarca_in_grecia_con_level_marmi_e_tele_di_marmo_reloaded',
      title:
        'La bellezza del gres effetto marmo sbarca in Grecia con Level Marmi e Tele di Marmo Reloaded ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/1684331405_6464db8d96d41_0.jpg',
      destinazione: 'Residenziale',
    },
    {
      id: 94,
      slug: 'una_suite_da_sogno_realizzata_con_tele_di_marmo_precious',
      title: 'Una suite da sogno realizzata con Tele di Marmo Precious',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/BANNER_DSF6979-HDR.jpg',
      destinazione: 'Hotel',
    },
    {
      id: 95,
      slug: 'happy_hours_bacoli_un_ristorante_di_design_unico',
      title: 'Happy Hours Bacoli: Un Ristorante di Design Unico',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/BANNER 1713511439_66221c0f8f72c_0.jpg',
      destinazione: 'Ristorazione',
    },
    {
      id: 98,
      slug: 'oasi_belvedere_spa_wellness_beauty_un_rifugio_di_lusso_nel_cuore_di_locarno',
      title: 'Oasi Belvedere Spa Wellness Beauty: un rifugio di lusso nel cuore di Locarno',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/BANNER 1725022460_66d1c0fce10f4_7.jpg',
      destinazione: 'Hotel',
    },
    {
      id: 99,
      slug: 'terrace_like_a_sandy_beach_un_paradiso_allaperto',
      title: 'Terrace Like a Sandy Beach: un paradiso all’aperto',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/BANNER 1721116865_669628c19fe76_0.jpg',
      destinazione: 'Esterni',
    },
    {
      id: 100,
      slug: 'milano_via_inverigo_4_ristrutturazione_con_stile_e_funzionalita',
      title: 'Milano Via Inverigo 4: Ristrutturazione con Stile e Funzionalità',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/BANNER 1720458022_668c1b263697c_0.jpg',
      destinazione: 'Esterni',
    },
    {
      id: 101,
      slug: 'kenese_bay_garden_hotel_un_rifugio_di_lusso_sul_lago_balaton',
      title: 'Kenese Bay Garden Hotel: Un Rifugio di Lusso sul Lago Balaton',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/BANNER Kenese_Bay-098.jpg',
      destinazione: 'Hotel',
    },
    {
      id: 102,
      slug: 'the_leo_grand_un_hotel_di_lusso_nel_cuore_di_vienna',
      title: 'The Leo Grand: un hotel di lusso nel cuore di Vienna',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/BANNER 1725006369_66d18221b4686_0.jpg',
      destinazione: 'Hotel',
    },
    {
      id: 103,
      slug: 'city_community_center_a_laubach_un_progetto_che_unisce_design_e_funzionalita',
      title: 'City Community Center a Laubach: Un progetto che unisce design e funzionalità',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/1722431851_66aa396b6f57b_0.jpg',
      destinazione: 'Cultura e tempo libero',
    },
  ],
  magazine: [
    {
      id: '429',
      title: 'Ristrutturare casa: errori da evitare in soggiorno, cucina e bagno',
      slug: 'ristrutturare-casa-errori-da-evitare-in-soggiorno-cucina-e-bagno',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/97/57/9757daa7-45e4-4e9f-ae88-4e39a2ca794f/banner_i-wood_imbrunito_20x120_elements_lombarda_sabbia_60x120_amb_bagno.jpg',
      categoriaTitle: 'Ispirazioni',
    },
    {
      id: '422',
      title: 'Pattern Drenching e Color Drenching: le tendenze che trasformano gli spazi',
      slug: 'pattern-drenching-e-color-drenching-le-tendenze-che-trasformano-gli-spazi',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/33/38/33383b95-a074-4cd3-ac97-8a80862f9aca/banner_tdmprecious_brown_agata-crystal_ambra_128x278_amb_hall.jpg',
      categoriaTitle: 'Ispirazioni',
    },
    {
      id: '416',
      title: 'Interior Design e Benessere Mentale: come trasformare il tuo spazio e la tua mente',
      slug: 'interior-design-e-benessere-mentale-come-trasformare-il-tuo-spazio-e-la-tua-mente',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/a6/25/a62547a5-a303-4ef9-b348-7cb0bd828333/banner_unique_travertine_white_vein_cut-minimal_nat_amb_cucina.jpg',
      categoriaTitle: 'Ispirazioni',
    },
    {
      id: '411',
      title: 'Come rendere il tuo bagno lussuoso: idee e consigli',
      slug: 'come-rendere-il-tuo-bagno-lussuoso-idee-e-consigli',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/c5/76/c576f55b-52c1-4390-a507-2f76b603bbc4/banner_tdm_pure_onyx_turchese_lapp_120x278_amb_bagno.jpg',
      categoriaTitle: 'Ispirazioni',
    },
    {
      id: '410',
      title: 'TaOsa Residence: Intervista con l’Arch. Elia Sifodaskalaki',
      slug: 'taosa-residence-intervista-con-larch-elia-sifodaskalaki',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/92/42/9242ef70-241c-48bc-8659-621a6c8a65a3/banner_1684331491_6464dbe36d567_0.jpg',
      categoriaTitle: 'Ispirazioni',
    },
    {
      id: '409',
      title:
        "Il ritorno dei colori caldi nel design d'interni: una tendenza accogliente e vibrante",
      slug: 'il-ritorno-dei-colori-caldi-nel-design-dinterni-una-tendenza-accogliente-e-vibrante',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/3e/10/3e104612-97ef-4801-b6e5-3d24fc4df80b/banner_forme_rosato-terracotta_20x20_amb_cucina.jpg',
      categoriaTitle: 'Ispirazioni',
    },
    {
      id: '408',
      title: "Wabi-Sabi: L'estetica dell'imperfezione nel design d'interni",
      slug: 'wabi-sabi-lestetica-dellimperfezione-nel-design-dinterni',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/3b/30/3b307329-55b5-4a28-8096-e0babe16ff19/banner_i-wood_pallido_24x278_elements_pallido_120x278_pigmento_grigio_b_asalto_amb_dining.jpg',
      categoriaTitle: 'Ispirazioni',
    },
    {
      id: '397',
      title: 'Cucina eccentrica: idee per un ambiente unico e accattivante',
      slug: 'cucina-eccentrica-idee-per-un-ambiente-unico-e-accattivante',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/e1/bc/e1bcaacc-73f8-45cd-a46f-4f128c5f20c9/banner_abacus_carbone_matt-lux_medley_grey_rock_60x120_amb_cucina.jpg',
      categoriaTitle: 'Ispirazioni',
    },
    {
      id: '383',
      title: 'Gres porcellanato lappato: Vantaggi, svantaggi e tecniche di pulizia',
      slug: 'gres-porcellanato-lappato-vantaggi-svantaggi-e-tecniche-di-pulizia',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/c3/f0/c3f096a8-7326-48f6-85fa-88deeda3895a/banner_-_unique_marble_bianco_siena_120x278_resin-ambra_amb__ristorantejpg.jpg',
      categoriaTitle: 'Ispirazioni',
    },
    {
      id: '379',
      title: 'Interni moderni per una casa in montagna: è possibile',
      slug: 'interni-moderni-per-una-casa-in-montagna-e-possibile',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/f6/7e/f67e24a0-2873-4cd0-bfdf-ef1c2aec52e6/banner_-_alter_noce_20x120-dec_intreccio_60x60_amb_bagno.jpg',
      categoriaTitle: 'Ispirazioni',
    },
  ],
}

export const mockBrand = {
  pk: 1,
  nome: 'Emilceramica',
  title: 'Emilceramica',
  description:
    "Dalla selezione dei migliori materiali, all’ideazione delle collezioni, fino alle componenti di servizio post vendita: l'attenzione alla filiera produttiva è trasversale e volta a soddisfare ogni necessità progettuale. La sua mission di Emilceramica è garantire la piena soddisfazione dei consumatori finali, aiutandoli innanzitutto a mettere a fuoco le proprie necessità, e quindi ad assecondarle a 360°, grazie a una conoscenza estremamente approfondita dei propri mercati.",
  immagineStatica: null,
  heroItems: {
    children: [
      {
        name: 'Tele di Marmo Lumia: Risonanza della luce',
        ctaLabel: 'Scopri la collezione',
        image: mockHomepage.magazine[0].imageUrl,
      },
      {
        name: 'Matera Stone: Armonia e innovazione',
        ctaLabel: 'Scopri la collezione',
        image: mockHomepage.magazine[1].imageUrl,
      },
      {
        name: 'Unique Bourgogne: Metamorfosi minerale',
        ctaLabel: 'Scopri la collezione',
        image: mockHomepage.magazine[2].imageUrl,
      },
      {
        name: 'Metallica: l’audacia del metallo',
        ctaLabel: 'Scopri la collezione',
        image: mockHomepage.magazine[3].imageUrl,
      },
      {
        name: 'Level: Nuovi Marmi',
        ctaLabel: 'Scopri la collezione',
        image: mockHomepage.magazine[4].imageUrl,
      },
      {
        name: 'Acif: Italian quality',
        ctaLabel: 'Scopri la collezione',
        image: mockHomepage.magazine[5].imageUrl,
      },
    ],
  },
  correlati: [
    {
      pk: 3,
      nome: 'Provenza',
      logo: 'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Provenza_Logo Brand Intestazione_200x85_Fondo Bianco.jpg',
      immagineStatica: null,
      url: '/collezioni/provenza',
    },
    {
      pk: 2,
      nome: 'Ergon',
      logo: 'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Ergon_Logo_RGB_web.png',
      immagineStatica:
        'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/ERGON_IMMAGINE_STATICA_1.jpg',
      url: '/collezioni/ergon',
    },
    {
      pk: 4,
      nome: 'Viva',
      logo: 'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Viva_Logo Brand Intestazione_200x85_Fondo Bianco.jpg',
      immagineStatica: null,
      url: '/collezioni/viva',
    },
    {
      pk: 7,
      nome: 'Level',
      logo: 'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Level_Logo Brand Intestazione_200x85_Fondo Bianco.jpg',
      immagineStatica: null,
      url: '/collezioni/level',
    },
  ],
  collezioni: [
    {
      pk: 1394,
      nome: 'Tele di Marmo Lumia',
      title: 'Tele di Marmo Lumia',
      slug: 'tele-di-marmo-lumia',
      url: '/collezioni/emilceramica/tele-di-marmo-lumia',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/TDM Lumia Ivory Gioiello Labradorite 120x278 Amb Cucina.jpg',
      },
    },
    {
      pk: 1390,
      nome: 'Ever-Stone',
      title: 'Ever-Stone',
      slug: 'ever-stone',
      url: '/collezioni/emilceramica/ever-stone',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Everstone Grey 100x10 60x120 Amb Bagno.jpg',
      },
    },
    {
      pk: 1389,
      nome: 'Playwood',
      title: 'Playwood',
      slug: 'playwood',
      url: '/collezioni/emilceramica/playwood',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Playwood Intense Playtangram 100x100 Brick 5x30 Amb Living.jpg',
      },
    },
    {
      pk: 1374,
      nome: 'Forme',
      title: 'Forme',
      slug: 'forme',
      url: '/collezioni/emilceramica/forme',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Forme Rosato 20x20 Majolica Bianco Part Studio .jpg',
      },
    },
    {
      pk: 1379,
      nome: 'Tele di Marmo Pure Onyx',
      title: 'Tele di Marmo Pure Onyx',
      slug: 'tele-di-marmo-pure-onyx',
      url: '/collezioni/emilceramica/tele-di-marmo-pure-onyx',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/TDM Pure Onyx Giada - Perla 120x278 Lapp Sixty 120x120 Cenere Amb Negozio.jpg',
      },
    },
    {
      pk: 1375,
      nome: 'Fabrika',
      title: 'Fabrika',
      slug: 'fabrika',
      url: '/collezioni/emilceramica/fabrika',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Fabrika Sand 60x120 Amb Bagno.jpg',
      },
    },
    {
      pk: 1367,
      nome: 'MaPierre',
      title: 'MaPierre',
      slug: 'mapierre',
      url: '/collezioni/emilceramica/mapierre',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Mapierre Beige ancienne-noble-ligne 60x120 Amb Bagno.jpg',
      },
    },
    {
      pk: 1365,
      nome: 'Tele di Marmo Precious ',
      title: 'Tele di Marmo Precious ',
      slug: 'tele-di-marmo-precious',
      url: '/collezioni/emilceramica/tele-di-marmo-precious',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/TdmPrecious Agate-Crystal Azure 128x278 Amb Bagno copy.jpg',
      },
    },
    {
      pk: 1353,
      nome: 'Tele di Marmo Onyx',
      title: 'Tele di Marmo Onyx',
      slug: 'tele-di-marmo-onyx',
      url: '/collezioni/emilceramica/tele-di-marmo-onyx',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Onyx_Ambiente 1_Bagno.jpg',
      },
    },
    {
      pk: 1351,
      nome: 'Sixty',
      title: 'Sixty',
      slug: 'sixty',
      url: '/collezioni/emilceramica/sixty',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/EMILCERAMICA_Sixty_1981 Salvia_ORIZZONTALE.jpg',
      },
    },
    {
      pk: 1352,
      nome: 'Mimesis',
      title: 'Mimesis',
      slug: 'mimesis',
      url: '/collezioni/emilceramica/mimesis',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emil_Mimesis_Bagno_ecru.jpg',
      },
    },
    {
      pk: 1334,
      nome: 'Tele Di Marmo Selection',
      title: 'Tele Di Marmo Selection',
      slug: 'tele-di-marmo-selection',
      url: '/collezioni/emilceramica/tele-di-marmo-selection',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/TDM Selection_gallery1.jpg',
      },
    },
    {
      pk: 1281,
      nome: 'Landscape',
      title: 'Landscape',
      slug: 'landscape',
      url: '/collezioni/emilceramica/landscape',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emil_Landscape_01.jpg',
      },
    },
    {
      pk: 1257,
      nome: 'Millelegni Remake',
      title: 'Millelegni Remake',
      slug: 'millelegni-remake',
      url: '/collezioni/emilceramica/millelegni-remake',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emil_Millelegni_03.jpg',
      },
    },
    {
      pk: 1261,
      nome: 'Tele Di Marmo Revolution',
      title: 'Tele Di Marmo Revolution',
      slug: 'tele-di-marmo-revolution',
      url: '/collezioni/emilceramica/tele-di-marmo-revolution',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/TeleDiMarmo_Revolution_05.jpg',
      },
    },
    {
      pk: 1260,
      nome: 'Totalook',
      title: 'Totalook',
      slug: 'totalook',
      url: '/collezioni/emilceramica/totalook',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Totalook White 80x80 6x24 Majolica Lux Matt Amb. Living.jpg',
      },
    },
    {
      pk: 1249,
      nome: 'Dimore',
      title: 'Dimore',
      slug: 'dimore',
      url: '/collezioni/emilceramica/dimore',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_Dimore_006.jpg',
      },
    },
    {
      pk: 1244,
      nome: 'Externa Cotto',
      title: 'Externa Cotto',
      slug: 'externa-cotto',
      url: '/collezioni/emilceramica/externa-cotto',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emil_Externa_Cotto_07.jpg',
      },
    },
    {
      pk: 1245,
      nome: 'Externa Quarzite',
      title: 'Externa Quarzite',
      slug: 'externa-quarzite',
      url: '/collezioni/emilceramica/externa-quarzite',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emil_Externa_Quarzite_018.jpg',
      },
    },
    {
      pk: 1214,
      nome: 'Tele Di Marmo Reloaded',
      title: 'Tele Di Marmo Reloaded',
      slug: 'tele-di-marmo-reloaded',
      url: '/collezioni/emilceramica/tele-di-marmo-reloaded',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emil_Tele Di Marmo Reloaded_016.jpg',
      },
    },
    {
      pk: 1131,
      nome: 'Chateau',
      title: 'Chateau',
      slug: 'chateau',
      url: '/collezioni/emilceramica/chateau',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emil_Chateau_012.jpg',
      },
    },
    {
      pk: 1221,
      nome: 'Sleekwood',
      title: 'Sleekwood',
      slug: 'sleekwood',
      url: '/collezioni/emilceramica/sleekwood',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emil_SleekWood_006.jpg',
      },
    },
    {
      pk: 881,
      nome: '20Twenty',
      title: '20Twenty',
      slug: '20twenty',
      url: '/collezioni/emilceramica/20twenty',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_20Twenty_017.jpg',
      },
    },
    {
      pk: 897,
      nome: 'Be-Square',
      title: 'Be-Square',
      slug: 'be-square',
      url: '/collezioni/emilceramica/be-square',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Be-Square Sand 120x278 Amb. Hall.jpg',
      },
    },
    {
      pk: 906,
      nome: 'Externa',
      title: 'Externa',
      slug: 'externa',
      url: '/collezioni/emilceramica/externa',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_Externa_016.jpg',
      },
    },
    {
      pk: 932,
      nome: 'Tele Di Marmo',
      title: 'Tele Di Marmo',
      slug: 'tele-di-marmo',
      url: '/collezioni/emilceramica/tele-di-marmo',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Tdm Breccia 60x120 Amb Living.jpg',
      },
    },
    {
      pk: 927,
      nome: 'Nordika',
      title: 'Nordika',
      slug: 'nordika',
      url: '/collezioni/emilceramica/nordika',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_Nordika_011.jpg',
      },
    },
    {
      pk: 928,
      nome: 'On Square',
      title: 'On Square',
      slug: 'on-square',
      url: '/collezioni/emilceramica/on-square',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_ON_SQUARE_004.jpg',
      },
    },
    {
      pk: 923,
      nome: 'Millelegni',
      title: 'Millelegni',
      slug: 'millelegni',
      url: '/collezioni/emilceramica/millelegni',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_Millelegni_009.jpg',
      },
    },
  ],
  progetti: [
    {
      name: 'Attico a Barcellona ',
      url: '/progetti/il_marmo_incanta_barcellona',
      title: 'Il marmo incanta Barcellona ',
      imageUrl: 'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/_MG_0354_banner.jpg',
    },
    {
      name: 'Villa Rustrial in Germania',
      url: '/progetti/lo_stile_rustrial_per_linterior_design',
      title: 'Lo stile Rustrial per l’interior design ',
      imageUrl: 'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/IMG_3873.JPEG',
    },
    {
      name: 'Progetto terrazza Sassuolo ',
      url: '/progetti/un_terrazzo_in_centro_moderno_ed_elegante',
      title: 'Un terrazzo in centro moderno ed elegante ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/Banner - Pinelli_Gariselli-Botti_8090b_X.jpg',
    },
    {
      name: 'Salotto Regina',
      url: '/progetti/restyling_salotto_regina',
      title: 'Restyling Salotto Regina',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/SalottoRegina_imgTESTATA.JPG',
    },
    {
      name: 'Mizuno Store Torino',
      url: '/progetti/mizuno_store_torino',
      title: 'Mizuno Store Torino ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/mizuno-store_immagine-testata.jpg',
    },
    {
      name: 'Restyling Villa a Modena',
      url: '/progetti/restyling_villa_a_modena',
      title: 'Restyling Villa a Modena ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/villa-modena_gallery-3.jpg',
    },
    {
      name: 'Restyling ristorante Niwa',
      url: '/progetti/restyling_ristorante_niwa',
      title: 'Restyling ristorante Niwa',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/ristorante-niwa_immagine testata.jpg',
    },
    {
      name: 'Il restyling di Villa Verde Hotel&Resort',
      url: '/progetti/il_restyling_di_villaverde_hotel-resort',
      title: 'Il restyling di Villaverde Hotel&Resort',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/golfclubudine_gallery-1.jpg',
    },
    {
      name: 'Restyling Sport Club',
      url: '/progetti/restyling_sport_club',
      title: 'Restyling Sport Club ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/sport-club-impuls_gallery-1.jpg',
    },
    {
      name: 'Restyling Pluricart',
      url: '/progetti/restyling_aziendale_sede_pluricart',
      title: 'Restyling aziendale sede Pluricart',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/pluricart_immagine gallery-1.jpg',
    },
    {
      name: 'Restyling Cormorano Hotel',
      url: '/progetti/restyling_cormorano_hotel',
      title: 'Restyling Cormorano Hotel ',
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/cormorano-hotel_gallery-2.jpg',
    },
  ],
  magazines: [
    {
      pk: 422,
      title: 'Pattern Drenching e Color Drenching: le tendenze che trasformano gli spazi',
      url: '/magazine/pattern-drenching-e-color-drenching-le-tendenze-che-trasformano-gli-spazi',
      description: null,
      subtitle: null,
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/33/38/33383b95-a074-4cd3-ac97-8a80862f9aca/banner_tdmprecious_brown_agata-crystal_ambra_128x278_amb_hall.jpg',
      categoriaTitle: 'Ispirazioni',
    },
    {
      pk: 416,
      title: 'Interior Design e Benessere Mentale: come trasformare il tuo spazio e la tua mente',
      url: '/magazine/interior-design-e-benessere-mentale-come-trasformare-il-tuo-spazio-e-la-tua-mente',
      description: null,
      subtitle: null,
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/a6/25/a62547a5-a303-4ef9-b348-7cb0bd828333/banner_unique_travertine_white_vein_cut-minimal_nat_amb_cucina.jpg',
      categoriaTitle: 'Ispirazioni',
    },
    {
      pk: 413,
      title: 'Art Suite Punta Tragara Hotel – Intervista con l’Arch. Dennerlein',
      url: '/magazine/art-suite-punta-tragara-hotel-intervista-con-larch-dennerlein',
      description: null,
      subtitle: null,
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/1e/a8/1ea8a607-3027-4c6e-922e-64700cf98a58/banner_dsf6979-hdr.jpg',
      categoriaTitle: 'Interviste',
    },
    {
      pk: 411,
      title: 'Come rendere il tuo bagno lussuoso: idee e consigli',
      url: '/magazine/come-rendere-il-tuo-bagno-lussuoso-idee-e-consigli',
      description: null,
      subtitle: null,
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/c5/76/c576f55b-52c1-4390-a507-2f76b603bbc4/banner_tdm_pure_onyx_turchese_lapp_120x278_amb_bagno.jpg',
      categoriaTitle: 'Ispirazioni',
    },
  ],
}

const mockSoluzioneDetailDescription = `
    <h4 >
      A secco su erba
    </h4>
     <div>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
    </div>
    <ul>
      <li>Velocità di esecuzione</li>
      <li>Facilità di rimozione e riposizionamento</li>
      <li>Economicità in quanto realizzabile senza l’intervento di personale specializzato</li>
      <li>Inattacabile da muffe e da agenti chimici</li>
      <li>Riduzione dei costi e tempi di posa</li>
      <li>Immediatamente utilizzabile</li>
    </ul>
`
const mockSoluzioneDetailDescription2 = `
    <h4>
      A secco su erba
    </h4>
    <div>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
    </div>
    <ul>
      <li>Velocità di esecuzione</li>
      <li>Facilità di rimozione e riposizionamento</li>
      <li>Economicità in quanto realizzabile senza l’intervento di personale specializzato</li>
    </ul>
`

export const mockSoluzioni = [
  {
    pk: 7,
    url: '/soluzioni/soluzioni-in-gres-porcellanato-per-interni',
    title: 'Soluzioni in gres porcellanato Emilgroup',
    image:
      'https://www.emilgroup.it/media/filer_public/3b/e2/3be25dae-b202-407c-a17a-94b1a9a67743/soluzione_per_interni_1.png',
  },
  {
    pk: 4,
    url: '/soluzioni/piastrelle-in-gres-per-esterni',
    title: 'Soluzioni in gres porcellanato per gli esterni',
    image:
      'https://www.emilgroup.it/media/filer_public/cb/4d/cb4dceb9-af20-4cbf-a123-eb20dfda0e1e/mapierre_beige_ancienne_20x20-20x40-60x120_amb_terrazza.jpg',
  },
  {
    pk: 2,
    url: '/soluzioni/piastrelle-in-gres-facciate-ventilate',
    title: 'Facciate ventilate',
    image:
      'https://www.emilgroup.it/media/filer_public/b1/36/b1366976-f267-4c33-ae2d-285049da2351/pagina_soluzioni_testata_soluzioni_facciate_ventilate_20180511_093317.jpg',
  },
  {
    pk: 3,
    url: '/soluzioni/piastrelle-in-gres-grandi-lastre-level',
    title: 'Piastrelle grandi lastre Level',
    image:
      'https://www.emilgroup.it/media/filer_public/da/f9/daf933c3-d9b3-401a-bd41-d9683bc3caac/pagina_soluzioni_testata_soluzioni_countertop_quarzo_nat-lapp_luc_162x324_amb_bagno.jpg',
  },
  {
    pk: 3,
    url: '/soluzioni/piastrelle-in-gres-grandi-lastre-level',
    title: 'Piastrelle grandi lastre Level',
    image:
      'https://www.emilgroup.it/media/filer_public/da/f9/daf933c3-d9b3-401a-bd41-d9683bc3caac/pagina_soluzioni_testata_soluzioni_countertop_quarzo_nat-lapp_luc_162x324_amb_bagno.jpg',
  },
  {
    pk: 3,
    url: '/soluzioni/piastrelle-in-gres-grandi-lastre-level',
    title: 'Piastrelle grandi lastre Level',
    image:
      'https://www.emilgroup.it/media/filer_public/da/f9/daf933c3-d9b3-401a-bd41-d9683bc3caac/pagina_soluzioni_testata_soluzioni_countertop_quarzo_nat-lapp_luc_162x324_amb_bagno.jpg',
  },
]

export const mockSoluzioneDetail = {
  pk: 2,
  title: 'Facciate ventilate',
  subtitle: 'Sottotitolo',
  mediaCards: [
    mockGenericItem(1),
    { ...mockGenericItem(1), ctaLabel: undefined, subtitle: undefined },
    { ...mockGenericItem(2), ctaLabel: undefined, name: undefined, subtitle: undefined },
  ],
  destinazioniUso: [
    {
      pk: 8,
      title: 'Residenziale',
      image:
        'https://www.emilgroup.it/media/filer_public/c5/9a/c59a42c8-4af1-4b19-b082-811fbd9a6a07/1_facciate.jpg',
    },
    {
      pk: 9,
      title: 'Commerciale',
      image:
        'https://www.emilgroup.it/media/filer_public/05/4d/054d458f-4138-4318-85d2-2407fed6d417/fvdu_2.jpg',
    },
    {
      pk: 10,
      title: 'Nuovi edifici',
      image:
        'https://www.emilgroup.it/media/filer_public/44/a2/44a27355-7b96-401f-8cd8-7cf2c1c60589/fvdu_3.jpg',
    },
    {
      pk: 11,
      title: 'Ristrutturazione',
      image:
        'https://www.emilgroup.it/media/filer_public/5f/48/5f48375f-1642-40ab-9985-891c89beb82f/fvdu_4.jpg',
    },
  ],
  correlati: [
    {
      pk: 4,
      title: 'Soluzioni in gres porcellanato per gli esterni',
      subtitle: null,
      image:
        'https://www.emilgroup.it/media/filer_public/cb/4d/cb4dceb9-af20-4cbf-a123-eb20dfda0e1e/mapierre_beige_ancienne_20x20-20x40-60x120_amb_terrazza.jpg',
      url: '/soluzioni/piastrelle-in-gres-per-esterni',
    },
    {
      pk: 3,
      title: 'Piastrelle grandi lastre Level',
      subtitle: null,
      image:
        'https://www.emilgroup.it/media/filer_public/da/f9/daf933c3-d9b3-401a-bd41-d9683bc3caac/pagina_soluzioni_testata_soluzioni_countertop_quarzo_nat-lapp_luc_162x324_amb_bagno.jpg',
      url: '/soluzioni/piastrelle-in-gres-grandi-lastre-level',
    },
    {
      pk: 7,
      title: 'Soluzioni in gres porcellanato Emilgroup',
      subtitle: null,
      image:
        'https://www.emilgroup.it/media/filer_public/3b/e2/3be25dae-b202-407c-a17a-94b1a9a67743/soluzione_per_interni_1.png',
      url: '/soluzioni/soluzioni-in-gres-porcellanato-per-interni',
    },
    {
      pk: 7,
      title: 'Soluzioni in gres porcellanato Emilgroup',
      subtitle: null,
      image:
        'https://www.emilgroup.it/media/filer_public/3b/e2/3be25dae-b202-407c-a17a-94b1a9a67743/soluzione_per_interni_1.png',
      url: '/soluzioni/soluzioni-in-gres-porcellanato-per-interni',
    },
  ],
  dettagli: [
    {
      name: 'Un team engeneering dedicato ai rivestimenti di facciate ventilate',
      description:
        '<p>Il team Engineering di Emilgroup è la struttura dedicata a supportare a 360°il cliente nella progettazione, installazione e certificazione dei sistemi di rivestimento superficiale per interni ed esterni.</p>',
      children: [
        { image: imgUrl(80, 80), name: 'Progettazione taylor made' },
        { image: imgUrl(80, 80), name: 'Consulenza estetica' },
        { image: imgUrl(80, 80), name: 'Assistenza in cantiere' },
        { image: imgUrl(80, 80), name: 'Supporto post installazione' },
      ],
    },
    {
      name: 'Le destinazioni d’uso',
      children: [
        { image: imgUrl(80, 80), name: 'Residenziale' },
        { image: imgUrl(80, 80), name: 'Commerciale' },
        { image: imgUrl(80, 80), name: 'Nuovi Edifici' },
        { image: imgUrl(80, 80), name: 'Ristrutturazione' },
        { image: imgUrl(80, 80), name: 'Ristrutturazione' },
        { image: imgUrl(80, 80), name: 'Ristrutturazione' },
        { image: imgUrl(80, 80), name: 'Ristrutturazione' },
      ],
    },
    {
      name: 'I vantaggi del gres Emilgroup',
      children: [
        {
          image: imgUrl(80, 80),
          name: 'Resistenza alle macchie (graffiti) e attacco chimico (piogge acide)',
        },
        {
          image: imgUrl(80, 80),
          name: 'Alta resistenza meccanica (flessione/carico del vento)',
        },
        { image: imgUrl(80, 80), name: 'Durezza superficiale (antigraffio)' },
        { image: imgUrl(80, 80), name: 'Resistenza al gelo e agli sbalzi termici' },
        { image: imgUrl(80, 80), name: 'Inalterabilità ai raggi ultravioletti' },
        { image: imgUrl(80, 80), name: 'Reazione e resistenza al fuoco' },
        { image: imgUrl(80, 80), name: 'Non assorbe acqua' },
        { image: imgUrl(80, 80), name: 'Resistente al muschio, muffe, verdame' },
      ],
    },
  ],
  ultimeCollezioni: [
    {
      id: 100001,
      slug: 'stonehenge',
      title: 'Stonehenge ',
      nome: 'Stonehenge ',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Stonehenge_001.jpg',
      },
    },
    {
      id: 100000,
      slug: 'slabs-usa',
      title: 'SLABS USA',
      nome: 'SLABS USA',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Ergon_Slabs_001.jpg',
      },
    },
    {
      id: 100002,
      slug: 'aurelia-stone',
      title: 'Aurelia Stone ',
      nome: 'Aurelia Stone ',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/AureliaStone_DarkGrey_Amb_Bar_gallery.jpg',
      },
    },
    {
      id: 100003,
      slug: 'essential-brick',
      title: 'Essential Brick',
      nome: 'Essential Brick',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/001_Ergon_EssentialBrick_Cucina_generale_HR_gallery.jpg',
      },
    },
    {
      id: 897,
      slug: 'be-square',
      title: 'Be-Square',
      nome: 'Be-Square',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Be-Square Sand 120x278 Amb. Hall.jpg',
      },
    },
    {
      id: 904,
      slug: 'eterna',
      title: 'Eterna',
      nome: 'Eterna',
      listingImage: null,
    },
    {
      id: 1141,
      slug: 'concept3',
      title: 'CONCEPT3',
      nome: 'CONCEPT3',
      listingImage: null,
    },
    {
      id: 923,
      slug: 'millelegni',
      title: 'Millelegni',
      nome: 'Millelegni',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_Millelegni_009.jpg',
      },
    },
    {
      id: 896,
      slug: 'brick-design',
      title: 'Brick Design',
      nome: 'Brick Design',
      listingImage: null,
    },
    {
      id: 917,
      slug: 'kotto',
      title: 'Kotto',
      nome: 'Kotto',
      listingImage: null,
    },
  ],
  applicazioni: [
    {
      id: '7',
      slug: 'soluzioni-in-gres-porcellanato-per-interni',
      description: mockSoluzioneDetailDescription,
      image:
        'https://www.emilgroup.it/media/filer_public/3b/e2/3be25dae-b202-407c-a17a-94b1a9a67743/soluzione_per_interni_1.png',
    },
    {
      id: '4',
      slug: 'piastrelle-in-gres-per-esterni',
      description: mockSoluzioneDetailDescription2,
      image:
        'https://www.emilgroup.it/media/filer_public/cb/4d/cb4dceb9-af20-4cbf-a123-eb20dfda0e1e/mapierre_beige_ancienne_20x20-20x40-60x120_amb_terrazza.jpg',
    },
    {
      id: '2',
      slug: 'piastrelle-in-gres-facciate-ventilate',
      description: mockSoluzioneDetailDescription,
      image:
        'https://www.emilgroup.it/media/filer_public/b1/36/b1366976-f267-4c33-ae2d-285049da2351/pagina_soluzioni_testata_soluzioni_facciate_ventilate_20180511_093317.jpg',
    },
    {
      id: '3',
      slug: 'piastrelle-in-gres-grandi-lastre-level',
      description: mockSoluzioneDetailDescription2,
      image:
        'https://www.emilgroup.it/media/filer_public/da/f9/daf933c3-d9b3-401a-bd41-d9683bc3caac/pagina_soluzioni_testata_soluzioni_countertop_quarzo_nat-lapp_luc_162x324_amb_bagno.jpg',
    },
    {
      id: '5',
      slug: 'piastrelle-in-gres-grandi-lastre-level',
      description: mockSoluzioneDetailDescription,
      image:
        'https://www.emilgroup.it/media/filer_public/da/f9/daf933c3-d9b3-401a-bd41-d9683bc3caac/pagina_soluzioni_testata_soluzioni_countertop_quarzo_nat-lapp_luc_162x324_amb_bagno.jpg',
    },
  ],
}

export const mockProgetto = {
  title: 'The Leo Grand: un hotel di lusso nel cuore di Vienna',
  premio:
    'https://www.emilgroup.it/media/filer_public/47/fb/47fbfd88-3ef9-4238-8d30-ebf869ca8905/logo_vincitori_black.png',
  imageUrl:
    'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/BANNER 1725006369_66d18221b4686_0.jpg',
  description:
    '<p>Situato nel vibrante centro di Vienna, <strong>The Leo Grand</strong> si erge come un simbolo di eleganza e raffinatezza. Progettato dallo studio di architettura <strong>Lenikus Group</strong>, questo hotel di lusso ha recentemente conquistato il prestigioso <strong>Emilgroup Project Awards 2024</strong> nella categoria Prestigio, grazie al suo impatto visivo straordinario e alla capacità di emozionare e stupire.</p>',
  sottotitolo: 'Lenikus Group',
  descriptionFooter:
    '<p>L’architettura di The Leo Grand è una fusione armoniosa di modernità e tradizione, un progetto che incanta e sorprende. Questo hotel offre 76 camere e suite che armonizzano la conservazione storica di un edificio barocco con un design contemporaneo. Le collezioni di <strong>Emilgroup</strong>, con il loro design unico e potente, si inseriscono perfettamente in questo contesto, comunicando una bellezza senza tempo e un fascino ineguagliabile.</p>\n\n<p>Per questo progetto, è stata scelta la collezione <a href="https://www.emilgroup.it/collezioni/piastrelle/emilceramica-chateau/" target="_blank"><ins><strong>Chateau by Emilceramica</strong></ins></a> nella tonalità <strong>gris</strong>, una scelta che conferisce all\'ambiente un’atmosfera di sofisticata eleganza. Ispirata alla celebre Pietra naturale di Borgogna, Chateau evoca la grandezza della storia architettonica francese, trasmettendo un senso di nobiltà e raffinatezza.</p>\n\n<p>Ogni elemento di The Leo Grand è pensato per offrire un\'esperienza indimenticabile, un viaggio sensoriale che esalta l’armonia tra spazio e materiali. La collezione Chateau non solo arricchisce visivamente gli spazi, ma racconta anche una storia di artigianalità e design, trasformando ogni ambiente in un\'opera d\'arte.</p>\n\n<p><ins><strong><em><a href="https://www.emilgroup.it/magazine/the-leo-grand-intervista-con-larchitetto/" target="_blank">Leggi l’intervista completa al designer.</a></em></strong></ins></p>\n',
  destinazioni: [
    {
      id: '9',
      titolo: 'Hotel',
      slug: 'hotel',
    },
  ],
  url: '/progetti/the_leo_grand_un_hotel_di_lusso_nel_cuore_di_vienna',
  imageAlt: '',
  collezioni: [
    {
      id: 1018,
      url: '/collezioni/ergon/cornerstone',
      nome: 'Cornerstone',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Ergon_Cornerstone White Slate_001.jpg',
      },
    },
    {
      id: 1079,
      url: '/collezioni/ergon/stone-project',
      nome: 'Stone Project',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Ergon_StoneProject_009.jpg',
      },
    },
  ],
  correlati: [
    {
      title: 'Ristorante Nishiki ',
      premio: null,
      destinazioni: [
        {
          id: '10',
          titolo: 'Ristorazione',
          slug: 'ristorazione',
        },
      ],
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/ristorante-nishiki_gallery-1.jpg',
      url: '/progetti/ristorante_nishiki',
    },
    {
      title: 'Nuova Residenza a Pinerolo',
      premio: null,
      destinazioni: [
        {
          id: '15',
          titolo: 'Residenziale',
          slug: 'residenziale',
        },
      ],
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/1Pinerolo_img_testata.jpg',
      url: '/progetti/nuova_residenza_a_pinerolo',
    },
    {
      title: 'Riserva naturale privata Kapama River Lodge',
      premio: null,
      destinazioni: [
        {
          id: '9',
          titolo: 'Hotel',
          slug: 'hotel',
        },
      ],
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/banner_Kapama progetto.jpg',
      url: '/progetti/riserva_naturale_privata_kapama_river_lodge',
    },
    {
      title: 'Ristorante Nishiki ',
      premio: null,
      destinazioni: [
        {
          id: '10',
          titolo: 'Ristorazione',
          slug: 'ristorazione',
        },
      ],
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/ristorante-nishiki_gallery-1.jpg',
      url: '/progetti/ristorante_nishiki',
    },
    {
      title: 'Un complesso studentesco innovativo e funzionale',
      premio: null,
      destinazioni: [
        {
          id: '14',
          titolo: 'Edifici pubblici e di culto',
          slug: 'edifici_pubblici_e_di_culto',
        },
      ],
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/banner_Niagara College.jpg',
      url: '/progetti/un_complesso_studentesco_innovativo_e_funzionale',
    },
    {
      title: 'Un’esperienza di shopping unica',
      premio: null,
      destinazioni: [
        {
          id: '6',
          titolo: 'Interni ed Esterni',
          slug: 'interni_ed_esterni',
        },
        {
          id: '7',
          titolo: 'Commerciale',
          slug: 'commerciale',
        },
      ],
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/Banner - IMG_8128.jpg',
      url: '/progetti/unesperienza_di_shopping_unica',
    },
  ],
  infoProgettiCollezione: [
    {
      collezione: {
        nome: 'Cornerstone',
        url: '/collezioni/ergon/cornerstone',
      },
      infoProgetti: [
        {
          formato: {
            nome: '600x1200',
          },
          coloreNome: 'Slate Black',
          finituraNome: '',
          tonalitaUrl: '',
          superficie: {
            nome: 'Naturale',
          },
          spessore: 'MM 10',
        },
        {
          formato: {
            nome: '600x1200',
          },
          coloreNome: 'Slate Black',
          finituraNome: '',
          tonalitaUrl: '',
          superficie: {
            nome: 'Naturale',
          },
          spessore: 'MM 10',
        },
      ],
    },
    {
      collezione: {
        nome: 'Stone Project',
        url: '/collezioni/ergon/stone-project',
      },
      infoProgetti: [
        {
          formato: {
            nome: '300x600',
          },
          coloreNome: 'Grey',
          finituraNome: 'Controfalda',
          tonalitaUrl: '/ergon/stone-project/controfalda-grey',
          superficie: {
            nome: 'Naturale',
          },
          spessore: 'MM 10',
        },
      ],
    },
  ],
  // FAKE aggiunta by Aly - servono in dettaglio Progetto
  pk: 23423,
  gallery: [
    { pk: 234231, imageUrl: imgUrl(300), imageAlt: '' },
    { pk: 234232, imageUrl: imgUrl(300), imageAlt: '' },
    { pk: 234233, imageUrl: imgUrl(300), imageAlt: '' },
    { pk: 234234, imageUrl: imgUrl(300), imageAlt: '' },
    { pk: 234235, imageUrl: imgUrl(300), imageAlt: '' },
  ],
}

export const mockCertificazioni = [
  {
    logo: 'https://www.emilgroup.it/media/3.jpg.250x100_q75_crop-scale.jpg',
    title: 'EPD (Environmental Product Declaration)',
    description:
      '<p>Emilgroup ha valutato gli impatti ambientali legati ai propri prodotti lungo tutto il loro ciclo di vita, a partire dall’estrazione e lavorazione delle materie prime fino al recupero dei rifiuti di demolizione.<br/> I risultati di questa analisi LCA (life cycle assessment), condotta secondo le norme internazionali della serie ISO 14040, sono pubblicati nella dichiarazione ambientale di prodotto EPD (ISO 14025 e EN 15804) che contribuisce al raggiungimento di crediti per la certificazione LEED.</p>',
    files: [
      {
        title: 'EPD - Spain Industry Wide',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide1',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide2',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide3',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide4',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide5',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide6',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
    ],
  },
  {
    logo: 'https://www.emilgroup.it/media/3.jpg.250x100_q75_crop-scale.jpg',
    title: '1 EPD (Environmental Product Declaration)',
    description:
      '<p>Emilgroup ha valutato gli impatti ambientali legati ai propri prodotti lungo tutto il loro ciclo di vita, a partire dall’estrazione e lavorazione delle materie prime fino al recupero dei rifiuti di demolizione.<br/> I risultati di questa analisi LCA (life cycle assessment), condotta secondo le norme internazionali della serie ISO 14040, sono pubblicati nella dichiarazione ambientale di prodotto EPD (ISO 14025 e EN 15804) che contribuisce al raggiungimento di crediti per la certificazione LEED.</p>',
    files: [
      {
        title: 'EPD - Spain Industry Wide',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide1',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide2',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide3',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide4',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide5',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide6',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
    ],
  },
  {
    logo: 'https://www.emilgroup.it/media/3.jpg.250x100_q75_crop-scale.jpg',
    title: '2 EPD (Environmental Product Declaration)',
    description:
      '<p>Emilgroup ha valutato gli impatti ambientali legati ai propri prodotti lungo tutto il loro ciclo di vita, a partire dall’estrazione e lavorazione delle materie prime fino al recupero dei rifiuti di demolizione.<br/> I risultati di questa analisi LCA (life cycle assessment), condotta secondo le norme internazionali della serie ISO 14040, sono pubblicati nella dichiarazione ambientale di prodotto EPD (ISO 14025 e EN 15804) che contribuisce al raggiungimento di crediti per la certificazione LEED.</p>',
    files: [
      {
        title: 'EPD - Spain Industry Wide',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide1',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide2',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide3',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide4',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide5',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide6',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
    ],
  },
  {
    logo: 'https://www.emilgroup.it/media/3.jpg.250x100_q75_crop-scale.jpg',
    title: '3 EPD (Environmental Product Declaration)',
    description:
      '<p>Emilgroup ha valutato gli impatti ambientali legati ai propri prodotti lungo tutto il loro ciclo di vita, a partire dall’estrazione e lavorazione delle materie prime fino al recupero dei rifiuti di demolizione.<br/> I risultati di questa analisi LCA (life cycle assessment), condotta secondo le norme internazionali della serie ISO 14040, sono pubblicati nella dichiarazione ambientale di prodotto EPD (ISO 14025 e EN 15804) che contribuisce al raggiungimento di crediti per la certificazione LEED.</p>',
    files: [
      {
        title: 'EPD - Spain Industry Wide',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide1',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide2',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide3',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide4',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide5',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide6',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
    ],
  },
  {
    logo: 'https://www.emilgroup.it/media/3.jpg.250x100_q75_crop-scale.jpg',
    title: '4 EPD (Environmental Product Declaration)',
    description:
      '<p>Emilgroup ha valutato gli impatti ambientali legati ai propri prodotti lungo tutto il loro ciclo di vita, a partire dall’estrazione e lavorazione delle materie prime fino al recupero dei rifiuti di demolizione.<br/> I risultati di questa analisi LCA (life cycle assessment), condotta secondo le norme internazionali della serie ISO 14040, sono pubblicati nella dichiarazione ambientale di prodotto EPD (ISO 14025 e EN 15804) che contribuisce al raggiungimento di crediti per la certificazione LEED.</p>',
    files: [
      {
        title: 'EPD - Spain Industry Wide',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide1',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide2',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide3',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide4',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide5',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide6',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
    ],
  },
  {
    logo: 'https://www.emilgroup.it/media/3.jpg.250x100_q75_crop-scale.jpg',
    title: '5 EPD (Environmental Product Declaration)',
    description:
      '<p>Emilgroup ha valutato gli impatti ambientali legati ai propri prodotti lungo tutto il loro ciclo di vita, a partire dall’estrazione e lavorazione delle materie prime fino al recupero dei rifiuti di demolizione.<br/> I risultati di questa analisi LCA (life cycle assessment), condotta secondo le norme internazionali della serie ISO 14040, sono pubblicati nella dichiarazione ambientale di prodotto EPD (ISO 14025 e EN 15804) che contribuisce al raggiungimento di crediti per la certificazione LEED.</p>',
    files: [
      {
        title: 'EPD - Spain Industry Wide',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide1',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide2',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide3',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide4',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide5',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide6',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
    ],
  },
  {
    logo: 'https://www.emilgroup.it/media/3.jpg.250x100_q75_crop-scale.jpg',
    title: '6 EPD (Environmental Product Declaration)',
    description:
      '<p>Emilgroup ha valutato gli impatti ambientali legati ai propri prodotti lungo tutto il loro ciclo di vita, a partire dall’estrazione e lavorazione delle materie prime fino al recupero dei rifiuti di demolizione.<br/> I risultati di questa analisi LCA (life cycle assessment), condotta secondo le norme internazionali della serie ISO 14040, sono pubblicati nella dichiarazione ambientale di prodotto EPD (ISO 14025 e EN 15804) che contribuisce al raggiungimento di crediti per la certificazione LEED.</p>',
    files: [
      {
        title: 'EPD - Spain Industry Wide',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide1',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide2',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide3',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide4',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide5',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide6',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
    ],
  },
  {
    logo: 'https://www.emilgroup.it/media/3.jpg.250x100_q75_crop-scale.jpg',
    title: 'EPD (Environmental Product Declaration)',
    description:
      '<p>Emilgroup ha valutato gli impatti ambientali legati ai propri prodotti lungo tutto il loro ciclo di vita, a partire dall’estrazione e lavorazione delle materie prime fino al recupero dei rifiuti di demolizione.<br/> I risultati di questa analisi LCA (life cycle assessment), condotta secondo le norme internazionali della serie ISO 14040, sono pubblicati nella dichiarazione ambientale di prodotto EPD (ISO 14025 e EN 15804) che contribuisce al raggiungimento di crediti per la certificazione LEED.</p>',
    files: [
      {
        title: 'EPD - Spain Industry Wide',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide1',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide2',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide3',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide4',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide5',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide6',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
    ],
  },
  {
    logo: 'https://www.emilgroup.it/media/3.jpg.250x100_q75_crop-scale.jpg',
    title: '7 EPD (Environmental Product Declaration)',
    description:
      '<p>Emilgroup ha valutato gli impatti ambientali legati ai propri prodotti lungo tutto il loro ciclo di vita, a partire dall’estrazione e lavorazione delle materie prime fino al recupero dei rifiuti di demolizione.<br/> I risultati di questa analisi LCA (life cycle assessment), condotta secondo le norme internazionali della serie ISO 14040, sono pubblicati nella dichiarazione ambientale di prodotto EPD (ISO 14025 e EN 15804) che contribuisce al raggiungimento di crediti per la certificazione LEED.</p>',
    files: [
      {
        title: 'EPD - Spain Industry Wide',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide1',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide2',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide3',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide4',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide5',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide6',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
    ],
  },
  {
    logo: 'https://www.emilgroup.it/media/3.jpg.250x100_q75_crop-scale.jpg',
    title: '8 EPD (Environmental Product Declaration)',
    description:
      '<p>Emilgroup ha valutato gli impatti ambientali legati ai propri prodotti lungo tutto il loro ciclo di vita, a partire dall’estrazione e lavorazione delle materie prime fino al recupero dei rifiuti di demolizione.<br/> I risultati di questa analisi LCA (life cycle assessment), condotta secondo le norme internazionali della serie ISO 14040, sono pubblicati nella dichiarazione ambientale di prodotto EPD (ISO 14025 e EN 15804) che contribuisce al raggiungimento di crediti per la certificazione LEED.</p>',
    files: [
      {
        title: 'EPD - Spain Industry Wide',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide1',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide2',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide3',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide4',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide5',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide6',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
    ],
  },
  {
    logo: 'https://www.emilgroup.it/media/3.jpg.250x100_q75_crop-scale.jpg',
    title: '9 EPD (Environmental Product Declaration)',
    description:
      '<p>Emilgroup ha valutato gli impatti ambientali legati ai propri prodotti lungo tutto il loro ciclo di vita, a partire dall’estrazione e lavorazione delle materie prime fino al recupero dei rifiuti di demolizione.<br/> I risultati di questa analisi LCA (life cycle assessment), condotta secondo le norme internazionali della serie ISO 14040, sono pubblicati nella dichiarazione ambientale di prodotto EPD (ISO 14025 e EN 15804) che contribuisce al raggiungimento di crediti per la certificazione LEED.</p>',
    files: [
      {
        title: 'EPD - Spain Industry Wide',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide1',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide2',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide3',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide4',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide5',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide6',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
    ],
  },
  {
    logo: 'https://www.emilgroup.it/media/3.jpg.250x100_q75_crop-scale.jpg',
    title: '10 EPD (Environmental Product Declaration)',
    description:
      '<p>Emilgroup ha valutato gli impatti ambientali legati ai propri prodotti lungo tutto il loro ciclo di vita, a partire dall’estrazione e lavorazione delle materie prime fino al recupero dei rifiuti di demolizione.<br/> I risultati di questa analisi LCA (life cycle assessment), condotta secondo le norme internazionali della serie ISO 14040, sono pubblicati nella dichiarazione ambientale di prodotto EPD (ISO 14025 e EN 15804) che contribuisce al raggiungimento di crediti per la certificazione LEED.</p>',
    files: [
      {
        title: 'EPD - Spain Industry Wide',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide1',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide2',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide3',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide4',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide5',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide6',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
    ],
  },
  {
    logo: 'https://www.emilgroup.it/media/3.jpg.250x100_q75_crop-scale.jpg',
    title: '11 EPD (Environmental Product Declaration)',
    description:
      '<p>Emilgroup ha valutato gli impatti ambientali legati ai propri prodotti lungo tutto il loro ciclo di vita, a partire dall’estrazione e lavorazione delle materie prime fino al recupero dei rifiuti di demolizione.<br/> I risultati di questa analisi LCA (life cycle assessment), condotta secondo le norme internazionali della serie ISO 14040, sono pubblicati nella dichiarazione ambientale di prodotto EPD (ISO 14025 e EN 15804) che contribuisce al raggiungimento di crediti per la certificazione LEED.</p>',
    files: [
      {
        title: 'EPD - Spain Industry Wide',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide1',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide2',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide3',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide4',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide5',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
      {
        title: 'EPD - Spain Industry Wide6',
        url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
      },
    ],
  },
]

export const mockMagazine = {
  pk: 432,
  title: 'City Community Center a Laubach: intervista con ankestern interior',
  pubDate: '2025-01-09T10:10:00+00:00',
  imageUrl:
    'https://www.emilgroup.it/media/filer_public/fb/a6/fba60b42-7827-4a6c-89b7-509a060fa346/1722431851_66aa396b6f57b_0.jpg',
  imageAlt: '',
  descriptionHead:
    '<p>Il <strong>City Community Center</strong> di Laubach &egrave; il risultato di una ristrutturazione che unisce design contemporaneo e funzionalit&agrave;, dando vita a uno spazio dinamico e accogliente per la comunit&agrave;. In questo progetto, lo studio <strong>ankestern interior</strong> ha saputo creare un ambiente moderno e pratico, utilizzando la collezione <a href="https://www.emilgroup.it/collezioni/piastrelle/ergon-medley/" target="_blank"><u><strong>Medley by Ergon</strong></u></a> per aggiungere un tocco distintivo e funzionale.</p>\r\n\r\n<p>Abbiamo intervistato <strong>Anke Stern</strong>, fondatrice di <strong>ankestern interior</strong>, per scoprire di pi&ugrave; sul processo creativo e le sfide affrontate in questo progetto.</p>\r\n\r\n<h2>Qual &egrave; la filosofia che ha ispirato il vostro progetto?</h2>\r\n\r\n<p>La filosofia che ha ispirato il nostro progetto si basa sull&#39;idea di creare uno spazio che unisca design contemporaneo e funzionalit&agrave;, in risposta alle esigenze di una comunit&agrave; dinamica e intergenerazionale. L&#39;obiettivo era offrire una soluzione moderna ma allo stesso tempo pratica. Un aspetto fondamentale &egrave; stata l&#39;integrazione del design dei mobili, come quelli del bar, con il concetto complessivo dello spazio. Il bar diventa il punto focale della stanza, accentuato dal continuo utilizzo dei materiali ceramici Emilgroup che si estendono nell&rsquo;ambiente circostante. Un cambiamento di materiale di fronte al bar definisce chiaramente una zona specifica, migliorandone la funzionalit&agrave;. Inoltre, nella zona della scala, una transizione di materiali segnala la necessit&agrave; di maggiore attenzione, contribuendo a un&#39;esperienza visiva e spaziale pi&ugrave; consapevole.</p>\r\n\r\n<h2>Cosa vi ha entusiasmato di pi&ugrave; di questo progetto?</h2>\r\n\r\n<p>Ci&ograve; che ci ha particolarmente colpito &egrave; stata l&#39;apertura della comunit&agrave; nel voler creare un nuovo centro nevralgico per il paese. Questo spazio ha infatti un carattere urbanizzato e moderno, che ridefinisce il cuore della comunit&agrave; stessa. La partecipazione attiva della gente &egrave; stata un aspetto davvero stimolante per noi.</p>\r\n\r\n<h2>Cosa avete apprezzato di pi&ugrave; di Emilgroup?</h2>\r\n\r\n<p>Abbiamo ricevuto un supporto eccellente durante tutto il processo, a partire dai campioni di materiale fino alle informazioni sui prezzi e alla gestione dei fornitori. In questo modo l&rsquo;utilizzo di un prodotto italiano di qualit&agrave;, che doveva arrivare in Austria e poi in Germania, si &egrave; rivelata la scelta migliore. Il progetto &egrave; stato realizzato puntualmente e nel rispetto del budget, il che &egrave; stato fondamentale per noi e per il nostro cliente. Siamo molto soddisfatti della collaborazione e consigliamo vivamente di lavorare con Emilgroup!</p>\r\n\r\n<p><a href="https://www.emilgroup.it/progetti/city_community_center_a_laubach_un_progetto_che_unisce_design_e_funzionalita/" target="_blank"><u><strong><em>Scopri il progetto.</em></strong></u></a></p>',
  descriptionFooter: null,
  tag: 'Interviste',
  magazineprogetti: [],
  magazinecollezioni: [
    {
      pk: 1258,
      title: 'Medley',
      listingImage: {
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Ergon_Medley_03.jpg',
      },
      brand: {
        pk: 2,
        logo: 'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Ergon_Logo_RGB_web.png',
      },
    },
  ],
  correlati: [
    {
      pk: 446,
      title: 'Emilgroup @ KBIS 2025',
      pubDate: '2025-02-04T14:39:00+00:00',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/61/c2/61c2ecd7-742a-466a-8185-60af02d88936/website-header.jpg',
      imageAlt: '',
      descriptionHead: null,
      url: '/magazine/emilgroup-kbis-2025',
      tag: 'News & Media',
    },
    {
      pk: 445,
      title: 'Emilgroup @ Artdom 2025',
      pubDate: '2025-02-04T14:37:00+00:00',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/e2/e3/e2e3aaff-d5c8-4e63-b9c5-8053cbe9b932/website-header.jpg',
      imageAlt: '',
      descriptionHead: null,
      url: '/magazine/emilgroup-artdom-2025',
      tag: 'News & Media',
    },
    {
      pk: 444,
      title: 'Emilgroup e Spazi Belli insieme per celebrare il design',
      pubDate: '2025-01-29T10:54:00+00:00',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/06/02/06027190-1f63-4c8a-a892-7ca76624db59/banner_project_image_a5da4749e2.jpeg',
      imageAlt: '',
      descriptionHead: null,
      url: '/magazine/emilgroup-e-spazi-belli-insieme-per-celebrare-il-design',
      tag: 'News & Media',
    },
  ],
  gallery: [
    {
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/75/de/75ded948-034f-44c2-9efd-b628ff163e98/arch_1.jpg',
      imageAlt: '',
    },
    {
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/31/65/3165b0fc-9f03-4db1-b8a2-40b54d2ed428/1722431851_66aa396b8fe87_5.jpg',
      imageAlt: '',
    },
    {
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/fa/5f/fa5f8817-3ca8-4939-bd9a-d7980c3032b5/1722431851_66aa396b909ad_6.jpg',
      imageAlt: '',
    },
    {
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/ec/7c/ec7c1f1d-622f-42d9-b229-a847ad84e566/1722431851_66aa396b70041_2.jpg',
      imageAlt: '',
    },
    {
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/94/b2/94b2f0ef-54e3-4200-a58c-028fe2255504/1722431851_66aa396baf519_8.jpg',
      imageAlt: '',
    },
  ],
}

export const mockMagazineCard = (index) => ({
  pk: index,
  title: 'City Community Center a Laubach: intervista con ankestern interior',
  pubDate: '2025-01-09T10:10:00+00:00',
  imageUrl:
    'https://www.emilgroup.it/media/filer_public/fb/a6/fba60b42-7827-4a6c-89b7-509a060fa346/1722431851_66aa396b6f57b_0.jpg',
  imageAlt: '',
  descriptionHead:
    '<p>Il <strong>City Community Center</strong> di Laubach &egrave; il risultato di una ristrutturazione che unisce design contemporaneo e funzionalit&agrave;, dando vita a uno spazio dinamico e accogliente per la comunit&agrave;. In questo progetto, lo studio <strong>ankestern interior</strong> ha saputo creare un ambiente moderno e pratico, utilizzando la collezione <a href="https://www.emilgroup.it/collezioni/piastrelle/ergon-medley/" target="_blank"><u><strong>Medley by Ergon</strong></u></a> per aggiungere un tocco distintivo e funzionale.</p>\r\n\r\n<p>Abbiamo intervistato <strong>Anke Stern</strong>, fondatrice di <strong>ankestern interior</strong>, per scoprire di pi&ugrave; sul processo creativo e le sfide affrontate in questo progetto.</p>\r\n\r\n<h2>Qual &egrave; la filosofia che ha ispirato il vostro progetto?</h2>\r\n\r\n<p>La filosofia che ha ispirato il nostro progetto si basa sull&#39;idea di creare uno spazio che unisca design contemporaneo e funzionalit&agrave;, in risposta alle esigenze di una comunit&agrave; dinamica e intergenerazionale. L&#39;obiettivo era offrire una soluzione moderna ma allo stesso tempo pratica. Un aspetto fondamentale &egrave; stata l&#39;integrazione del design dei mobili, come quelli del bar, con il concetto complessivo dello spazio. Il bar diventa il punto focale della stanza, accentuato dal continuo utilizzo dei materiali ceramici Emilgroup che si estendono nell&rsquo;ambiente circostante. Un cambiamento di materiale di fronte al bar definisce chiaramente una zona specifica, migliorandone la funzionalit&agrave;. Inoltre, nella zona della scala, una transizione di materiali segnala la necessit&agrave; di maggiore attenzione, contribuendo a un&#39;esperienza visiva e spaziale pi&ugrave; consapevole.</p>\r\n\r\n<h2>Cosa vi ha entusiasmato di pi&ugrave; di questo progetto?</h2>\r\n\r\n<p>Ci&ograve; che ci ha particolarmente colpito &egrave; stata l&#39;apertura della comunit&agrave; nel voler creare un nuovo centro nevralgico per il paese. Questo spazio ha infatti un carattere urbanizzato e moderno, che ridefinisce il cuore della comunit&agrave; stessa. La partecipazione attiva della gente &egrave; stata un aspetto davvero stimolante per noi.</p>\r\n\r\n<h2>Cosa avete apprezzato di pi&ugrave; di Emilgroup?</h2>\r\n\r\n<p>Abbiamo ricevuto un supporto eccellente durante tutto il processo, a partire dai campioni di materiale fino alle informazioni sui prezzi e alla gestione dei fornitori. In questo modo l&rsquo;utilizzo di un prodotto italiano di qualit&agrave;, che doveva arrivare in Austria e poi in Germania, si &egrave; rivelata la scelta migliore. Il progetto &egrave; stato realizzato puntualmente e nel rispetto del budget, il che &egrave; stato fondamentale per noi e per il nostro cliente. Siamo molto soddisfatti della collaborazione e consigliamo vivamente di lavorare con Emilgroup!</p>\r\n\r\n<p><a href="https://www.emilgroup.it/progetti/city_community_center_a_laubach_un_progetto_che_unisce_design_e_funzionalita/" target="_blank"><u><strong><em>Scopri il progetto.</em></strong></u></a></p>',
  descriptionFooter: null,
  tag: mockCategoriaMagazine((index % 4) + 1).title,
  url: '/',
})

export const mockCategoriaMagazine = (index) => ({
  pk: index,
  title: `Categoria mag ${index}`,
})

export const mockProgettoListing = (index: number) => ({
  pk: index,
  title: 'The Leo Grand: un hotel di lusso nel cuore di Vienna',
  premio:
    'https://www.emilgroup.it/media/filer_public/47/fb/47fbfd88-3ef9-4238-8d30-ebf869ca8905/logo_vincitori_black.png',
  imageUrl:
    'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/BANNER 1725006369_66d18221b4686_0.jpg',
  destinazioni: [
    {
      id: '9',
      titolo: 'Hotel',
      slug: 'hotel',
    },
  ],
  url: '/progetti/the_leo_grand_un_hotel_di_lusso_nel_cuore_di_vienna',
  imageAlt: '',
})

export const progettiListingMock = {
  title: 'Progetti',
  subtitle: '(Sottotitolo eventuale)',
  description:
    '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>',
  suggestions: [
    {
      id: 10,
      modelName: 'collezioni',
      text: 'Metallica',
      url: '/collezioni/brand/emilceramica/metallica',
    },
  ],
  elementi: mockArray(mockProgettoListing, 58),
  attributi: [
    {
      label: 'Brand',
      chiave: 'brand',
      valori: [
        {
          id: 4,
          label: 'Viva',
          valori: null,
        },
        {
          id: 2,
          label: 'Ergon',
          valori: null,
        },
        {
          id: 7,
          label: 'Level',
          valori: null,
        },
        {
          id: 3,
          label: 'Provenza',
          valori: null,
        },
        {
          id: 1,
          label: 'Emilceramica',
          valori: null,
        },
      ],
    },
    {
      label: "Destinazioni d'uso",
      chiave: 'destinazioni',
      valori: [
        { id: 201, label: 'Commerciale', valori: null },
        { id: 202, label: 'Cultura e tempo libero', valori: null },
        { id: 203, label: 'Edifici pubblici e di culto', valori: null },
        { id: 204, label: 'Esterni', valori: null },
        { id: 205, label: 'Hotel', valori: null },
        { id: 206, label: 'Interni ed Esterni', valori: null },
        { id: 207, label: 'Residenziale', valori: null },
        { id: 208, label: 'Ristorazione', valori: null },
        { id: 209, label: 'Salute, benessere e fitness', valori: null },
        { id: 210, label: 'Uffici e industrie', valori: null },
      ],
    },
    {
      label: 'Soluzioni',
      chiave: 'soluzioni',
      valori: [
        { id: 301, label: 'Arredi design', valori: null },
        { id: 302, label: 'Countertop', valori: null },
        { id: 303, label: 'Esterni', valori: null },
        { id: 304, label: 'Facciate ventilate', valori: null },
        { id: 305, label: 'Interni', valori: null },
      ],
    },
    {
      label: 'Emilgroup Project Awards',
      chiave: 'premio',
      valori: [
        { id: 401, label: 'Emilgroup Project Awards 2022', valori: null },
        { id: 402, label: 'Emilgroup Project Awards 2023', valori: null },
        { id: 403, label: 'Emilgroup Project Awards 2024', valori: null },
      ],
    },
  ],
  params: {
    search: '',
    filtri: [],
    ordinamento: null,
    page: 1,
    perPage: null,
    firstPagePerPage: null,
    categoriaSlug: null,
  },
  ordinamenti: [
    {
      label: 'Dal più recente',
      value: 'creation_date',
    },
    {
      label: 'Dalla A alla Z',
      value: 'alphabetic',
    },
    {
      label: 'Dalla Z alla A',
      value: 'reverse_alphabetic',
    },
  ],
  page: 1,
  perPage: 6,
  numPages: 10,
  count: 58,
}

export const mockAreaDownload = [
  {
    name: 'Cataloghi',
    children: [
      {
        brand: {
          id: '3',
          nome: 'Provenza',
          title: 'Provenza',
          slug: 'provenza',
          children: [
            {
              name: 'Collezioni',
              files: [
                {
                  title: 'EPD - Spain Industry Wide',
                  url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
                },
                {
                  title: 'EPD - Spain Industry Wide1',
                  url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
                },
                {
                  title: 'EPD - Spain Industry Wide2',
                  url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
                },
              ],
            },
            {
              name: 'Catalogo Generale',
              files: [
                {
                  title: 'EPD - Spain Industry Wide',
                  url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
                },
                {
                  title: 'EPD - Spain Industry Wide1',
                  url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
                },
              ],
            },
          ],
        },
      },
      {
        brand: {
          id: '1',
          nome: 'Emilceramica',
          title: 'Emilceramica',
          slug: 'emilceramica',
          children: [
            {
              name: 'Collezioni',
              files: [
                {
                  title: 'EPD - Spain Industry Wide',
                  url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
                },
                {
                  title: 'EPD - Spain Industry Wide2',
                  url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
                },
              ],
            },
            {
              name: 'Catalogo Generale',
              files: [
                {
                  title: 'EPD - Spain Industry Wide',
                  url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
                },
                {
                  title: 'EPD - Spain Industry Wide1',
                  url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
                },
              ],
            },
          ],
        },
      },
    ],
  },
  {
    name: 'Certificazioni',
    children: [
      {
        name: 'Collezioni',
        files: [
          {
            title: 'EPD - Spain Industry Wide',
            url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
          },
          {
            title: 'EPD - Spain Industry Wide1',
            url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
          },
          {
            title: 'EPD - Spain Industry Wide2',
            url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
          },
        ],
      },
      {
        name: 'Catalogo Generale',
        files: [
          {
            title: 'EPD - Spain Industry Wide',
            url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
          },
          {
            title: 'EPD - Spain Industry Wide1',
            url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
          },
        ],
      },
    ],
  },
  {
    name: 'Azienda',
    children: [
      {
        name: 'Documenti',
        files: [
          {
            title: 'EPD - Spain Industry Wide',
            url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
          },
          {
            title: 'EPD - Spain Industry Wide1',
            url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
          },
          {
            title: 'EPD - Spain Industry Wide2',
            url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
          },
        ],
      },
      {
        name: 'Condizioni generali di vendita e acquisto',
        files: [
          {
            title: 'EPD - Spain Industry Wide',
            url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
          },
          {
            title: 'EPD - Spain Industry Wide1',
            url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
          },
        ],
      },
    ],
  },
]

export const mockSearchResult = {
  collezioni: [
    {
      title: '20Twenty',
      slug: '20twenty',
      quickship: true,
      novita: true,
      listingImage: {
        id: 37,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_20Twenty_017.jpg',
      },
      brand: {
        nome: 'Emilceramica',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Emil_Bianco_Logo Brand Stiky Menu_365x122_Fondo Trasparente-1.png',
      },
    },
    {
      title: 'Be-Square',
      slug: 'be-square',
      quickship: true,
      novita: false,
      listingImage: {
        id: 4089,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Be-Square Sand 120x278 Amb. Hall.jpg',
      },
      brand: {
        nome: 'Emilceramica',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Emil_Bianco_Logo Brand Stiky Menu_365x122_Fondo Trasparente-1.png',
      },
    },
    {
      title: 'Externa',
      slug: 'externa',
      quickship: false,
      novita: true,
      listingImage: {
        id: 429,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_Externa_016.jpg',
      },
      brand: {
        nome: 'Emilceramica',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Emil_Bianco_Logo Brand Stiky Menu_365x122_Fondo Trasparente-1.png',
      },
    },
    {
      title: 'Millelegni',
      slug: 'millelegni',
      quickship: false,
      novita: false,
      listingImage: {
        id: 1554,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_Millelegni_009.jpg',
      },
      brand: {
        nome: 'Emilceramica',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Emil_Bianco_Logo Brand Stiky Menu_365x122_Fondo Trasparente-1.png',
      },
    },
    {
      title: 'Nordika',
      slug: 'nordika',
      quickship: false,
      novita: false,
      listingImage: {
        id: 784,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_Nordika_011.jpg',
      },
      brand: {
        nome: 'Emilceramica',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Emil_Bianco_Logo Brand Stiky Menu_365x122_Fondo Trasparente-1.png',
      },
    },
    {
      title: 'On Square',
      slug: 'on-square',
      quickship: false,
      novita: false,
      listingImage: {
        id: 2085,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginicollezioni_emil/Emilceramica_ON_SQUARE_004.jpg',
      },
      brand: {
        nome: 'Emilceramica',
        logoTransparent:
          'https://www.emilgroup.it/emil/prodotti/immaginibrand_emil/Emil_Bianco_Logo Brand Stiky Menu_365x122_Fondo Trasparente-1.png',
      },
    },
  ],
  colori: [
    {
      nome: 'Chocolate',
      finitura: 'Dettaglio finitura',
      collezioni: 'Nome collezioni',
      url: '/provenza/unique-travertine/ancient-chocolate',
      image: {
        title: null,
        alt: null,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJTA_ UNIQUE TRAVERTINE ANCIENT CHOCOLATE_30x60_1.jpg',
      },
    },
    {
      nome: 'Cream',
      finitura: 'Dettaglio finitura',
      collezioni: 'Nome collezioni',
      url: '/provenza/unique-travertine/ancient-cream',
      image: {
        title: null,
        alt: null,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ9F_ UNIQUE TRAVERTINE ANCIENT CREAM_30x60_1.jpg',
      },
    },
    {
      nome: 'Silver',
      finitura: 'Dettaglio finitura',
      collezioni: 'Nome collezioni',
      url: '/provenza/unique-travertine/ancient-silver',
      image: {
        title: null,
        alt: null,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ9G_ UNIQUE TRAVERTINE ANCIENT SILVER_30x60_1.jpg',
      },
    },
    {
      nome: 'White',
      finitura: 'Dettaglio finitura',
      collezioni: 'Nome collezioni',
      url: '/provenza/unique-travertine/ancient-white',
      image: {
        title: null,
        alt: null,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ9E_ UNIQUE TRAVERTINE ANCIENT WHITE_30x60_1.jpg',
      },
    },
    {
      nome: 'Chocolate',
      finitura: 'Dettaglio finitura',
      collezioni: 'Nome collezioni',
      url: '/provenza/unique-travertine/minimal-chocolate',
      image: {
        title: null,
        alt: null,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJSY_ UNIQUE TRAVERTINE MINIMAL CHOCOLATE_30x60_1.jpg',
      },
    },
    {
      nome: 'Cream',
      finitura: 'Dettaglio finitura',
      collezioni: 'Nome collezioni',
      url: '/provenza/unique-travertine/minimal-cream',
      image: {
        title: null,
        alt: null,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ8Q_ UNIQUE TRAVERTINE MINIMAL CREAM_30x60_1.jpg',
      },
    },
    {
      nome: 'Silver',
      finitura: 'Dettaglio finitura',
      collezioni: 'Nome collezioni',
      url: '/provenza/unique-travertine/minimal-silver',
      image: {
        title: null,
        alt: null,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ8R_ UNIQUE TRAVERTINE MINIMAL SILVER_30x60_1.jpg',
      },
    },
    {
      nome: 'White',
      finitura: 'Dettaglio finitura',
      collezioni: 'Nome collezioni',
      url: '/provenza/unique-travertine/minimal-white',
      image: {
        title: null,
        alt: null,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ8P_ UNIQUE TRAVERTINE MINIMAL WHITE_30x60_1.jpg',
      },
    },
    {
      nome: 'Chocolate',
      finitura: 'Dettaglio finitura',
      collezioni: 'Nome collezioni',
      url: '/provenza/unique-travertine/ruled-chocolate',
      image: {
        title: null,
        alt: null,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJT4_ UNIQUE TRAVERTINE RULED CHOCOLATE_30x60_CON STRUTTURA_1.jpg',
      },
    },
    {
      nome: 'Cream',
      finitura: 'Dettaglio finitura',
      collezioni: 'Nome collezioni',
      url: '/provenza/unique-travertine/ruled-cream',
      image: {
        title: null,
        alt: null,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ96_ UNIQUE TRAVERTINE RULED CREAM_30x60_CON STRUTTURA_1.jpg',
      },
    },
    {
      nome: 'Silver',
      finitura: 'Dettaglio finitura',
      collezioni: 'Nome collezioni',
      url: '/provenza/unique-travertine/ruled-silver',
      image: {
        title: null,
        alt: null,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ97_ UNIQUE TRAVERTINE RULED SILVER_30x60 CON STRUTTURA_1.jpg',
      },
    },
    {
      nome: 'White',
      finitura: 'Dettaglio finitura',
      collezioni: 'Nome collezioni',
      url: '/provenza/unique-travertine/ruled-white',
      image: {
        title: null,
        alt: null,
        url: 'https://www.emilgroup.it/emil/prodotti/immaginiarticoli_emil/EJ95_UNIQUE TRAVERTINE RULED WHITE_30x60_CON STRUTTURA_1.jpg',
      },
    },
  ],
  download: [
    {
      name: 'EPD - Spain Industry Wide',
      url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
    },
    {
      name: 'EPD - Spain Industry Wide1',
      url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
    },
    {
      name: 'EPD - Spain Industry Wide2',
      url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
    },
    {
      name: 'EPD - Spain Industry Wide',
      url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
    },
    {
      name: 'EPD - Spain Industry Wide1',
      url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
    },
    {
      name: 'EPD - Spain Industry Wide2',
      url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
    },
  ],
  certificazioni: [
    {
      name: 'EPD - Spain Industry Wide',
      url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
    },
    {
      name: 'EPD - Spain Industry Wide1',
      url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
    },
    {
      name: 'EPD - Spain Industry Wide2',
      url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
    },
    {
      name: 'EPD - Spain Industry Wide3',
      url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
    },
    {
      name: 'EPD - Spain Industry Wide4',
      url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
    },
    {
      name: 'EPD - Spain Industry Wide5',
      url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
    },
    {
      name: 'EPD - Spain Industry Wide6',
      url: 'https://www.emilgroup.it/media/filer_public/ec/e0/ece032b1-b14a-4dae-aaba-0c1a0a119c49/iso_50001_emissione_2022_emilceramica.pdf',
    },
  ],
  progetti: [
    {
      title: 'Ristorante Nishiki ',
      premio: null,
      destinazioni: [
        {
          id: '10',
          titolo: 'Ristorazione',
          slug: 'ristorazione',
        },
      ],
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/ristorante-nishiki_gallery-1.jpg',
      url: '/progetti/ristorante_nishiki',
    },
    {
      title: 'Nuova Residenza a Pinerolo',
      premio: null,
      destinazioni: [
        {
          id: '15',
          titolo: 'Residenziale',
          slug: 'residenziale',
        },
      ],
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/1Pinerolo_img_testata.jpg',
      url: '/progetti/nuova_residenza_a_pinerolo',
    },
    {
      title: 'Riserva naturale privata Kapama River Lodge',
      premio: null,
      destinazioni: [
        {
          id: '9',
          titolo: 'Hotel',
          slug: 'hotel',
        },
      ],
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/banner_Kapama progetto.jpg',
      url: '/progetti/riserva_naturale_privata_kapama_river_lodge',
    },
    {
      title: 'Ristorante Nishiki ',
      premio: null,
      destinazioni: [
        {
          id: '10',
          titolo: 'Ristorazione',
          slug: 'ristorazione',
        },
      ],
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/ristorante-nishiki_gallery-1.jpg',
      url: '/progetti/ristorante_nishiki',
    },
    {
      title: 'Un complesso studentesco innovativo e funzionale',
      premio: null,
      destinazioni: [
        {
          id: '14',
          titolo: 'Edifici pubblici e di culto',
          slug: 'edifici_pubblici_e_di_culto',
        },
      ],
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/banner_Niagara College.jpg',
      url: '/progetti/un_complesso_studentesco_innovativo_e_funzionale',
    },
    {
      title: 'Un’esperienza di shopping unica',
      premio: null,
      destinazioni: [
        {
          id: '6',
          titolo: 'Interni ed Esterni',
          slug: 'interni_ed_esterni',
        },
        {
          id: '7',
          titolo: 'Commerciale',
          slug: 'commerciale',
        },
      ],
      imageUrl:
        'https://www.emilgroup.it/emil/referenze/immaginiprogetti_emil/Banner - IMG_8128.jpg',
      url: '/progetti/unesperienza_di_shopping_unica',
    },
  ],
  magazine: [
    {
      pk: 446,
      title: 'Emilgroup @ KBIS 2025',
      pubDate: '2025-02-04T14:39:00+00:00',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/61/c2/61c2ecd7-742a-466a-8185-60af02d88936/website-header.jpg',
      imageAlt: '',
      descriptionHead: null,
      url: '/magazine/emilgroup-kbis-2025',
      tag: 'News & Media',
    },
    {
      pk: 445,
      title: 'Emilgroup @ Artdom 2025',
      pubDate: '2025-02-04T14:37:00+00:00',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/e2/e3/e2e3aaff-d5c8-4e63-b9c5-8053cbe9b932/website-header.jpg',
      imageAlt: '',
      descriptionHead: null,
      url: '/magazine/emilgroup-artdom-2025',
      tag: 'News & Media',
    },
    {
      pk: 444,
      title: 'Emilgroup e Spazi Belli insieme per celebrare il design',
      pubDate: '2025-01-29T10:54:00+00:00',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/06/02/06027190-1f63-4c8a-a892-7ca76624db59/banner_project_image_a5da4749e2.jpeg',
      imageAlt: '',
      descriptionHead: null,
      url: '/magazine/emilgroup-e-spazi-belli-insieme-per-celebrare-il-design',
      tag: 'News & Media',
    },
    {
      pk: 444,
      title: 'Emilgroup e Spazi Belli insieme per celebrare il design',
      pubDate: '2025-01-29T10:54:00+00:00',
      imageUrl:
        'https://www.emilgroup.it/media/filer_public/06/02/06027190-1f63-4c8a-a892-7ca76624db59/banner_project_image_a5da4749e2.jpeg',
      imageAlt: '',
      descriptionHead: null,
      url: '/magazine/emilgroup-e-spazi-belli-insieme-per-celebrare-il-design',
      tag: 'News & Media',
    },
  ],
  pagine: mockArray(mockPagina, 4),
}

export const regioniMocks = [
  { pk: 1, name: 'Abruzzo', slug: 'abruzzo' },
  { pk: 2, name: 'Campania', slug: 'campania' },
  { pk: 3, name: 'Lazio', slug: 'lazio' },
  { pk: 4, name: 'Marche', slug: 'marche' },
  { pk: 5, name: 'Sardegna', slug: 'sardegna' },
  { pk: 6, name: 'Trentino-alto adige', slug: 'trentino-alto-adige' },
  { pk: 7, name: 'Veneto', slug: 'veneto' },
  { pk: 8, name: 'Basilicata', slug: 'basilicata' },
  { pk: 9, name: 'Emilia-romagna', slug: 'emilia-romagna' },
  { pk: 10, name: 'Liguria', slug: 'liguria' },
  { pk: 11, name: 'Piemonte', slug: 'piemonte' },
  { pk: 12, name: 'Sicilia', slug: 'sicilia' },
  { pk: 13, name: 'Umbria', slug: 'umbria' },
  { pk: 14, name: 'Calabria', slug: 'calabria' },
  { pk: 15, name: 'Friulia-venezia giulia', slug: 'friuli-venezia-giulia' },
  { pk: 16, name: 'Lombardia', slug: 'lombardia' },
  { pk: 17, name: 'Puglia', slug: 'puglia' },
  { pk: 18, name: 'Toscana', slug: 'toscana' },
  { pk: 19, name: 'Valle d’aosta', slug: 'valle-d-aosta' },
]

export const mockRivenditore = (index: number) => ({
  pk: index,
  nome: 'Catania - AG.7',
  indirizzo: 'Via C. Battisti, 53',
  cap: '24025',
  citta: 'Gazzaniga',
  provincia: 'Bergamo',
  regione: regioniMocks[index % regioniMocks.length],
  latitudine: 43.592237,
  longitudine: 10.984354,
})

export const mockTecnologia = (index: number) => ({
  pk: index,
  title: 'Tecnologia #' + index,
  listingImage: imgUrl(600), // TODO
  alt: 'tecnologia alt immagine',
  url: '/',
})

export const mockTecnologiaDetail = (index: number) => ({
  ...mockTecnologia(index),
  correlati: mockArray(mockTecnologia, 2),
})
